
import { defineComponent, ref, computed, watch, onMounted } from "vue";
import Dropzone from "dropzone";
import axios from "@/axios-instance"
import Swal from "sweetalert2/dist/sweetalert2.js";
import { useRoute } from "vue-router";
import { emitter } from '@/main';
import Multiselect from "@vueform/multiselect";

import { reinitializeComponents } from "@/core/plugins/keenthemes";
import Permission from "@/core/config/Permission";
import moment from "moment"
import heic2any from "heic2any";
import { statusTagDefault } from "@/components/customers/ProfileDetailInfor.vue";
import { sortByAlphabet } from "@/core/helpers/sortHelpers";

  interface Step3 {
    method: number;
    all10: string;
    all11: string;
    hki12: string;
    all12: string;
    //------
    mathHKII: string;
    physicsHKII: string;
    chemistryHKII: string;
    englishHKII: string;
    frenchHKII: string;
    literatureHKII: string;
    historyHKII: string;
    geographyHKII: string;
    biologicalHKII: string;
    civicEducationHKII: string;
    informationTechnologyHKII: string;
    economicsAndLawEducationHKII: string;

    artHKII: string;
    admissionsIndustry: string;
    admissionsIndustry2: string;
    admissionsIndustry3: string;
    methosIndustry: string;
    methosIndustry2: string;
    methosIndustry3: string;
    //
    mathTHPT: string;
    physicsTHPT: string;
    chemistryTHPT: string;
    englishTHPT: string;
    frenchTHPT: string;
    literatureTHPT: string;
    historyTHPT: string;
    geographyTHPT: string;
    artTHPT: string;
    informationTechnologyTHPT: string;
    economicsAndLawEducationTHPT: string;
    biologicalTHPT: string;
    admissionsIndustryTHPT: string;
    admissionsIndustryTHPT2: string;
    admissionsIndustryTHPT3: string;
    methosIndustryTHPT: string;
    methosIndustryTHPT2: string;
    methosIndustryTHPT3: string;
    //-----------------------
    aptitudeTest: string;
    majorForAptitudeTest: string;
    majorForAptitudeTest2: string;
    majorForAptitudeTest3: string;
    //-----------------------
    majorForUmt: string;
    majorForUmt2: string;
    majorForUmt3: string;
    ielts: string;
    toefl: string;
    toeic: string;
    sat: string;
    satDate: any;
    actScore: string;
    actDate: any;
    formOfMethodMethod5: string;
    tcCriteria: string;
    tc01AverageGrade12: string;
    pt05mathTHPT: string;
    pt05physicsTHPT: string;
    pt05chemistryTHPT: string;
    pt05englishTHPT: string;
    pt05frenchTHPT: string;
    pt05literatureTHPT: string;
    pt05historyTHPT: string;
    pt05geographyTHPT: string;
    pt05artTHPT: string;
    pt05informationTechnologyTHPT: string;
    pt05economicsAndLawEducationTHPT: string;
    pt05biologicalTHPT: string;
    typeIsCert: string;
    status: string;
    source: string;
    createdAt: Date;
    phase: number;
    isActive: boolean;
  }
  interface Step4 {
    files: string[];
   }
interface KTCreateApp extends Step3, Step4 {}

export default defineComponent({
  name: "add-customer-modal",
  emits: ["updateData","closeModal","callbackFunction"],
  props: {
    isEdit: { type: Boolean, default: false },
    isAppraised: { type: Boolean, default: false },
    fromProfile:{ type: Boolean, default: null },
    priorityScore: { type: Number, default: 0 },
    dataAdm: { type: Object, default: null },
    idStudent: {type: String, default: null},
    isAddProfile: { type: Boolean, default: null },
    // Tạo mới hồ sơ LIÊN THÔNG (LTĐHCQ) từ admin: bật form LT ở chế độ tạo (kết hợp is-edit=true).
    articulationCreate: { type: Boolean, default: false },
    dataHighschool: {type: String, default: null},
    orderNumber: {type: String, default: null},
    isInModalAi: { type: Boolean, default: null },
    dataCustomer: {type: Object, default: {}}
  },
  components: {
    Multiselect
  },
  data() {
    return {
      isAdmissionsIndustry: false,
      isAdmissionsIndustryTHPT: false,
      arrPhase: [] as any,
      arrAdmissionMethod: [] as any,
      
      objectScore: {
        mathTHPT: "",
        physicsTHPT: "",
        chemistryTHPT: "",
        englishTHPT: "",
        frenchTHPT: "",
        literatureTHPT: "",
        historyTHPT: "",
        geographyTHPT: "",
        artTHPT: "",
        informationTechnologyTHPT: "",
        economicsAndLawEducationTHPT: "",
        biologicalTHPT: "",
      }
    }
  },
  computed: {
    allArrMethosIndustry () {
      let admissionsIndustry = this.formData.admissionsIndustry
      let tempMajors = this.arrMajors as any//[{code:string[], value:string,label:string}]
      // get array tổ hợp xét tuyển
      let arrCode = tempMajors.filter(i =>i.value == admissionsIndustry)[0]?.code 
      // console.log('arrCode',arrCode)
      //temp filter value và label nhũng tổ hợp của từng môn dc chọn
      let temp:{ value: string, label: string, code: string }[] = arrCode ? this.arrIndustry.filter(i=>arrCode?.includes(i.value)) : this.arrIndustry
      // console.log('temptemptemp',temp)
   
      let arr: Array<string> = []
      //add điểm !0 vào từng tổ hợp (full)
      this.arrGPAIndustry.forEach(item => {
        // console.log('item',item)
        if(item.value != 0)
          arr.push(item.code)
      })
      // console.log('arrarrarrarr',arr)
      //lấy ra những tổ hợp có điểm
      let obj = temp.filter(item => !['5HK','3YS','9CR'].includes(item.code))
      if( obj.length != 0) {
        this.setIsAdmissionsIndustry(true)
        if(admissionsIndustry) {
          // console.log('call this')
          // this.admissionsIndustryChange(admissionsIndustry)
        }
      }
      else {

        //this.setIsAdmissionsIndustry(false)
      }
      // console.log('objobjobj',obj)
      return obj
    },
    allArrMethosIndustry2 () {
      let admissionsIndustry = this.formData.admissionsIndustry2
      let tempMajors = this.arrMajors as any//[{code:string[], value:string,label:string}]
      // get array tổ hợp xét tuyển
      let arrCode = tempMajors.filter(i =>i.value == admissionsIndustry)[0]?.code 
      // console.log('arrCode',arrCode)
      //temp filter value và label nhũng tổ hợp của từng môn dc chọn
      let temp:{ value: string, label: string, code: string }[] = arrCode ? this.arrIndustry.filter(i=>arrCode?.includes(i.value)) : this.arrIndustry
      // console.log('temptemptemp',temp)
   
      let arr: Array<string> = []
      //add điểm !0 vào từng tổ hợp (full)
      this.arrGPAIndustry.forEach(item => {
        // console.log('item',item)
        if(item.value != 0)
          arr.push(item.code)
      })
      // console.log('arrarrarrarr',arr)
      //lấy ra những tổ hợp có điểm
      let obj = temp.filter(item => !['5HK','3YS','9CR'].includes(item.code))
      if( obj.length != 0) {
        this.setIsAdmissionsIndustry(true)
        if(admissionsIndustry) {
          // this.admissionsIndustryChange2(admissionsIndustry)
        }
      }
      else {

        //this.setIsAdmissionsIndustry(false)
      }
      // console.log('objobjobj',obj)
      return obj
    },
    allArrMethosIndustry3 () {
      let admissionsIndustry = this.formData.admissionsIndustry3
      let tempMajors = this.arrMajors as any //[{code:string[], value:string,label:string}]
      // get array tổ hợp xét tuyển
      let arrCode = tempMajors.filter(i =>i.value == admissionsIndustry)[0]?.code 
      // console.log('arrCode',arrCode)
      //temp filter value và label nhũng tổ hợp của từng môn dc chọn
      let temp:{ value: string, label: string, code: string }[] = arrCode ? this.arrIndustry.filter(i=>arrCode?.includes(i.value)) : this.arrIndustry
      // console.log('temptemptemp',temp)
   
      let arr: Array<string> = []
      //add điểm !0 vào từng tổ hợp (full)
      this.arrGPAIndustry.forEach(item => {
        // console.log('item',item)
        if(item.value != 0)
          arr.push(item.code)
      })
      // console.log('arrarrarrarr',arr)
      //lấy ra những tổ hợp có điểm
      let obj = temp.filter(item => !['5HK','3YS','9CR'].includes(item.code))
      if( obj.length != 0) {
        this.setIsAdmissionsIndustry(true)
        if(admissionsIndustry) {
          // this.admissionsIndustryChange3(admissionsIndustry)
        }
      }
      else {

        //this.setIsAdmissionsIndustry(false)
      }
      // console.log('objobjobj',obj)
      return obj
    },
    arrMethosIndustryTHPT() {
      let admissionsIndustry = this.formData.admissionsIndustryTHPT
      let tempMajors = this.arrMajors
      // get array tổ hợp xét tuyển
      let tempCode = tempMajors.filter(i =>i.value == admissionsIndustry)
      let arrCode = undefined as any
      if(tempCode.length!=0) {
        arrCode = tempCode[0].code 
      }
      //temp filter value và label nhũng tổ hợp của từng môn dc chọn
      let temp:{ value: string, label: string }[] = arrCode ? this.arrIndustry.filter(i=>arrCode?.includes(i.value)) : this.arrIndustry
   
      let arr: Array<string> = []
      //add điểm !0 vào từng tổ hợp (full)
      this.arrGPAIndustryTHPT.forEach(item => {
        if(item.value != 0)
          arr.push(item.code)
      })
      //lấy ra những tổ hợp có điểm
      let obj = temp.filter(item => arr.includes(item.value))
      if( obj.length != 0) {
        this.setIsAdmissionsIndustryTHPT(true)
        
      }
      else {
        //this.setIsAdmissionsIndustry(false)
      }
      return obj
    },
    arrMethosIndustryTHPT2() {
      let admissionsIndustry = this.formData.admissionsIndustryTHPT2
      let tempMajors = this.arrMajors
      // get array tổ hợp xét tuyển
      let tempCode = tempMajors.filter(i =>i.value == admissionsIndustry)
      let arrCode = undefined as any
      if(tempCode.length!=0) {
        arrCode = tempCode[0].code 
      }
      //temp filter value và label nhũng tổ hợp của từng môn dc chọn
      let temp:{ value: string, label: string }[] = arrCode ? this.arrIndustry.filter(i=>arrCode?.includes(i.value)) : this.arrIndustry
   
      let arr: Array<string> = []
      //add điểm !0 vào từng tổ hợp (full)
      this.arrGPAIndustryTHPT.forEach(item => {
        if(item.value != 0)
          arr.push(item.code)
      })
      //lấy ra những tổ hợp có điểm
      let obj = temp.filter(item => arr.includes(item.value))
      if( obj.length != 0) {
        this.setIsAdmissionsIndustryTHPT(true)
        
      }
      else {
        //this.setIsAdmissionsIndustry(false)
      }
      return obj
    },
    arrMethosIndustryTHPT3() {
      let admissionsIndustry = this.formData.admissionsIndustryTHPT3
      let tempMajors = this.arrMajors
      // get array tổ hợp xét tuyển
      let tempCode = tempMajors.filter(i =>i.value == admissionsIndustry)
      let arrCode = undefined as any
      if(tempCode.length!=0) {
        arrCode = tempCode[0].code 
      }
      //temp filter value và label nhũng tổ hợp của từng môn dc chọn
      let temp:{ value: string, label: string }[] = arrCode ? this.arrIndustry.filter(i=>arrCode?.includes(i.value)) : this.arrIndustry
   
      let arr: Array<string> = []
      //add điểm !0 vào từng tổ hợp (full)
      this.arrGPAIndustryTHPT.forEach(item => {
        if(item.value != 0)
          arr.push(item.code)
      })
      //lấy ra những tổ hợp có điểm
      let obj = temp.filter(item => arr.includes(item.value))
      if( obj.length != 0) {
        this.setIsAdmissionsIndustryTHPT(true)
       
      }
      else {
        //this.setIsAdmissionsIndustry(false)
      }
      return obj
    },
    arrMethosIndustry() {
      let admissionsIndustry = this.formData.admissionsIndustry
      let tempMajors = this.arrMajors as any
      // get array tổ hợp xét tuyển
      let tempCode = tempMajors.filter(i =>i.value == admissionsIndustry)
      let arrCode = undefined as any
      if(tempCode.length!=0) {
        arrCode = tempCode[0].code 
      }
      //temp filter value và label nhũng tổ hợp của từng môn dc chọn
      let temp:{ value: string, label: string }[] = arrCode ? this.arrIndustry.filter(i=>arrCode?.includes(i.value)) : this.arrIndustry
   
      let arr: Array<string> = []
      //add điểm !0 vào từng tổ hợp (full)
      this.arrGPAIndustry.forEach(item => {
        if(item.value != 0)
          arr.push(item.code)
      })
      //lấy ra những tổ hợp có điểm
      let obj = temp.filter(item => arr.includes(item.value))
      if(this.formData.formOfMethod == 'THM') {
        obj = obj.filter(item => !['5HK','3YS','9CR'].includes(item.value))
      }
      else if(this.formData.formOfMethod == '3YS') {
        obj = obj.filter(item => ['3YS'].includes(item.value))
      }

      if( obj.length != 0) {
        this.setIsAdmissionsIndustry(true)
        
      }
      else {
        //this.setIsAdmissionsIndustry(false)
      }
      return obj
    },
    arrMethosIndustry2() {
      let admissionsIndustry = this.formData.admissionsIndustry2

      let tempMajors = this.arrMajors
      let tempCode = tempMajors.filter(i =>i.value == admissionsIndustry)
      let arrCode = undefined as any
      if(tempCode.length!=0) {
        arrCode = tempCode[0].code 
      }
      //filter value và label nhũng tổ hợp của từng môn
      let temp:{ value: string, label: string }[] = arrCode ? this.arrIndustry.filter(i=>arrCode?.includes(i.value)) : this.arrIndustry
      let arr: Array<string> = []
      this.arrGPAIndustry.forEach(item => {
        if(item.value != 0)
          arr.push(item.code)
      })
      let obj = temp.filter(item => arr.includes(item.value))
      if(this.formData.formOfMethod == 'THM') {
        obj = obj.filter(item => !['5HK','3YS','9CR'].includes(item.value))
      }
      else if(this.formData.formOfMethod == '3YS') {
        obj = obj.filter(item => ['3YS'].includes(item.value))
      }
      // if(admissionsIndustry) {
      //   this.admissionsIndustryChange2(admissionsIndustry)
      // }
      return obj
    },
    arrMethosIndustry3() {
      let admissionsIndustry = this.formData.admissionsIndustry3

      let tempMajors = this.arrMajors 
      // let arrCode = tempMajors.filter(i =>i.value == admissionsIndustry)[0]?.code 
      // get array tổ hợp xét tuyển
      let tempCode = tempMajors.filter(i =>i.value == admissionsIndustry)
      let arrCode = undefined as any
      if(tempCode.length!=0) {
        arrCode = tempCode[0].code 
      }
      //filter value và label nhũng tổ hợp của từng môn
      let temp:{ value: string, label: string }[] = arrCode ? this.arrIndustry.filter(i=>arrCode?.includes(i.value)) : this.arrIndustry
      let arr: Array<string> = []
      this.arrGPAIndustry.forEach(item => {
        if(item.value != 0)
          arr.push(item.code)
      })
      let obj = temp.filter(item => arr.includes(item.value))
      if(this.formData.formOfMethod == 'THM') {
        obj = obj.filter(item => !['5HK','3YS','9CR'].includes(item.value))
      }
      else if(this.formData.formOfMethod == '3YS') {
        obj = obj.filter(item => ['3YS'].includes(item.value))
      }
      // if(admissionsIndustry) {
      //   this.admissionsIndustryChange3(admissionsIndustry)
      // }
      return obj
    },
    // PT5: tiêu chí SAT/ACT (dùng để bố trí Ngành đăng ký thành 3 cột; TC01 giữ layout xếp hàng dọc)
    pt5IsSatAct() {
      return ['SAT', 'ACT'].includes(this.formData.formOfMethodMethod5);
    },
    englishCertResult() {
      const type = this.formData.englishCertType;
      const score = +this.formData.englishCertScore;
      const date = this.formData.englishCertDate;
      const hasCert = this.formData.hasEnglishCert;

      if (!hasCert || !type) return { convertedScore: 0, bonusPoints: 0, valid: false };

      let scoreValid = false;
      if (type === 'TOEIC') {
        const lr = +this.formData.toeicLRScore;
        const sw = +this.formData.toeicSWScore;
        if (lr > 0 || sw > 0) scoreValid = true;
      } else if (score > 0) {
        scoreValid = true;
      }
      if (!scoreValid) return { convertedScore: 0, bonusPoints: 0, valid: false };

      let valid = true;
      if (date) {
        const expiryDate = new Date(date);
        const limitDate = new Date('2026-10-30');
        if (expiryDate < limitDate) valid = false;
      }
      if (!valid) return { convertedScore: 0, bonusPoints: 0, valid: false };

      let convertedScore = 0;
      if (type === 'IELTS') {
        if (score >= 7.0) convertedScore = 10.0;
        else if (score >= 6.5) convertedScore = 9.5;
        else if (score >= 6.0) convertedScore = 9.0;
        else if (score >= 5.5) convertedScore = 8.0;
        else if (score >= 5.0) convertedScore = 7.0;
        else if (score >= 4.5) convertedScore = 6.0;
        else if (score >= 4.0) convertedScore = 5.0;
      } else if (type === 'TOEIC') {
        const lr = +this.formData.toeicLRScore;
        const sw = +this.formData.toeicSWScore;
        let lrConverted = 0;
        if (lr >= 835) lrConverted = 10.0;
        else if (lr >= 785) lrConverted = 9.5;
        else if (lr >= 685) lrConverted = 9.0;
        else if (lr >= 570) lrConverted = 8.0;
        else if (lr >= 450) lrConverted = 7.0;
        else if (lr >= 365) lrConverted = 6.0;
        else if (lr >= 340) lrConverted = 5.0;
        let swConverted = 0;
        if (sw >= 312) swConverted = 10.0;
        else if (sw >= 292) swConverted = 9.5;
        else if (sw >= 262) swConverted = 9.0;
        else if (sw >= 242) swConverted = 8.0;
        else if (sw >= 232) swConverted = 7.0;
        else if (sw >= 202) swConverted = 6.0;
        else if (sw >= 180) swConverted = 5.0;
        convertedScore = Math.min(lrConverted, swConverted);
      } else if (type === 'TOEFL iBT') {
        if (score >= 5.5) convertedScore = 10.0;
        else if (score >= 5.0) convertedScore = 9.5;
        else if (score >= 4.5) convertedScore = 9.0;
        else if (score >= 4.0) convertedScore = 8.0;
        else if (score >= 3.5) convertedScore = 7.0;
        else if (score >= 3.0) convertedScore = 6.0;
        else if (score >= 2.5) convertedScore = 5.0;
      } else if (type === 'PTE') {
        if (score >= 63) convertedScore = 10.0;
        else if (score >= 55) convertedScore = 9.5;
        else if (score >= 47) convertedScore = 9.0;
        else if (score >= 39) convertedScore = 8.0;
        else if (score >= 31) convertedScore = 7.0;
        else if (score >= 24) convertedScore = 6.0;
        else if (score >= 20) convertedScore = 5.0;
      }
      return { convertedScore, bonusPoints: 0, valid: true };
    },
    certIncentiveResult() {
      const limitBonus = 1.5;
      const limitDate = new Date('2026-10-30');
      const isValidDate = (dateStr) => {
        if (!dateStr) return true;
        return new Date(dateStr) >= limitDate;
      };
      const getBonus = (excludeEnglish = false) => {
        let maxBonus = 0;
        if (!excludeEnglish && this.formData.hasEnglishCert) {
          const type = this.formData.englishCertType;
          const score = +this.formData.englishCertScore;
          const date = this.formData.englishCertDate;
          if (isValidDate(date)) {
            let englishBonus = 0;
            if (type === 'IELTS') {
              if (score >= 7.0) englishBonus = 1.5;
              else if (score >= 6.0) englishBonus = 1.0;
              else if (score >= 5.0) englishBonus = 0.5;
            } else if (type === 'TOEIC') {
              const lr = +this.formData.toeicLRScore;
              const sw = +this.formData.toeicSWScore;
              let lrLevel = lr >= 835 ? 1.5 : (lr >= 700 ? 1.0 : (lr >= 480 ? 0.5 : 0));
              let swLevel = sw >= 312 ? 1.5 : (sw >= 262 ? 1.0 : (sw >= 232 ? 0.5 : 0));
              englishBonus = Math.min(lrLevel, swLevel);
            } else if (type === 'TOEFL iBT') {
              if (score >= 5.0) englishBonus = 1.5;
              else if (score >= 4.0) englishBonus = 1.0;
              else if (score >= 3.0) englishBonus = 0.5;
            }
            maxBonus = Math.max(maxBonus, englishBonus);
          }
        }
        if (!excludeEnglish && this.formData.hasIncentiveOther) {
          if (this.formData.vstepLevel) {
            let b = this.formData.vstepLevel === 'Bậc 5(C1)' ? 1.5 : (this.formData.vstepLevel === 'Bậc 4' ? 1.0 : 0.5);
            maxBonus = Math.max(maxBonus, b);
          }
          if (this.formData.aptisLevel) {
            let b = this.formData.aptisLevel === 'C1' ? 1.5 : (this.formData.aptisLevel === 'B2' ? 1.0 : 0.5);
            maxBonus = Math.max(maxBonus, b);
          }
        }
        if (this.formData.hasIncentiveOther) {
          const word = +this.formData.mosWordScore;
          const excel = +this.formData.mosExcelScore;
          const ppt = +this.formData.mosPPTScore;
          if (word >= 700 && excel >= 700 && ppt >= 700) {
            const minScore = Math.min(word, excel, ppt);
            let mosBonus = minScore >= 900 ? 1.5 : (minScore >= 800 ? 1.0 : 0.5);
            maxBonus = Math.max(maxBonus, mosBonus);
          }
          if (this.formData.jlptLevel) {
            let b = this.formData.jlptLevel === 'N2' ? 1.5 : (this.formData.jlptLevel === 'N3' ? 1.0 : 0.5);
            maxBonus = Math.max(maxBonus, b);
          }
          if (this.formData.hskLevel) {
            let b = this.formData.hskLevel === 'HSK 5' ? 1.5 : (this.formData.hskLevel === 'HSK 4' ? 1.0 : 0.5);
            maxBonus = Math.max(maxBonus, b);
          }
          if (this.formData.topikLevel) {
            let b = this.formData.topikLevel === 'C1' ? 1.5 : (this.formData.topikLevel === 'B2' ? 1.0 : 0.5);
            maxBonus = Math.max(maxBonus, b);
          }
          if (this.formData.delfTcfLevel) {
            let b = this.formData.delfTcfLevel === 'C1' ? 1.5 : (this.formData.delfTcfLevel === 'B2' ? 1.0 : 0.5);
            maxBonus = Math.max(maxBonus, b);
          }
          if (this.formData.hasOtherCert && this.formData.otherIntCertType) {
            maxBonus = Math.max(maxBonus, 1.5);
          }
        }
        return Math.min(maxBonus, limitBonus);
      };
      return { total: getBonus(false), excludeEnglish: getBonus(true) };
    },
  },
  methods: {
    // Kiểm tra tổ hợp có môn Tiếng Anh không
    isEnglishInCombo(comboCode: string): boolean {
      const englishCombos = ['A01','B08','D01','D07','D08','D09','D10','D11','D12','D13','D14','D15','D66','D84','D96'];
      return englishCombos.includes(comboCode);
    },
    // Tính tổng điểm theo Exclusion Rule (giống calculateBestTotal ở public)
    calcBestForCombo(baseGPA: number, comboCode: string, actualEnglish: number): { total: number, incentive: number, priority: number } {
      const convRes = this.englishCertResult;
      const incentivePoints = this.certIncentiveResult;
      const isEnglishInCombo = this.isEnglishInCombo(comboCode);

      if (!convRes.valid || baseGPA <= 0) {
        // Không có cert hợp lệ → dùng full incentive
        const incentive = incentivePoints.total;
        const priority = this.cacuPointPriority(baseGPA + incentive);
        return { total: +(baseGPA + incentive + priority).toFixed(2), incentive, priority };
      }

      // Option 1: Dùng cert để quy đổi điểm Tiếng Anh (nếu combo có TA)
      const sum1 = isEnglishInCombo ? +(baseGPA - actualEnglish + convRes.convertedScore).toFixed(2) : baseGPA;
      const incentive1 = incentivePoints.excludeEnglish; // không tính bonus từ English cert
      const priority1 = this.cacuPointPriority(sum1 + incentive1);
      const total1 = +(sum1 + incentive1 + priority1).toFixed(2);

      // Option 2: Không dùng cert quy đổi → dùng full incentive (kể cả English cert bonus)
      const sum2 = baseGPA;
      const incentive2 = incentivePoints.total;
      const priority2 = this.cacuPointPriority(sum2 + incentive2);
      const total2 = +(sum2 + incentive2 + priority2).toFixed(2);

      if (total1 >= total2) {
        return { total: total1, incentive: incentive1, priority: priority1 };
      } else {
        return { total: total2, incentive: incentive2, priority: priority2 };
      }
    },
    // Lấy điểm Tiếng Anh thực tế từ formData theo phương thức (THPT hoặc Học bạ)
    getActualEnglishScore(method: number): number {
      if (method === 4) return +(this.formData.englishTHPT || 0);
      if (method === 1) return +(this.formData.englishHKII || 0);
      if (method === 5) return +(this.formData.pt05englishTHPT || 0);
      return 0;
    },
    // Hàm helper trung tâm để tính toán kết quả tốt nhất từ dữ liệu thô trong formData
    handleEnglishCertTypeChange() {
      this.formData.englishCertScore = '';
      this.formData.toeicLRScore = '';
      this.formData.toeicSWScore = '';
    },
    async autofillAddress(value) {
      if(value) {
        //Địa chỉ 2 cấp: copy danh sách Xã từ Tỉnh rồi gán Xã giống hộ khẩu
        this.formData_arp.student.contactProvinceId = this.formData_arp.student.prProvinceId
        this.dataWard = await this.getWard(this.formData_arp.student.contactProvinceId)
        this.formData_arp.student.contactWardId = this.formData_arp.student.prWardId
        this.formData_arp.student.contactAddress = this.formData_arp.student.prAddress
      }
    },
    async provinceChange(id:string) {
      //Địa chỉ 2 cấp (sáp nhập 2025): nạp Xã/Phường trực tiếp từ Tỉnh, bỏ cấp Huyện
      this.dataWard = []
      if(this.formData_arp.student.contactWardId != "") {
        this.formData_arp.student.contactWardId = ""
      }
      this.dataWard = await this.getWard(id)
    },
    async districtChange(id:string) {
      //Giữ lại cho tương thích; địa chỉ 2 cấp không còn dùng cấp Huyện
    },

    async residenceProvinceChange(id:string) {
      //Địa chỉ 2 cấp (sáp nhập 2025): nạp Xã/Phường trực tiếp từ Tỉnh, bỏ cấp Huyện
      this.dataResidenceWard = []
      if(this.formData_arp.student.prWardId != "") {
        this.formData_arp.student.prWardId = ""
      }
      this.dataResidenceWard = await this.getWard(id)
    },
    async residenceDistrictChange(id:string) {
      //Giữ lại cho tương thích; địa chỉ 2 cấp không còn dùng cấp Huyện
    },
    
    funcResetPoint() {
      this.formData = {
        ...this.formData,
        methosIndustry: "",
        methosIndustry2: "",
        methosIndustry3: "",
        methosIndustryTHPT: "",
        methosIndustryTHPT2: "",
        methosIndustryTHPT3: "",
      }
    },
    funcChangeFormofMethod(e) {
        this.funcResetPoint()
        this.formData.subjectpoint = JSON.parse(JSON.stringify(this.subjectpoint))
        this.formData.subjectpoint2 = JSON.parse(JSON.stringify(this.subjectpoint))
        this.formData.subjectpoint3 = JSON.parse(JSON.stringify(this.subjectpoint))
    },
    funcChangeMethod(e) {
      this.funcResetPoint()
      let obj = {
        5: "PT05",
        4: "THPT",  
        3: "UMT",  
        2: "NLQG",
        1: "THM",
      }
      this.formData.formOfMethod = obj[e]
      if (this.formData.method == 5) {
        this.formData.formOfMethodMethod5 = 'SAT'
      }
      if(this.formData.method == 1) {
        // Học bạ: tự chọn option đầu tiên của hình thức xét (formOptions hiện chỉ còn 1 option khả dụng)
        this.formData.formOfMethod = this.formOptions[0]?.value || obj[1]
        this.formData.subjectpoint = JSON.parse(JSON.stringify(this.subjectpoint))
        this.formData.subjectpoint2 = JSON.parse(JSON.stringify(this.subjectpoint))
        this.formData.subjectpoint3 = JSON.parse(JSON.stringify(this.subjectpoint))
      }
    },
    //checkPoint ("Tra cứu điểm thi") đã GỠ: gọi API giaoducthoidai với nam=2022 hardcode — lỗi thời;
    //đối chiếu điểm giờ dựa vào Bảng điểm thi TN THPT (students.graduationscore) + banner lệch điểm
    acticonSelect(){
    },
    onSelectTag(record) {
      axios.put(`/admission/file/${record.id}`,{
        label: record.select
      })
    },
    getTypeFile(type) {
      let dotFile = 'folder-document'
      if(!type) {
        return dotFile
      }
      if(type.indexOf('image') != -1) {
        dotFile = 'image'
      }
      else if(type.indexOf('pdf') != -1) {
        dotFile = 'pdf'
      }
      else if(type.indexOf('msword') != -1 || type.indexOf('wordprocessingml.document') != -1) {
        dotFile = 'doc'
      }
      else if(type.indexOf('excel') != -1 || type.indexOf('spreadsheetml.sheet') != -1) {
        dotFile = 'excel'
      }
      else if(type.indexOf('zip') != -1 || type.indexOf('compressed') != -1) {
        dotFile = 'zip'
      }
      else {
        dotFile = 'folder-document'
      }
      return dotFile
    },
    hiddenModal() {
      this.$emit('closeModal')
    },
    async deleteFile(record) {
      const confirm = await Swal.fire({
        title: 'Xóa tệp đính kèm?',
        text: 'Tệp sẽ bị gỡ NGAY khỏi hồ sơ (không cần bấm "Lưu hồ sơ"). Thao tác không thể hoàn tác.',
        icon: 'warning',
        showCancelButton: true,
        buttonsStyling: false,
        confirmButtonText: 'Xóa ngay',
        cancelButtonText: 'Hủy',
        customClass: { confirmButton: 'btn btn-danger', cancelButton: 'btn btn-light' },
      })
      if (!confirm.isConfirmed) return
      await axios.delete(`/admission/file/${record.file?.name}`)
      let index = this.tableData.findIndex(item=> item.id == record.id)
      this.tableData.splice(index, 1)
    },
    typeIsCertChange() {
      this.formData.majorForUmt = ""
      this.formData.majorForUmt2 = ""
      this.formData.majorForUmt3 = ""
    },
    resetValuesPt05() {
      this.formData.sat = "";
      this.formData.satDate = null;
      this.formData.actDate = null;
      if (this.formData.formOfMethodMethod5 === 'TC01') {
        this.formData.tcCriteria = "1";
      } else {
        this.formData.tcCriteria = "";
      }
      this.resetValuesTcCriteria();
      this.formData.admissionsIndustryTHPT = "";
      this.formData.admissionsIndustryTHPT2 = "";
      this.formData.admissionsIndustryTHPT3 = "";
      this.formData.methosIndustryTHPT = "";
      this.formData.methosIndustryTHPT2 = "";
      this.formData.methosIndustryTHPT3 = "";
      this.userSelectTHPT = false;
    },
    resetValuesTcCriteria() {
      // Đặt cờ khóa auto-selection
      this.userSelectTHPT = true;

      // Reset dữ liệu ngay lập tức
      const subjects = [
        "mathTHPT", "physicsTHPT", "chemistryTHPT", "englishTHPT",
        "frenchTHPT", "literatureTHPT", "historyTHPT", "geographyTHPT",
        "biologicalTHPT", "informationTechnologyTHPT", "artTHPT", 
        "economicsAndLawEducationTHPT"
      ];
      subjects.forEach(s => {
        this.formData['pt05' + s] = "";
      });
      this.formData.tc01AverageGrade12 = "";
      
      this.formData.admissionsIndustryTHPT = null;
      this.formData.admissionsIndustryTHPT2 = null;
      this.formData.admissionsIndustryTHPT3 = null;
      this.formData.methosIndustryTHPT = null;
      this.formData.methosIndustryTHPT2 = null;
      this.formData.methosIndustryTHPT3 = null;
      
      this.userSelectTHPT = false;
    },
    majorForUmtChange(value) {
      if(this.formData.majorForUmt2 == value) {
        this.formData.majorForUmt2 = ""
      }
      if(this.formData.majorForUmt3 == value) {
        this.formData.majorForUmt3 = ""
      }
    },
    majorForUmtChange2(value) {
      if(this.formData.majorForUmt3 == value) {
        this.formData.majorForUmt3 = ""
      }
    },
    majorForAptitudeTestChange(value) {
      if(this.formData.majorForAptitudeTest2 == value) {
        this.formData.majorForAptitudeTest2 = ""
      }
      if(this.formData.majorForAptitudeTest3 == value) {
        this.formData.majorForAptitudeTest3 = ""
      }
    },
    majorForAptitudeTestChange2(value) {
      if(this.formData.majorForAptitudeTest3 == value) {
        this.formData.majorForAptitudeTest3 = ""
      }
    },
    setIsAdmissionsIndustry(value) {
        this.isAdmissionsIndustry = value
        if(!this.isAdmissionsIndustry) {
          this.formData.admissionsIndustry = ""
          this.formData.admissionsIndustry2 = ""
          this.formData.admissionsIndustry3 = ""
        }
    },
    setIsAdmissionsIndustryTHPT(value) {
        this.isAdmissionsIndustryTHPT = value
        if(!this.isAdmissionsIndustryTHPT) {
          this.formData.admissionsIndustryTHPT = ""
          this.formData.admissionsIndustryTHPT2 = ""
          this.formData.admissionsIndustryTHPT3 = ""
        }
    },
    isNumber: function(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },
    admissionsIndustryChange(event:string) {
      // console.log('admissionsIndustryChange1',event,)
      if(this.formData.admissionsIndustry2 == event) {
        this.formData.admissionsIndustry2 = ""
        this.formData.methosIndustry2 = ""
      }
      if (this.formData.admissionsIndustry3 == event) {
        this.formData.admissionsIndustry3 = ""
        this.formData.methosIndustry3 = ""
      }
      if(this.arrMajors.length != 0 && event) {
        let maxGPA  = this.maxGPAIndustry(event)
        let value = maxGPA ? maxGPA.code : undefined
        this.formData.methosIndustry = value ? value : ""
      }
      if(!event ) {
        this.formData.methosIndustry = ""
      }
      // Khi phương thức 9CR: gọi methosIndustryAutoChange để fill adForm/type/label
      // Chỉ gọi khi combo được chọn (không rỗng) để tránh reset dữ liệu ngành
      if(this.formData.formOfMethod == '9CR' && this.formData.methosIndustry) {
        this.methosIndustryAutoChange(this.formData.methosIndustry)
      }
    },
    admissionsIndustryChangeTHPT(event:string) {
      // console.log('admissionsIndustryChange1')
      if(this.formData.admissionsIndustryTHPT2 == event) {
        this.formData.admissionsIndustryTHPT2 = ""
        this.formData.methosIndustryTHPT2 = ""
      }
      if (this.formData.admissionsIndustryTHPT3 == event) {
        this.formData.admissionsIndustryTHPT3 = ""
        this.formData.methosIndustryTHPT3 = ""
      }
      if(this.arrMajors.length != 0 && event) {
        let maxGPA  = this.maxGPAIndustryTHPT(event)
        let value = maxGPA ? maxGPA.code : undefined
        this.formData.methosIndustryTHPT = value ? value : ""
      }
      if(!event ) {
        this.formData.methosIndustryTHPT = ""
      }
    },
    methosIndustryAutoChange(event, number?: any) {
      if(this.formData.formOfMethod == '9CR') {
        const resetDataPoint = {
          point0: '',
          point1: '',
          point2: '',
        }
        const emptySlot = () => ({
          adForm: '',
          type: '',
          label: '',
          data: JSON.parse(JSON.stringify(resetDataPoint))
        })

        // Xác định key của subjectpoint tương ứng với ngành 1, 2, 3
        const targetKey = !number ? 'subjectpoint' : (number == '2' ? 'subjectpoint2' : 'subjectpoint3')
        const otherKeys = ['subjectpoint', 'subjectpoint2', 'subjectpoint3'].filter(k => k !== targetKey)

        // Nếu không có event (xóa chọn tổ hợp), reset subjectpoint của ngành đó
        if (!event) {
          this.formData[targetKey] = [emptySlot(), emptySlot(), emptySlot()]
          if(number && number == '2') {
            this.formData.methosIndustry3 = ""
            this.formData.admissionsIndustry3 = ""
          }
          if(number) {
            this.formData[`admissionsIndustry${number}`] = ""
          }
          return
        }

        const temp = this.renderSubject(event)

        // Guard: temp phải là mảng hợp lệ mới tiến hành gán dữ liệu
        if (!Array.isArray(temp) || temp.length === 0) return

        // Reset slots trước khi gán mới (tránh dữ liệu cũ còn sót lại)
        this.formData[targetKey] = [emptySlot(), emptySlot(), emptySlot()]

        temp.forEach((subjectType, index) => {
          if (index >= this.formData[targetKey].length) return

          // Điền đầy đủ adForm, type, label cho mỗi môn trong tổ hợp
          this.formData[targetKey][index].adForm = '9CR'
          this.formData[targetKey][index].type = subjectType
          this.formData[targetKey][index].label = this.renderTitleSubject(subjectType)

          // Tái sử dụng data điểm từ các ngành khác nếu cùng môn
          let record: any = null
          for (const k of otherKeys) {
            const found = this.formData[k]?.find((f: any) => f.type == subjectType)
            if (found) { record = found; break }
          }
          this.formData[targetKey][index].data = record
            ? JSON.parse(JSON.stringify(record.data))
            : JSON.parse(JSON.stringify(resetDataPoint))
        })
        this.userSelect = false
      }
    },
    methosIndustryAutoChangeTHPT() {
      this.userSelectTHPT = false
      //user thật sự sửa ô điểm THPT trong phiên -> mở gate write-back về students.graduationscore khi Lưu (PT1)
      this.gradScoreDirty = true
    },
    admissionsIndustryChangeTHPT2(event:string) {
      if (this.formData.admissionsIndustryTHPT3 == event) {
        this.formData.admissionsIndustryTHPT3 = ""
        this.formData.methosIndustryTHPT3 = ""
      }
      if(this.arrMajorsTHPT2.length != 0  && event) {
        let maxGPA  = this.maxGPAIndustryTHPT(event)
        let value = maxGPA ? maxGPA.code : undefined
        this.formData.methosIndustryTHPT2 = value ? value : ""
      }
      if(!event ) {
        this.formData.methosIndustryTHPT2 = ""
      }
    },
    admissionsIndustryChange2(event:string) {
      if (this.formData.admissionsIndustry3 == event) {
        this.formData.admissionsIndustry3 = ""
        this.formData.methosIndustry3 = ""
      }
      if(this.arrMajors2.length != 0  && event) {
        let maxGPA  = this.maxGPAIndustry(event)
        let value = maxGPA ? maxGPA.code : undefined
        this.formData.methosIndustry2 = value ? value : ""
      }
      if(!event ) {
        this.formData.methosIndustry2 = ""
      }
      // Khi phương thức 9CR: gọi methosIndustryAutoChange để fill adForm/type/label ngành 2
      // Chỉ gọi khi combo được chọn (không rỗng) để tránh reset dữ liệu ngành
      if(this.formData.formOfMethod == '9CR' && this.formData.methosIndustry2) {
        this.methosIndustryAutoChange(this.formData.methosIndustry2, '2')
      }
    },
    admissionsIndustryChangeTHPT3(event:string) {
      if(this.arrMajorsTHPT3.length != 0  && event) {
        let maxGPA  = this.maxGPAIndustryTHPT(event)
        let value = maxGPA ? maxGPA.code : undefined
        this.formData.methosIndustryTHPT3 = value ? value : ""
      }
    },
    admissionsIndustryChange3(event:string) {
      if(this.arrMajors3.length != 0  && event) {
        let maxGPA  = this.maxGPAIndustry(event)
        let value = maxGPA ? maxGPA.code : undefined
        this.formData.methosIndustry3 = value ? value : ""
      }
      // Khi phương thức 9CR: gọi methosIndustryAutoChange để fill adForm/type/label ngành 3
      // Chỉ gọi khi combo được chọn (không rỗng) để tránh reset dữ liệu ngành
      if(this.formData.formOfMethod == '9CR' && this.formData.methosIndustry3) {
        this.methosIndustryAutoChange(this.formData.methosIndustry3, '3')
      }
    },
  },
  async mounted() {
    
    await axios.get('/phase')
    .then(( {data} ) => {
      this.arrPhase = data.map(i => {return {name:'Đợt '+i.phaseNo,id:i.id}})
    })
    .catch((errors) => {
      console.log('err',errors)
    });
    // Đợt mặc định = đợt HIỆN TẠI theo BE (startedDate <= hôm nay, phaseNo lớn nhất) — KHÔNG lấy
    // đợt tạo gần nhất: đợt bổ sung tạo trước ngày bắt đầu sẽ bị chọn nhầm dù chưa mở.
    await axios.get('/phase/item/current')
    .then(( {data} ) => {
      this.defaultPhaseId = data ? data.id : null
      // Chế độ TẠO & chưa chọn đợt -> chọn sẵn đợt hiện tại (phòng khi resetDataForm chạy trước lúc API xong)
      // Tạo liên thông truyền isEdit=true để bật form -> vẫn coi là TẠO (articulationCreate) nên auto-chọn đợt.
      if (!this.fromProfile && (!this.isEdit || this.articulationCreate) && this.defaultPhaseId && !this.formData.phase) {
        this.formData.phase = this.defaultPhaseId
      }
    })
    .catch((errors) => {
      // Chưa có đợt nào mở (404) -> không auto-chọn, NV tự chọn tay
      console.log('err',errors)
    });
    await axios.get('/major')
    .then(( {data} ) => {
      // TÁCH 2 danh sách theo cờ majors.isarticulation (bật ở Cài đặt xét tuyển > Ngành nhập học):
      //  - arrMajors: ngành hệ CHÍNH QUY, nuôi toàn bộ dropdown nguyện vọng của hồ sơ thường.
      //    Để ngành liên thông lọt vào đây thì thí sinh phổ thông chọn nhầm được.
      //  - arrMajorsArticulation: ngành hệ LIÊN THÔNG, chỉ dùng cho form xét tuyển liên thông
      //    (thay cho hardcode mã '7480201' trước đây — vốn trỏ nhầm sang ngành chính quy).
      data.forEach(item => {
        let temp = {
          value: item.code,
          // Ngành hệ LIÊN THÔNG hiển thị "Tên (mã)": mã _LT dài, để trước làm lệch cột và
          // đẩy tên ngành ra xa. Ngành chính quy giữ nguyên "mã-Tên" như mọi dropdown khác.
          label: item.isarticulation ? `${item.name} (${item.code})` : item.code+'-'+item.name,
          name: item.name,
          code: item.combination.split(','),
          id: item.id,
          isarticulation: !!item.isarticulation
        }
        if (temp.isarticulation) {
          this.arrMajorsArticulation.push(temp)
        } else {
          this.arrMajors.push(temp)
        }
      })
      this.arrMajors.splice(0,1) //bỏ phần tử rỗng khởi tạo sẵn của arrMajors
    })
    .catch((errors) => {
      console.log('err',errors)
    });
    await axios.get('/admission/method')
    .then(( {data} ) => {
      this.arrAdmissionMethod = data
    })
    .catch((errors) => {
      console.log('err',errors)
    });
    axios.get(`/setting/generalsetting?type=source`)
      .then(( {data} ) => {
        if(data.length!=0) {
          this.arrResource = data.map(i=>{return{
            value: i.code,
            label: i.name
          }})
        }
      })
      .catch((errors) => {
        console.log('err',errors)
      });
      await axios.get('/admission/form/')
    .then(( {data} ) => {
      this.arrIndustry = data.map((i: any) => ({...i, value: i.code, label: i.description}))
    })
    .catch((errors) => {
      console.log('err',errors)
    });
  },
 
  setup(props, {emit}) {
    function getBestComboResult(comboCode: string, method: number, priorityIndex: number = 1) {
      if (!comboCode) return null;
      let item = (arrIndustry.value as any[]).find((i: any) => i.code === comboCode);
      if (!item) return null;

      let actualEnglish = 0;
      let hasEnglish = false;
      let originalSum = 0;
      let check = false;

      if (formData.value.formOfMethod === '9CR') {
        const subjPoints = priorityIndex === 1 ? formData.value.subjectpoint : (priorityIndex === 2 ? formData.value.subjectpoint2 : formData.value.subjectpoint3);
        if (!subjPoints || subjPoints.length === 0) return null;
        
        subjPoints.forEach((subj: any) => {
          if (!subj || !subj.data) return;
          const d = subj.data;
          const avg = (+d.point0 + +d.point1 + +d.point2) / 3;
          originalSum += avg;
          if (subj.type && subj.type.toLowerCase().includes('english')) {
            hasEnglish = true;
            actualEnglish = avg;
          }
          if (d.point0 === '' || d.point1 === '' || d.point2 === '') check = true;
        });
        //giữ số gốc, KHÔNG làm tròn trung gian (calculateBestTotal đã toFixed(2) ở tổng cuối)
      } else {
        let prefix = (method == 5 || (method == 4 && formData.value.formOfMethod == 'TC01')) ? 'pt05' : '';
        let suffix = (method == 1) ? 'HKII' : '';
        let subjects = (method == 4 || method == 1 || method == 2 || method == 5) ? item['subjectthpt'] : item['subjecthk2'];
        
        if (Array.isArray(subjects)) {
          subjects.forEach((i: any) => {
            let baseSubject = i.replace('THPT', '').replace('HKII', '');
            let fieldName = prefix ? prefix + i : (suffix ? baseSubject + suffix : i);
            if (i.toLowerCase().includes('english')) {
              hasEnglish = true;
              actualEnglish = +formData.value[fieldName] || 0;
            }
            if (formData.value[fieldName] || formData.value[fieldName] === 0) originalSum += +formData.value[fieldName];
            else check = true;
          });
        }
      }

      if (check || originalSum === 0) return null;
      return calculateBestTotal(originalSum, actualEnglish, hasEnglish, priorityIndex);
    }
    function getIncentiveForDisplay(baseGPA: number, comboCode: string, method: number, priorityIndex: number = 1) {
      const best = getBestComboResult(comboCode, method, priorityIndex);
      return best ? best.incentiveScore : 0;
    }
    function getPriorityForDisplay(baseGPA: number, comboCode: string, method: number, priorityIndex: number = 1) {
      const best = getBestComboResult(comboCode, method, priorityIndex);
      return best ? best.priorityScoreNew : cacuPointPriority(baseGPA);
    }
    function getTotalForDisplay(baseGPA: number, comboCode: string, method: number, priorityIndex: number = 1) {
      const best = getBestComboResult(comboCode, method, priorityIndex);
      return best ? best.total : baseGPA;
    }
    function getGPAForDisplay(baseGPA: number, comboCode: string, method: number, priorityIndex: number = 1) {
      const best = getBestComboResult(comboCode, method, priorityIndex);
      const raw = best ? best.sum : baseGPA;
      return Math.round(raw * 100) / 100;
    }
    function getConversionUsedForDisplay(comboCode: string, method: number, priorityIndex: number = 1) {
      const best = getBestComboResult(comboCode, method, priorityIndex);
      return best ? best.usedConversion : false;
    }
    function getEnglishConvertedScoreForDisplay(comboCode: string, method: number, priorityIndex: number = 1) {
      if (!comboCode || !englishCertResult.value.valid) return 0;
      const originalMode = (formData.value as any)[`isUseEnglish${priorityIndex}`];
      (formData.value as any)[`isUseEnglish${priorityIndex}`] = true;
      const best = getBestComboResult(comboCode, method, priorityIndex);
      const score = best ? best.englishConvertedScore : 0;
      (formData.value as any)[`isUseEnglish${priorityIndex}`] = originalMode;
      return score;
    }
    function isPriorityReducedForDisplay(comboCode: string, method: number, priorityIndex: number = 1) {
      const best = getBestComboResult(comboCode, method, priorityIndex);
      if (!best) return false;
      if (!best.priorityScoreNew) return false;
      return (best.sum + best.incentiveScore) >= 22.5;
    }
    function comboHasEnglish(comboCode: string, method: number, priorityIndex: number = 1) {
      if (!comboCode) return false;
      let item = (arrIndustry.value as any[]).find((i: any) => i.code === comboCode);
      if (!item) return false;

      if (formData.value.formOfMethod === '9CR') {
        const subjPoints = priorityIndex === 1 ? formData.value.subjectpoint : (priorityIndex === 2 ? formData.value.subjectpoint2 : formData.value.subjectpoint3);
        if (!subjPoints) return false;
        return subjPoints.some((subj: any) => subj.type && subj.type.toLowerCase().includes('english'));
      } else {
        let subjects = (method == 4 || method == 1 || method == 2 || method == 5) ? item['subjectthpt'] : item['subjecthk2'];
        if (Array.isArray(subjects)) {
          return subjects.some((i: any) => i.toLowerCase().includes('english'));
        }
      }
      return false;
    }
    function getActualEnglishScore(comboCode: string, method: number, priorityIndex: number = 1) {
      if (!comboCode) return 0;
      
      let englishScore = 0;
      if (formData.value.formOfMethod === '9CR') {
        const subjPoints = priorityIndex === 1 ? formData.value.subjectpoint : (priorityIndex === 2 ? formData.value.subjectpoint2 : formData.value.subjectpoint3);
        if (subjPoints && subjPoints.length > 0) {
          const eng = subjPoints.find((s: any) => s.type && s.type.toLowerCase().includes('english'));
          if (eng) englishScore = (+eng.data.point0 + +eng.data.point1 + +eng.data.point2) / 3;
        }
      } else {
         if (method == 4) {
           englishScore = formData.value.formOfMethod == 'TC01' ? +formData.value.pt05englishTHPT : +formData.value.englishTHPT;
         } else if (method == 1) {
           englishScore = +formData.value.englishHKII;
         } else if (method == 5) {
           englishScore = +formData.value.pt05englishTHPT;
         }
      }
      return englishScore || 0;
    }
    function autoSelectEnglishMode(priorityIndex: number) {
      const method = formData.value.method;
      const comboCode = priorityIndex === 1 ? formData.value.methosIndustry : (priorityIndex === 2 ? formData.value.methosIndustry2 : formData.value.methosIndustry3);
      if (!comboCode || !englishCertResult.value.valid) return;

      const originalMode = (formData.value as any)[`isUseEnglish${priorityIndex}`];
      (formData.value as any)[`isUseEnglish${priorityIndex}`] = true;
      const best = getBestComboResult(comboCode, method, priorityIndex);
      
      if (best) {
        (formData.value as any)[`isUseEnglish${priorityIndex}`] = best.usedConversion;
      } else {
        (formData.value as any)[`isUseEnglish${priorityIndex}`] = originalMode;
      }
    }
    function handleHasEnglishCertChange() {
      if (!formData.value.hasEnglishCert) {
        formData.value.englishCertType = '';
        formData.value.englishCertScore = '';
        formData.value.englishCertDate = null;
        formData.value.toeicLRScore = '';
        formData.value.toeicSWScore = '';
      }
    }
    function handleHasIncentiveOtherChange() {
      if (!formData.value.hasIncentiveOther) {
        formData.value.mosWordScore = '';
        formData.value.mosExcelScore = '';
        formData.value.mosPPTScore = '';
        formData.value.jlptLevel = '';
        formData.value.hskLevel = '';
        formData.value.topikLevel = '';
        formData.value.delfTcfLevel = '';
        formData.value.vstepLevel = '';
        formData.value.aptisLevel = '';
        formData.value.hasOtherCert = false;
        formData.value.otherIntCertType = '';
      }
    }

    Dropzone.autoDiscover = false;
    const route = useRoute()
    const idAdReg = ref(undefined);
    const adCode = ref(undefined);
    const fizeSize = ref(undefined);
    const isAddFiles = ref(false)
    const tabFile = ref<any>(null)
    const showUploadPopup = ref(false)
    const fileTypes = [
      { value: 'cccdtruoc', label: 'CCCD mặt trước' },
      { value: 'cccdsau', label: 'CCCD mặt sau' },
      { value: 'hocba10', label: 'Học bạ lớp 10' },
      { value: 'hocba11', label: 'Học bạ lớp 11' },
      { value: 'hocba12', label: 'Học bạ lớp 12' },
      { value: 'khac', label: 'Giấy tờ khác' },
    ]
    const dataCustomer = ref<any>({})
    const dataResidenceProvince = ref<any>([])
    const dataResidenceDistrict = ref<any>([])
    const dataResidenceWard = ref<any>([])
    const dataProvince = ref<any>([])
    const dataDistrict = ref<any>([])
    const dataWard = ref<any>([])
    async function getDistrict(id:string) {
      let arrTemp = []
      await axios.get(`/res/district/?provinceId=${id}`)
      .then(( {data} ) => {
        arrTemp = data
      })
      .catch(({ response }) => {
        console.log('err',response)
      });
      return arrTemp
    }
    async function getWard(id:string) {
      //Địa chỉ 2 cấp (sáp nhập 2025): nạp Xã/Phường trực tiếp từ Tỉnh, bỏ cấp Huyện
      let arrTemp = JSON.parse(JSON.stringify(dataProvince.value)).find(i => i.id == id)
      if(arrTemp) {
        let temp = (arrTemp.wards || []).map(i=>({
          ...i,
          id: i.code,
          label: i.name,
          value: i.code,
        }))
        return sortByAlphabet(temp,'name')
      }
      return []
    }
    async function getProvince() {
      // await axios.get('/res/province')
      await axios.get('/res/newprovince/list')
    .then(( {data} ) => {
      dataProvince.value = data.map(i =>({...i,id: i.code, wards: (i.wards || []).map(w => ({...w,id: w.code,provinceCode: i.code}))}))
      setTimeout(async()=> {
        //Địa chỉ 2 cấp (2025): nạp Xã từ Tỉnh trực tiếp, không còn cấp Huyện
          if(formData_arp.value.student.contactProvinceId != "" && formData_arp.value.student.contactProvinceId) {
            dataWard.value = await getWard(formData_arp.value.student.contactProvinceId)
          }
          if(formData_arp.value.student.prProvinceId != "" && formData_arp.value.student.prProvinceId) {
            dataResidenceWard.value = await getWard(formData_arp.value.student.prProvinceId)
          }
      },600)
    })
    .catch(({ response }) => {
      console.log('err',response)
    });
    }
    // console.log('props',props)
    const formOptions = ref<any>([
      /*{
        label:'Xét tuyển dựa trên Kết quả học tập cả năm lớp 12 theo tổ hợp 3 môn',
        value: "THM",
      },*/
      {
        label:'Xét tuyển dựa trên Kết quả học tập 3 năm THPT theo tổ hợp 3 môn',
        value: '9CR',
      },
      /*{
        label:`Xét tuyển dựa trên Kết quả học tập 3 năm THPT <br /><i>(Đối với thí sinh đã tốt nghiệp THPT từ năm ${new Date().getFullYear() - 1} trở về trước)</i>`,
        value: '3YS',
      },*/
    ])
    const kt_customer_view_files_profile = ref<null | HTMLElement>(null);
    const kt_customer_view_method = ref<null | HTMLElement>(null);
    function renderTitleSubject(value){
      let a = arr_subject_THPT.value.find(i=>i.value == value)
      // console.log('a',a)
      // console.log('arr_subject_THPT',arr_subject_THPT,value)
      return a?.label|| ''
    }
    function renderSubject(code){
      let a = arrIndustry.value.find(i=>i.code == code)
      // console.log('a',a)
      // console.log('arrIndustry',arrIndustry,code)
      return a?.subjectthpt|| ''
    }
    //Cảnh báo dữ liệu lệch tổ hợp: nhãn môn render theo tổ hợp nhưng ô điểm bind theo VỊ TRÍ slot,
    //nên slot mang type môn khác (hồ sơ đổi tổ hợp mà slot không remap) sẽ hiển thị điểm SAI MÔN
    //mà không ai thấy. Trả về danh sách lệch để banner cảnh báo user kiểm tra lại.
    function slotTypeMismatch(spKey: string, comboCode: string) {
      if (formData.value.formOfMethod !== '9CR' || !comboCode) return []
      const expected = renderSubject(comboCode)
      const slots = (formData.value as any)[spKey]
      if (!Array.isArray(expected) || !Array.isArray(slots)) return []
      const out: string[] = []
      expected.forEach((sub: string, i: number) => {
        const t = slots[i]?.type
        if (t && t !== sub) out.push(`ô "${renderTitleSubject(sub)}" đang chứa điểm môn "${renderTitleSubject(t)}" (dữ liệu lưu từ tổ hợp trước)`)
      })
      return out
    }
    const arr_subject_THPT = ref([
      {
          label:'Toán',
          value: 'mathTHPT'
      },
      {
          label:'Vật lý',
          value: 'physicsTHPT'
      },
      {
          label:'Hóa học',
          value: 'chemistryTHPT'
      },
      {
          label:'Tiếng anh',
          value: 'englishTHPT'
      },
      {
          label:'Sinh học',
          value: 'biologicalTHPT'
      },
      {
          label:'GDCD',
          value: 'civicEducationTHPT'
      },
      {
          label:'Ngữ văn',
          value: 'literatureTHPT'
      },
      {
          label:'Địa lý',
          value: 'geographyTHPT'
      },
      {
          label:'Lịch sử',
          value: 'historyTHPT'
      },
      {
          label:'Vẽ',
          value: 'artTHPT'
      },
      {
          label:'Tiếng pháp',
          value: 'frenchTHPT'
      },
      {
          label:'Giáo dục kinh tế và pháp luật',
          value: 'economicsAndLawEducationTHPT'
      },
      {
          label:'Tin học',
          value: 'informationTechnologyTHPT'
      },
    ])
    const arrResource = ref([
      {
        value: "online",
        label: "Trực tuyến"
      },
      {
        value: "office",
        label: "Trực tiếp"
      },
      {
        value: "postoffice",
        label: "Bưu điện"
      },
      {
        value: "email",
        label: "Email"
      },
    ])
    const tableData = ref([
      {
        file: {
          url: "",
          name: "",
        },
        label: null,
        actions: true,
        type: "",
        size: "",
        date: "",
        id: "",
        processing: false
      } as any
    ])
    
    const arrTypeIsCert = ref([
      {
        value: "isEnglishCertificate",
        typeIsCert: "isEngCert"
      },
      {
        value: "isCollegeOrInterDegree",
        typeIsCert: "isCollegeDiploma"
      },
      {
        value: "isInternationalCertificate",
        typeIsCert: "isInternationalCert"
      },
      {
        value: "isAthleteCertOrPreMaster",
        typeIsCert: "isAthleteCertOrPreMaster"
      },
      {
        value: "isPrize",
        typeIsCert: "isNationalAward"
      },
      {
        value: "isGoodStanding",
        typeIsCert: "isGoodInHighschool"
      },
    ])
    const _arpros = computed(() => {
      let a = props as any
      // console.log('aaaaaaaaaaaa',a)
      return a.dataAdm?.adRegister?._arpros|| null
    });
    // arpros = đang ở CHẾ ĐỘ liên thông: sửa hồ sơ LT đã có (_arpros) HOẶC tạo mới LT (articulationCreate).
    // Dùng chung để hiện form LT (v-if="arpros && isEdit") và định tuyến submit sang articulationProgram().
    const arpros = computed(() => !!_arpros.value || !!props.articulationCreate)

    
    const arrSubject = {
      graduationschool: '',
      trainingform: 'chinhquy',
      graduationsys: 'caodang',
      gpafor: 'gpa4',
      gpa: '',
      graduationnumber: '',
      graduationentrynumber: '',
      graduationyear: '',
      graduationday: '',
    }
    const formData_arp = ref({
      intermediate: JSON.parse(JSON.stringify(arrSubject)),
      college: JSON.parse(JSON.stringify(arrSubject)),
      isintermediate: false,
      job: '',
      jobtitle: '',
      workplace: '',
      registeredmajor: "",
      student: {
          "id": dataCustomer.value.id,
          "fullName": dataCustomer.value.fullName,
          "phone": dataCustomer.value.phoneNumber,
          "idCard": dataCustomer.value.idCard,
          "email": dataCustomer.value.email,
          "gender": dataCustomer.value.gender,
          "dateOfBirth": dataCustomer.value.birthday,
          "birthplace": dataCustomer.value.birthplace,

          "dateOfIssue": dataCustomer.value.dateOfIssue,
          "issuePlace": dataCustomer.value.issuePlace,
          
          "prProvinceId": dataCustomer.value.residenceProvince,
          "prDistrictId": dataCustomer.value.residenceDistrict,

          "prWardId": dataCustomer.value.residenceWard,
          "prAddress": dataCustomer.value.residenceAddress,
          "contactProvinceId": dataCustomer.value.province,
          "contactDistrictId": dataCustomer.value.district,
          "contactWardId": dataCustomer.value.ward,
          "contactAddress": dataCustomer.value.address,
        },
    })
    watch(() => _arpros.value, (olData, newData) => {
      if(props.dataCustomer) {
        dataCustomer.value = props.dataCustomer
      }
      if(_arpros.value) {
        formData_arp.value = {
          ...formData_arp.value,
          registeredmajor: _arpros.value.registeredmajor,
          isintermediate: _arpros.value.isintermediate,
          job: _arpros.value.job,
          jobtitle: _arpros.value.jobtitle,
          workplace: _arpros.value.workplace,
        }
        formData_arp.value.student = props.dataCustomer as any
        formData_arp.value.college = {
          graduationschool: _arpros.value.graduationschool,
          trainingform: _arpros.value.trainingform,
          graduationsys: _arpros.value.graduationsys,
          gpafor: _arpros.value.gpafor,
          gpa: _arpros.value.gpa,
          graduationnumber: _arpros.value.graduationnumber,
          graduationentrynumber: _arpros.value.graduationentrynumber,
          graduationyear: _arpros.value.graduationyear,
          graduationday: _arpros.value.graduationday,
        }
        if(_arpros.value.intermediate) {
          formData_arp.value.intermediate = {
            graduationschool: _arpros.value.intermediate.graduationschool,
            trainingform: _arpros.value.intermediate.trainingform,
            graduationsys: _arpros.value.intermediate.graduationsys,
            gpafor: _arpros.value.intermediate.gpafor,
            gpa: _arpros.value.intermediate.gpa,
            graduationnumber: _arpros.value.intermediate.graduationnumber,
            graduationentrynumber: _arpros.value.intermediate.graduationentrynumber,
            graduationyear: _arpros.value.intermediate.graduationyear,
            graduationday: _arpros.value.intermediate.graduationday,
          }
        }
        getProvince()
      }
    }, { immediate: true })
    // Prefill hồ sơ vào formData. Tách thành hàm để gọi được từ cả watch (khi dataAdm đổi null->object,
    // dùng cho các luồng KHÔNG bọc v-if) lẫn onMounted (luồng profileDetail bọc v-if="dataAdmissionRegister"
    // nên modal mount khi dataAdm đã có sẵn -> watch không fire). Đặt ở onMounted (sau setup) để tránh TDZ
    // vì body tham chiếu formData/additionalPhase được khai báo phía dưới.
    const applyDataAdm = () => {
      resetDataForm()
      if(props.dataAdm) {
        additionalPhase.value = props.dataAdm.adRegister.isExtra
        formData.value.method = +props.dataAdm.adRegister.idAdMethod
        formData.value.source = props.dataAdm.adRegister.source
        formData.value.createdAt = props.dataAdm.adRegister.createdAt
        formData.value.phase = props.dataAdm.adRegister.phase
        formData.value.isActive = props.dataAdm.adRegister.isActive
        if(props.fromProfile) {
          formData.value.status = props.dataAdm.adRegister.status
        }
        if(props.dataAdm.adRegister.idAdMethod == 1) {
          formData.value.all10 = props.dataAdm.adDetails[0].class10TotalScore
          formData.value.all11 = props.dataAdm.adDetails[0].class11TotalScore
          formData.value.all12 = props.dataAdm.adDetails[0].class12TotalScore
          formData.value.hki12 = props.dataAdm.adDetails[0].class12Semester1Score
          formData.value.mathHKII = props.dataAdm.adDetails[0].class12AverageMathScore?props.dataAdm.adDetails[0].class12AverageMathScore:""
          formData.value.physicsHKII = props.dataAdm.adDetails[0].class12AveragePhysicsScore?props.dataAdm.adDetails[0].class12AveragePhysicsScore:""
          formData.value.chemistryHKII = props.dataAdm.adDetails[0].class12AverageChemistryScore?props.dataAdm.adDetails[0].class12AverageChemistryScore:""
          formData.value.englishHKII = props.dataAdm.adDetails[0].class12AverageEnglishScore?props.dataAdm.adDetails[0].class12AverageEnglishScore:""
          formData.value.frenchHKII = props.dataAdm.adDetails[0].class12AverageFrenchScore?props.dataAdm.adDetails[0].class12AverageFrenchScore:""
          formData.value.literatureHKII = props.dataAdm.adDetails[0].class12AverageLiteratureScore?props.dataAdm.adDetails[0].class12AverageLiteratureScore:""
          formData.value.historyHKII = props.dataAdm.adDetails[0].class12AverageHistoryScore?props.dataAdm.adDetails[0].class12AverageHistoryScore:""
          formData.value.geographyHKII = props.dataAdm.adDetails[0].class12AverageGeographyScore?props.dataAdm.adDetails[0].class12AverageGeographyScore:""
          formData.value.biologicalHKII = props.dataAdm.adDetails[0].class12AverageBiologyScore?props.dataAdm.adDetails[0].class12AverageBiologyScore:""
          formData.value.civicEducationHKII = props.dataAdm.adDetails[0].class12AverageCivicEducationScore?props.dataAdm.adDetails[0].class12AverageCivicEducationScore:""
          formData.value.informationTechnologyHKII = props.dataAdm.adDetails[0].class12AverageInformationTechnologyScore?props.dataAdm.adDetails[0].class12AverageInformationTechnologyScore:""
          formData.value.economicsAndLawEducationHKII = props.dataAdm.adDetails[0].class12AverageEconomicsAndLawEducationScore?props.dataAdm.adDetails[0].class12AverageEconomicsAndLawEducationScore:""
          formData.value.artHKII = props.dataAdm.adDetails[0].class12AverageArtScore?props.dataAdm.adDetails[0].class12AverageArtScore:""
          
          formData.value.admissionsIndustry = props.dataAdm.adMajors.filter(item => item.priority == 1)[0]?.major?.code
          formData.value.admissionsIndustry2 = props.dataAdm.adMajors.filter(item => item.priority == 2)[0]?.major?.code
          formData.value.admissionsIndustry3 = props.dataAdm.adMajors.filter(item => item.priority == 3)[0]?.major?.code
          formData.value.methosIndustry = props.dataAdm.adMajors.filter(item => item.priority == 1)[0]?.adForm
          formData.value.methosIndustry2 = props.dataAdm.adMajors.filter(item => item.priority == 2)[0]?.adForm
          formData.value.methosIndustry3 = props.dataAdm.adMajors.filter(item => item.priority == 3)[0]?.adForm
          formData.value.formOfMethod = props.dataAdm.adDetails[0]?.admissiontype
          
          // Load subjectpoint1,2,3: chỉ cần tồn tại và là mảng có dữ liệu
          // (không kiểm tra adForm vì dữ liệu cũ có thể chưa có field này)
          if(Array.isArray(props.dataAdm.adDetails[0]?.subjectpoint1) && props.dataAdm.adDetails[0].subjectpoint1.length > 0) {
            formData.value.subjectpoint = props.dataAdm.adDetails[0].subjectpoint1
          }
          if(Array.isArray(props.dataAdm.adDetails[0]?.subjectpoint2) && props.dataAdm.adDetails[0].subjectpoint2.length > 0) {
            formData.value.subjectpoint2 = props.dataAdm.adDetails[0].subjectpoint2
          }
          if(Array.isArray(props.dataAdm.adDetails[0]?.subjectpoint3) && props.dataAdm.adDetails[0].subjectpoint3.length > 0) {
            formData.value.subjectpoint3 = props.dataAdm.adDetails[0].subjectpoint3
          }
        }
        if(props.dataAdm.adRegister.idAdMethod == 2) {
          let nlqgScore = props.dataAdm.adDetails[0].nlqgScore||''
          //Ưu tiên điểm gốc thang 1200 đã lưu (total_score) để không bị mất chính xác do làm tròn
          if(props.dataAdm.adDetails[0].totalScore != null && props.dataAdm.adDetails[0].totalScore !== '') {
            nlqgScore = props.dataAdm.adDetails[0].totalScore
          }
          //Hồ sơ cũ lỡ lưu thẳng điểm thang 1200 (>30) thì giữ nguyên
          else if(nlqgScore && nlqgScore > 30) {

          }
          //Hồ sơ cũ chỉ có điểm thang 30 -> back-calc (chấp nhận sai số do dữ liệu gốc đã mất)
          else {
            nlqgScore = props.dataAdm.adDetails[0].nlqgScore*1200/30
          }
          formData.value.aptitudeTest = nlqgScore
          formData.value.majorForAptitudeTest = props.dataAdm.adMajors.filter(item => item.priority == 1)[0]?.major?.code
          formData.value.majorForAptitudeTest2 = props.dataAdm.adMajors.filter(item => item.priority == 2)[0]?.major?.code
          formData.value.majorForAptitudeTest3 = props.dataAdm.adMajors.filter(item => item.priority == 3)[0]?.major?.code
        }
        
        if(props.dataAdm.adRegister.idAdMethod == 3) {
          formData.value.majorForUmt = props.dataAdm.adMajors.filter(item => item.priority == 1)[0]?.major?.code
          formData.value.majorForUmt2 = props.dataAdm.adMajors.filter(item => item.priority == 2)[0]?.major?.code
          formData.value.majorForUmt3 = props.dataAdm.adMajors.filter(item => item.priority == 3)[0]?.major?.code
          formData.value.ielts = props.dataAdm.adDetails[0]?.ieltsScore?props.dataAdm.adDetails[0].ieltsScore:""
          formData.value.toefl = props.dataAdm.adDetails[0]?.toeflScore?props.dataAdm.adDetails[0].toeflScore:""
          formData.value.toeic = props.dataAdm.adDetails[0]?.toeicScore?props.dataAdm.adDetails[0].toeicScore:""
          formData.value.sat = props.dataAdm.adDetails[0]?.satScore?props.dataAdm.adDetails[0].satScore:""
          formData.value.typeIsCert = arrTypeIsCert.value.filter(item => props.dataAdm.adDetails[0][item.typeIsCert])[0]?.value
        }
        if(props.dataAdm.adRegister.idAdMethod == 4) {
          formData.value.mathTHPT = props.dataAdm.adDetails[0].mathScore?props.dataAdm.adDetails[0].mathScore:""
          formData.value.physicsTHPT = props.dataAdm.adDetails[0].physicsScore?props.dataAdm.adDetails[0].physicsScore:""
          formData.value.chemistryTHPT = props.dataAdm.adDetails[0].chemistryScore?props.dataAdm.adDetails[0].chemistryScore:""
          formData.value.englishTHPT = props.dataAdm.adDetails[0].englishScore?props.dataAdm.adDetails[0].englishScore:""
          formData.value.frenchTHPT = props.dataAdm.adDetails[0].frenchScore?props.dataAdm.adDetails[0].frenchScore:""
          formData.value.literatureTHPT = props.dataAdm.adDetails[0].literatureScore?props.dataAdm.adDetails[0].literatureScore:""
          formData.value.historyTHPT = props.dataAdm.adDetails[0].historyScore?props.dataAdm.adDetails[0].historyScore:""
          formData.value.geographyTHPT = props.dataAdm.adDetails[0].geographyScore?props.dataAdm.adDetails[0].geographyScore:""
          formData.value.artTHPT = props.dataAdm.adDetails[0].artScore?props.dataAdm.adDetails[0].artScore:""
          formData.value.informationTechnologyTHPT = props.dataAdm.adDetails[0].informationTechnologyScore?props.dataAdm.adDetails[0].informationTechnologyScore:""
          formData.value.economicsAndLawEducationTHPT = props.dataAdm.adDetails[0].economicsAndLawEducationScore?props.dataAdm.adDetails[0].economicsAndLawEducationScore:""
          formData.value.biologicalTHPT = props.dataAdm.adDetails[0].biologyScore?props.dataAdm.adDetails[0].biologyScore:""
          
          formData.value.admissionsIndustryTHPT = props.dataAdm.adMajors.filter(item => item.priority == 1)[0]?.major?.code
          formData.value.admissionsIndustryTHPT2 = props.dataAdm.adMajors.filter(item => item.priority == 2)[0]?.major?.code
          formData.value.admissionsIndustryTHPT3 = props.dataAdm.adMajors.filter(item => item.priority == 3)[0]?.major?.code
          formData.value.methosIndustryTHPT = props.dataAdm.adMajors.filter(item => item.priority == 1)[0]?.adForm
          formData.value.methosIndustryTHPT2 = props.dataAdm.adMajors.filter(item => item.priority == 2)[0]?.adForm
          formData.value.methosIndustryTHPT3 = props.dataAdm.adMajors.filter(item => item.priority == 3)[0]?.adForm
        }
        if(props.dataAdm.adRegister.idAdMethod == 6) {
          const vsatData = props.dataAdm.adDetails[0];
          if (vsatData) {
            formData.value.dgnlHN_math = vsatData.mathScore || "";
            formData.value.dgnlHN_physics = vsatData.physicsScore || "";
            formData.value.dgnlHN_chemistry = vsatData.chemistryScore || "";
            formData.value.dgnlHN_biology = vsatData.biologyScore || "";
            formData.value.dgnlHN_history = vsatData.historyScore || "";
            formData.value.dgnlHN_geography = vsatData.geographyScore || "";
            formData.value.dgnlHN_english = vsatData.englishScore || "";
            formData.value.dgnlHN_literature = vsatData.literatureScore || "";
          }
          formData.value.majorDGNL_HN = props.dataAdm.adMajors.filter(item => item.priority == 1)[0]?.major?.code;
          formData.value.majorDGNL_HN2 = props.dataAdm.adMajors.filter(item => item.priority == 2)[0]?.major?.code;
          formData.value.majorDGNL_HN3 = props.dataAdm.adMajors.filter(item => item.priority == 3)[0]?.major?.code;
        }
        if(props.dataAdm.adRegister.idAdMethod == 5) {
          const edData = props.dataAdm.adDetails[0];
          if (edData) {
            //Guard dữ liệu bẩn: một số hồ sơ TĐTĐ (nguồn online) lưu formOfMethod='9CR' (giá trị của PT Học bạ)
            //-> không khớp SAT/ACT/TC01 nên form không hiện ô điểm/hình thức nào. Coi như CHƯA chọn để user chọn lại
            //(pt5CriteriaLocked=false mở khoá select dù isEdit — bình thường tiêu chí bị khoá sau khi tạo).
            const _pt5Valid = ['SAT', 'ACT', 'TC01'].includes(edData.formOfMethod);
            formData.value.formOfMethodMethod5 = _pt5Valid ? edData.formOfMethod : '';
            formData.value.pt5CriteriaLocked = _pt5Valid;
            formData.value.tcCriteria = edData.tcCriteria;
            formData.value.tc01AverageGrade12 = edData.tc01AverageGrade12;
            formData.value.pt05mathTHPT = edData.mathTHPT;
            formData.value.pt05physicsTHPT = edData.physicsTHPT;
            formData.value.pt05chemistryTHPT = edData.chemistryTHPT;
            formData.value.pt05englishTHPT = edData.englishTHPT;
            formData.value.pt05frenchTHPT = edData.frenchTHPT;
            formData.value.pt05literatureTHPT = edData.literatureTHPT;
            formData.value.pt05historyTHPT = edData.historyTHPT;
            formData.value.pt05geographyTHPT = edData.geographyTHPT;
            formData.value.pt05biologicalTHPT = edData.biologicalTHPT;
            formData.value.pt05artTHPT = edData.artTHPT;
            formData.value.pt05informationTechnologyTHPT = edData.informationTechnologyTHPT;
            formData.value.pt05economicsAndLawEducationTHPT = edData.economicsAndLawEducationTHPT;
            
            formData.value.sat = edData.sat || '';
            formData.value.actScore = edData.actScore || '';
            formData.value.satDate = edData.satDate || null;
            formData.value.actDate = edData.actDate || null;
          }
          
          formData.value.admissionsIndustryTHPT = props.dataAdm.adMajors.filter(item => item.priority == 1)[0]?.major?.code;
          formData.value.admissionsIndustryTHPT2 = props.dataAdm.adMajors.filter(item => item.priority == 2)[0]?.major?.code;
          formData.value.admissionsIndustryTHPT3 = props.dataAdm.adMajors.filter(item => item.priority == 3)[0]?.major?.code;
          formData.value.methosIndustryTHPT = props.dataAdm.adMajors.filter(item => item.priority == 1)[0]?.adForm;
          formData.value.methosIndustryTHPT2 = props.dataAdm.adMajors.filter(item => item.priority == 2)[0]?.adForm;
          formData.value.methosIndustryTHPT3 = props.dataAdm.adMajors.filter(item => item.priority == 3)[0]?.adForm;
        }
        formData.value.files = props.dataAdm.adFiles
        
        // Load certBonusData (English Cert & Incentive Certs)
        if (props.dataAdm.adRegister?.certBonusData) {
          const cbd = props.dataAdm.adRegister.certBonusData;
          formData.value.hasEnglishCert = cbd.hasEnglishCert || false;
          formData.value.englishCertType = cbd.englishCertType || '';
          formData.value.englishCertScore = cbd.englishCertScore || '';
          formData.value.toeicLRScore = cbd.toeicLRScore || '';
          formData.value.toeicSWScore = cbd.toeicSWScore || '';
          formData.value.englishCertDate = cbd.englishCertDate || null;
          
          formData.value.hasIncentiveOther = cbd.hasIncentiveOther || false;
          formData.value.mosWordScore = cbd.mosWordScore || '';
          formData.value.mosExcelScore = cbd.mosExcelScore || '';
          formData.value.mosPPTScore = cbd.mosPPTScore || '';
          formData.value.jlptLevel = cbd.jlptLevel || '';
          formData.value.hskLevel = cbd.hskLevel || '';
          formData.value.topikLevel = cbd.topikLevel || '';
          formData.value.delfTcfLevel = cbd.delfTcfLevel || '';
          formData.value.vstepLevel = cbd.vstepLevel || '';
          formData.value.aptisLevel = cbd.aptisLevel || '';
          formData.value.hasOtherCert = cbd.hasOtherCert || false;
          formData.value.otherIntCertType = cbd.otherIntCertType || '';
        }

        // Sync isUseEnglish flags based on objectInfo from adMajors
        if (props.dataAdm.adMajors && Array.isArray(props.dataAdm.adMajors)) {
          props.dataAdm.adMajors.forEach(major => {
            let info = major.objectInfo;
            if (typeof info === 'string') {
              try { info = JSON.parse(info); } catch(e) { info = {}; }
            }
            const hasConversion = !!(info?.englishConvertedScore > 0);
            if (major.priority == 1) formData.value.isUseEnglish1 = hasConversion;
            if (major.priority == 2) formData.value.isUseEnglish2 = hasConversion;
            if (major.priority == 3) formData.value.isUseEnglish3 = hasConversion;
          });
        }
      }
    }
    watch(() => props.dataAdm, applyDataAdm)
    // Chỉ prefill lúc mount cho luồng profileDetail (bọc v-if="dataAdmissionRegister" nên watch ở trên không fire).
    // Các luồng khác (AdmissionProfile/Statement, AdmissionProcedures, ModalRunAnalysis, tạo mới) modal mount với
    // dataAdm rỗng/partial rồi nạp sau qua watch -> KHÔNG gọi ở mount để tránh đọc adRegister khi chưa có.
    // LƯU Ý: KHÔNG chặn render body chờ prefill (từng thử prefillReady) — applyDataAdm→resetDataForm cần
    // element Dropzone CÓ TRONG DOM ("Invalid dropzone element" nếu chưa render). Noise "$el" của el-select
    // khi các v-if lật lúc đổ dữ liệu đã được chặn đúng loại ở main.ts (unhandledrejection).
    onMounted(() => { if (props.fromProfile && props.dataAdm && props.dataAdm.adRegister) applyDataAdm() })

    watch(() => props.isEdit, (oldEdit, newEdit) => {
      //isEditAdmission.value = newEdit
      document.querySelectorAll(".dz-preview").forEach(e => e.remove());
    });
    //const isEditAdmission = ref<boolean>(false);
    const formRef = ref();
    const loading = ref<boolean>(false);
    const userSelect = ref(false)
    const userSelectTHPT = ref(false)
    const arrMajors = ref([
      {
        value: '',
        label: '',
        name: '',
        id: '',
        code:'',
      }
    ]);
    //Ngành hệ LIÊN THÔNG (majors.isarticulation) — tách khỏi arrMajors để không lọt vào
    //dropdown nguyện vọng của hồ sơ thường. Chỉ form "Xét tuyển liên thông" dùng danh sách này.
    const arrMajorsArticulation = ref([] as any[]);

    const isPermission = computed(() => {
      if (props.isEdit) {
        if(props.isAppraised) {
          return !props.isAppraised
        }
        return checkPermission([Permission.ADMISSION_REGISTER_EDIT,Permission.ADMISSION_REGISTER])
      }
      else {
        return checkPermission([Permission.ADMISSION_REGISTER_CREATE,Permission.ADMISSION_REGISTER])
      }
    });
    // Trang hồ sơ nhúng (fromProfile): đích quay lại của nút Đóng/Hủy bỏ —
    // mở từ chi tiết ứng viên (?from=ungvien, AdmissionProfile gắn) thì về tab "Hồ sơ đăng ký xét" (#tab3),
    // còn lại về Danh sách hồ sơ như cũ.
    const profileBackTo = computed(() => {
      const sid = props.idStudent || props.dataAdm?.adRegister?.idStudent
      if (route?.query?.from === 'ungvien' && sid) {
        return { path: `/danhsachungvien/${sid}`, hash: '#tab3' }
      }
      return '/danhsachhoso'
    });
    const date = new Date()
    const currentYear = date.getFullYear().toString()
    const subjectpoint = [
      {
      adForm: '',
      type: '',
      label: '',
      data: {
        point0: '',
        point1: '',
        point2: '',
      }
      },
      {
      adForm: '',
      type: '',
      label: '',
      data: {
        point0: '',
        point1: '',
        point2: '',
      }
      },
      {
        adForm: '',
        type: '',
        label: '',
        data: {
          point0: '',
          point1: '',
          point2: '',
        }
      },
    ]
    var formData = ref<any>({
        method: 4,
        all10: "",
        all11: "",
        hki12: "",
        all12: "",
        mathHKII: "",
        physicsHKII: "",
        chemistryHKII: "",
        englishHKII: "",
        frenchHKII: "",
        literatureHKII: "",
        historyHKII: "",
        geographyHKII: "",
        biologicalHKII:"",
        civicEducationHKII: "",
        informationTechnologyHKII: "",
        economicsAndLawEducationHKII: "",
        artHKII:"",
        admissionsIndustry: "",
        admissionsIndustry2: "",
        admissionsIndustry3: "",
        methosIndustry: "",
        methosIndustry2: "",
        methosIndustry3: "",
        mathTHPT: "",
        physicsTHPT: "",
        chemistryTHPT: "",
        englishTHPT: "",
        frenchTHPT: "",
        literatureTHPT: "",
        historyTHPT: "",
        geographyTHPT: "",
        artTHPT: "",
        informationTechnologyTHPT: "",
        economicsAndLawEducationTHPT: "",
        biologicalTHPT:"",
        admissionsIndustryTHPT: "",
        admissionsIndustryTHPT2: "",
        admissionsIndustryTHPT3: "",
        methosIndustryTHPT: "",
        methosIndustryTHPT2: "",
        methosIndustryTHPT3: "",
        aptitudeTest: "",
        majorForAptitudeTest: "",
        majorForAptitudeTest2: "",
        majorForAptitudeTest3: "",
        majorForUmt: "",
        majorForUmt2: "",
        majorForUmt3: "",
        ielts: "",
        toefl: "",
        toeic: "",
        typeIsCert: '',
        files: [],
        subjectpoint: JSON.parse(JSON.stringify(subjectpoint)),
        subjectpoint2: JSON.parse(JSON.stringify(subjectpoint)),
        subjectpoint3: JSON.parse(JSON.stringify(subjectpoint)),
        formOfMethod: "THPT",
        hasEnglishCert: false,
        englishCertType: '',
        englishCertScore: '',
        toeicLRScore: '',
        toeicSWScore: '',
        englishCertDate: '',
        hasIncentiveOther: false,
        mosWordScore: '',
        mosExcelScore: '',
        mosPPTScore: '',
        jlptLevel: '',
        hskLevel: '',
        topikLevel: '',
        delfTcfLevel: '',
        vstepLevel: '',
        aptisLevel: '',
        hasOtherCert: false,
        otherIntCertType: '',
        otherIntCertScore: '',
        // Method 5 (Equivalent Degree)
        pt05mathTHPT: '',
        pt05physicsTHPT: '',
        pt05chemistryTHPT: '',
        pt05englishTHPT: '',
        pt05frenchTHPT: '',
        pt05literatureTHPT: '',
        pt05historyTHPT: '',
        pt05geographyTHPT: '',
        pt05artTHPT: '',
        pt05informationTechnologyTHPT: '',
        pt05economicsAndLawEducationTHPT: '',
        pt05biologicalTHPT: '',
        tcCriteria: '',
        tc01AverageGrade12: '',
        sat: '',
        satDate: '',
        actScore: '',
        actDate: '',
        formOfMethodMethod5: '',
        // Method 6 (VSAT)
        dgnlHN_math: "",
        dgnlHN_physics: "",
        dgnlHN_chemistry: "",
        dgnlHN_biology: "",
        dgnlHN_history: "",
        dgnlHN_geography: "",
        dgnlHN_english: "",
        dgnlHN_literature: "",
        majorDGNL_HN: "",
        majorDGNL_HN2: "",
        majorDGNL_HN3: "",
        isUseEnglish1: true,
        isUseEnglish2: true,
        isUseEnglish3: true,
      });
    function checkPermission(permission) {
      const value = permission
      const temp = window.localStorage.getItem("user")
      const user = temp?JSON.parse(temp) : undefined as any
      const listPermission = user?.permissions?.filter(item => item.name == value[1])

      if(listPermission && listPermission.length!=0) {
        const {permissions} = listPermission[0]
        if(permissions && permissions instanceof Array) {
          if (value && value instanceof Array) {
            if (value.length > 0) {
              const permissionRoles = [value[0]]
              const hasPermission = permissions.some(role => {
                return permissionRoles.includes(role)
              })
              return hasPermission //true | false
            }
          } else {
            return false
          }
        }
      }
      else {
        return false
      }
    };
    function resetDataForm() {
      kt_customer_view_method.value?.click()
      isAddFiles.value = false
      tableData.value = []
      additionalPhase.value = false
      // Reset theo dõi ô điểm đã gõ (tránh dính chéo giữa các hồ sơ mở nối tiếp trong cùng modal)
      // + refetch bảng điểm học bạ MỚI NHẤT (luồng tạo mới không đổi props nên watch không fire)
      clearScoreDirty()
      loadStudentTranscript()
      let temp = {
        method: 4,
        createdAt: new Date(),
        all10: "",
        all11: "",
        hki12: "",
        all12: "",
        mathHKII: "",
        physicsHKII: "",
        chemistryHKII: "",
        englishHKII: "",
        frenchHKII: "",
        literatureHKII: "",
        historyHKII: "",
        geographyHKII: "",
        biologicalHKII:"",
        civicEducationHKII: "",
        informationTechnologyHKII: "",
        economicsAndLawEducationHKII: "",
        artHKII:"",
        admissionsIndustry: "",
        admissionsIndustry2: "",
        admissionsIndustry3: "",
        methosIndustry: "",
        methosIndustry2: "",
        methosIndustry3: "",
        mathTHPT: "",
        physicsTHPT: "",
        chemistryTHPT: "",
        englishTHPT: "",
        frenchTHPT: "",
        literatureTHPT: "",
        historyTHPT: "",
        geographyTHPT: "",
        artTHPT: "",
        informationTechnologyTHPT: "",
        economicsAndLawEducationTHPT: "",
        biologicalTHPT:"",
        admissionsIndustryTHPT: "",
        admissionsIndustryTHPT2: "",
        admissionsIndustryTHPT3: "",
        methosIndustryTHPT: "",
        methosIndustryTHPT2: "",
        methosIndustryTHPT3: "",
        aptitudeTest: "",
        majorForAptitudeTest: "",
        majorForAptitudeTest2: "",
        majorForAptitudeTest3: "",
        majorForUmt: "",
        majorForUmt2: "",
        majorForUmt3: "",
        ielts: "",
        toefl: "",
        toeic: "",
        typeIsCert: '',
        files: [],
        subjectpoint: JSON.parse(JSON.stringify(subjectpoint)),
        subjectpoint2: JSON.parse(JSON.stringify(subjectpoint)),
        subjectpoint3: JSON.parse(JSON.stringify(subjectpoint)),
        formOfMethod: "THPT",
        hasEnglishCert: false,
        englishCertType: '',
        englishCertScore: '',
        toeicLRScore: '',
        toeicSWScore: '',
        englishCertDate: '',
        hasIncentiveOther: false,
        mosWordScore: '',
        mosExcelScore: '',
        mosPPTScore: '',
        jlptLevel: '',
        hskLevel: '',
        topikLevel: '',
        delfTcfLevel: '',
        vstepLevel: '',
        aptisLevel: '',
        hasOtherCert: false,
        otherIntCertType: '',
        otherIntCertScore: '',
        // Method 5 (Equivalent Degree)
        pt05mathTHPT: '',
        pt05physicsTHPT: '',
        pt05chemistryTHPT: '',
        pt05englishTHPT: '',
        pt05frenchTHPT: '',
        pt05literatureTHPT: '',
        pt05historyTHPT: '',
        pt05geographyTHPT: '',
        pt05artTHPT: '',
        pt05informationTechnologyTHPT: '',
        pt05economicsAndLawEducationTHPT: '',
        pt05biologicalTHPT: '',
        tcCriteria: '',
        tc01AverageGrade12: '',
        sat: '',
        satDate: '',
        actScore: '',
        actDate: '',
        formOfMethodMethod5: '',
        // Method 6 (VSAT)
        dgnlHN_math: "",
        dgnlHN_physics: "",
        dgnlHN_chemistry: "",
        dgnlHN_biology: "",
        dgnlHN_history: "",
        dgnlHN_geography: "",
        dgnlHN_english: "",
        dgnlHN_literature: "",
        majorDGNL_HN: "",
        majorDGNL_HN2: "",
        majorDGNL_HN3: "",
        isUseEnglish1: true,
        isUseEnglish2: true,
        isUseEnglish3: true,
      }
      if(props.isEdit) {
        adCode.value = props.dataAdm.adRegister?.adCode
        idAdReg.value = props.dataAdm.adRegister?.id
        if(!idAdReg.value && props.dataAdm.adMajors) {
          idAdReg.value = props.dataAdm.adMajors[0]?.idAdReg

        }
      }
      else {
        adCode.value = undefined
        idAdReg.value = undefined
        fizeSize.value = undefined
      }
      
      Dropzone.autoDiscover = false;
      if (Dropzone.instances.length > 0) {
          Dropzone.instances.forEach((e: any) => {
            e.off();
            e.destroy();
          });
      }
      if(checkPermission([Permission.ADMISSION_REGISTER_ATTACHMENT,Permission.ADMISSION_REGISTER])){
        let myDropzone = new Dropzone("#id_dropzone", { 
          url:`${process.env.VUE_APP_API_URL}/admission/file`,
          dictDefaultMessage: "Nhấn vào đây để tải tệp đính kèm lên",
          dictFileTooBig: "Kích thước tệp quá lớn. Tối đa 6MB",
          dictMaxFilesExceeded: "Bạn chỉ được upload tối đa 20 files",
          maxFilesize: 6,
          maxFiles: 20,
          addRemoveLinks: true,
          acceptedFiles: `.heic,image/*, application/pdf,
                            application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, 
                            application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, 
                            application/x-zip-compressed`,
          uploadprogress: function(file, progress, bytesSent) {
            if (file.previewElement) {
              var progressElement = document.querySelector(".data-dz-uploadprogress") as any;
              if(progressElement && progressElement.style) {
                progressElement.style.width = progress + "%";
              }
            }
          },
          sending: function(file, xhr, formData) {
            let mockFile = {
              file: {
                  name: '',
                  url: ''
              },
              actions: true,
              size: file.size,
              date:  '',
              type: file.type,
              id: file.upload.uuid,
              processing: true,
              label: tabFile as any,
            }
            tableData.value.push(mockFile)
          },
          init: function () {
            var startUpload = document.getElementById("uploadFiles");
            myDropzone = this;
            myDropzone.removeAllFiles()
            if(props.isEdit) {
              document.querySelectorAll(".dz-preview").forEach(e => e.remove());
              props.dataAdm.adFiles?.forEach(file => {
                let mockFile = {
                  file: {
                    name: file.fileName,
                    url: file.filePath
                  },
                  actions: true,
                  type: file.fileType,
                  size: file.fileSize,
                  date: moment(file.createdAt).format('DD/MM/YYYY'),
                  id: file.id,
                  label: file.label
                }
                tableData.value.push(mockFile)
              })
            } 
            startUpload?.addEventListener("click", function (file) {
              //console.log('file',file)
              //myDropzone.processQueue();
                
            });
            async function convertHEICtoJPG(file) {
            return new Promise(async (resolve, reject) => {
              try {
                const blob = await heic2any({
                  blob: file,
                  toType: "image/jpeg",
                });
                resolve(blob);
              } catch (error) {
                reject(error);
              }
            });
          }
          this.on("addedfile", async function (file) {
            if (file.name.endsWith(".heic") || file.name.endsWith(".HEIC")) {
              const jpgBlob = await convertHEICtoJPG(file) as any;
              const jpgFile = new File([jpgBlob], file.name.replace(".heic", ".jpg"), { type: "image/jpeg" });

              // Xóa file HEIC khỏi Dropzone
              myDropzone.removeFile(file);

              // Thêm file JPG vào Dropzone
              myDropzone.addFile(jpgFile);
            }
          });
            this.on("removedfile",async function (file) {
              if(file && file.fileName) {
                await axios.delete(`/admission/file/${file.fileName}`)
                let index = tableData.value.findIndex(item=> item.fileName == file.fileName)
                tableData.value.splice(index, 1)
              }
            });
            this.on("success",function (file, response) {
              file.fileName = response.successFiles[0]?.fileName
              pushFileLocal(response,file.upload.uuid)
            })
          }
        });
      }
      else if(props.isEdit) {
        props.dataAdm.adFiles.forEach(file => {
          let mockFile = {
            file: {
              name: file.fileName,
              url: file.filePath
            },
            actions: true,
            type: file.fileType,
            size: file.fileSize,
            date: moment(file.createdAt).format('DD/MM/YYYY'),
            id: file.id,
            label: file.label
          }
          //console.log('mockFile',mockFile)
          tableData.value.push(mockFile)
        })
      }
      
      formData.value = temp
      // Tạo LIÊN THÔNG: đặt method = 9 để KHÔNG khớp bất kỳ section PT thường nào
      // (v-if="formData.method == 1..6") -> ẩn hẳn khối Điểm THPT + Ngành đăng ký xét tuyển.
      if (props.articulationCreate) formData.value.method = 9
      formRef?.value.resetFields()
      // Đặt LẠI mặc định SAU resetFields (resetFields đưa field về initial rỗng):
      // Ngày tạo = hôm nay; Đợt = đợt hiện tại (nếu /phase/item/current đã tải xong)
      formData.value.createdAt = new Date()
      if (defaultPhaseId.value && !formData.value.phase) formData.value.phase = defaultPhaseId.value
    }
    function pushFileLocal(response,id = null) {
      if(id) {
        let index = tableData.value.findIndex(item=> item.id == id)
        tableData.value.splice(index, 1)
      }
      let mockFile = {
        file: {
          name: response.successFiles[0]?.fileName,
          url: response.successFiles[0]?.filePath
        },
        actions: true,
        type: response.successFiles[0]?.fileType,
        size: response.successFiles[0]?.fileSize,
        date:  moment(response.successFiles[0]?.createdAt).format('DD/MM/YYYY'),
        id: response.successFiles[0]?.id,
        label: response.successFiles[0]?.label as any
      }
      tableData.value.push(mockFile)
      reinitializeComponents();
    }
    const arrMajors2 = computed(() => {
      let tempMajors = JSON.parse(JSON.stringify(arrMajors.value))
      return tempMajors.filter(item => item.value != formData.value.admissionsIndustry)
    });
    const arrMajors3 = computed(() => {
      let tempMajors = JSON.parse(JSON.stringify(arrMajors.value))
      return tempMajors.filter(item => item.value != formData.value.admissionsIndustry && item.value != formData.value.admissionsIndustry2)
    });
    const arrMajorsTHPT2 = computed(() => {
      let tempMajors = JSON.parse(JSON.stringify(arrMajors.value))
      return tempMajors.filter(item => item.value != formData.value.admissionsIndustryTHPT)
    });
    const arrMajorsTHPT3 = computed(() => {
      let tempMajors = JSON.parse(JSON.stringify(arrMajors.value))
      return tempMajors.filter(item => item.value != formData.value.admissionsIndustryTHPT && item.value != formData.value.admissionsIndustryTHPT2)
    });
    const arrMajorsForAptitudeTest2 = computed(() => {
      let tempMajors = JSON.parse(JSON.stringify(arrMajors.value))
      return tempMajors.filter(item => item.value != formData.value.majorForAptitudeTest)
    });
    const arrMajorsForAptitudeTest3 = computed(() => {
      let tempMajors = JSON.parse(JSON.stringify(arrMajors.value))
      return tempMajors.filter(item => item.value != formData.value.majorForAptitudeTest && item.value != formData.value.majorForAptitudeTest2)
    });
    const arrMajorsForUmt = computed(() => {
      let tempMajors = JSON.parse(JSON.stringify(arrMajors.value)) as [{code:string[], value:string,label:string}]
      let majors:any = []
      if(formData.value.typeIsCert == 'isInternationalCertificate') {
        majors = ['7340101','7340115','7340116','7340120','7320104']
      }
      if(formData.value.typeIsCert == 'isAthleteCertOrPreMaster') {
        majors = ['7480201','7340101','7340115','7340116','7340120','7320104']
      }
      return tempMajors.filter(item => !majors.includes(item.value) )
    });
    const arrMajorsForUmt2 = computed(() => {
      let tempMajors = arrMajorsForUmt.value as [{code:string[], value:string,label:string}]
      return tempMajors.filter(item => item.value != formData.value.majorForUmt)
    });
    const arrMajorsForUmt3 = computed(() => {
      let tempMajors = arrMajorsForUmt2.value as [{code:string[], value:string,label:string}]
      return tempMajors.filter(item => item.value != formData.value.majorForUmt2)
    });
    const rules = ref({
      method: [
        {
          required: true,
          message: "Vui lòng điền trường này",
          trigger: "change",
        },
      ],
      majorForUmt: [
        {
          required: true,
          message: "Vui lòng điền trường này",
          trigger: "change",
        },
      ],
      aptitudeTest: [
        {
          required: true,
          message: "Vui lòng điền trường này",
          trigger: "change",
        },
      ],
      majorForAptitudeTest: [
        {
          required: true,
          message: "Vui lòng điền trường này",
          trigger: "change",
        },
      ],
      
      typeIsCert: [
        {
          required: true,
          message: "Vui lòng điền trường này",
          trigger: "change",
        },
      ],
      createdAt: [
        {
          required: true,
          message: "Vui lòng điền trường này",
          trigger: "change",
        },
      ],
      admissionsIndustry: [
        {
          required: true,
          message: "Vui lòng điền trường này",
          trigger: "change",
        },
      ],
      admissionsIndustryTHPT: [
        {
          required: true,
          message: "Vui lòng điền trường này",
          trigger: "change",
        },
      ],
      methosIndustry: [
        {
          required: true,
          message: "Vui lòng điền trường này",
          trigger: "change",
        },
      ],
      methosIndustryTHPT: [
        {
          required: true,
          message: "Vui lòng điền trường này",
          trigger: "change",
        },
      ],
      formOfMethodMethod5: [
        {
          required: true,
          message: "Vui lòng chọn tiêu chí",
          trigger: "change",
        },
      ],
      source: [
        {
          required: true,
          message: "Vui lòng chọn nguồn",
          trigger: "change",
        },
      ],
      phase: [
        {
          required: true,
          message: "Vui lòng chọn đợt xét tuyển",
          trigger: "change",
        },
      ],
    });
    const textFile = ref([
      {
        id: 1,
        label:'',
        value: ['CMND/CCCD', 
                'Học bạ THPT',
                'Bằng tốt nghiệp THPT/Giấy chứng nhận tốt nghiệp THPT tạm thời (Nếu có)']
      },
      {
        id: 2,
        label:'',
        value: ['CMND/CCCD', 
                'Phiếu điểm thi Đánh giá năng lực ĐHQG Tp.HCM', 
                'Bằng tốt nghiệp THPT/Giấy chứng nhận tốt nghiệp THPT tạm thời (Nếu có)']
        
      },
      {
        id: 3,
        label: '',
        value: ['CMND/CCCD.',
                'Chứng chỉ/Chứng nhận/Văn bằng tương ứng hoặc học bạ THPT',
                'Bằng tốt nghiệp THPT/Giấy chứng nhận tốt nghiệp THPT tạm thời (Nếu có)']
      },
    ])
    const caculateIndustry = (item: any, key: any, prefix = "") => {
      let value = 0;
      let actualEnglish = 0;
      let hasEnglishKey = false;
      let check = false;

      // For Method 5 TC01, we might use pt05 prefix
      if (item[key] && Array.isArray(item[key])) {
        item[key].forEach((i: any) => {
          if (check) return;
          let fieldName = prefix ? prefix + i : i;
          
          if (i === 'englishTHPT' || i === 'englishHKII' || (prefix === 'pt05' && i === 'englishTHPT')) {
            hasEnglishKey = true;
            actualEnglish = +formData.value[fieldName] || 0;
          }
          
          if (formData.value[fieldName] || formData.value[fieldName] === 0) {
            value += +formData.value[fieldName];
          } else {
            value = 0;
            check = true;
          }
        });
      }

      // 2026 Smart Selection logic for English Cert
      if (hasEnglishKey && (formData.value.method == 4 || formData.value.method == 1 || formData.value.method == 5)) {
        if (!check && value > 0) {
          const best = calculateBestTotal(value, actualEnglish, true);
          return Number(best.sum.toFixed(1));
        }
      }

      if (item.code == '3YS') {
        if (+formData.value.all10 && +formData.value.all11 && +formData.value.all12) {
          value = (+formData.value.all10) + (+formData.value.all11) + (+formData.value.all12);
        }
      }
      if (item.code == '5HK') {
        if (+formData.value.all10 && +formData.value.all11 && +formData.value.hki12) {
          value = (+formData.value.all10) + (+formData.value.all11) + (+formData.value.hki12);
        }
      }
      
      return +value.toFixed(1);
    }

    const englishCertResult = computed(() => {
      const type = formData.value.englishCertType;
      const score = +formData.value.englishCertScore;
      const date = formData.value.englishCertDate;
      const hasCert = formData.value.hasEnglishCert;

      if (!hasCert || !type) return { convertedScore: 0, bonusPoints: 0, valid: false };

      let scoreValid = false;
      if (type === 'TOEIC') {
        const lr = +formData.value.toeicLRScore;
        const sw = +formData.value.toeicSWScore;
        if (lr > 0 || sw > 0) scoreValid = true;
      } else if (score > 0) {
        scoreValid = true;
      }

      if (!scoreValid) return { convertedScore: 0, bonusPoints: 0, valid: false };

      let valid = true;
      if (date) {
        const expiryDate = new Date(date);
        const limitDate = new Date('2026-10-30');
        if (expiryDate < limitDate) valid = false;
      }
      if (!valid) return { convertedScore: 0, bonusPoints: 0, valid: false };

      let convertedScore = 0;
      if (type === 'IELTS') {
        if (score >= 7.0) convertedScore = 10.0;
        else if (score >= 6.5) convertedScore = 9.5;
        else if (score >= 6.0) convertedScore = 9.0;
        else if (score >= 5.5) convertedScore = 8.0;
        else if (score >= 5.0) convertedScore = 7.0;
        else if (score >= 4.5) convertedScore = 6.0;
        else if (score >= 4.0) convertedScore = 5.0;
      } else if (type === 'TOEIC') {
        const lr = +formData.value.toeicLRScore;
        const sw = +formData.value.toeicSWScore;
        
        let lrConverted = 0;
        if (lr >= 835) lrConverted = 10.0;
        else if (lr >= 785) lrConverted = 9.5;
        else if (lr >= 685) lrConverted = 9.0;
        else if (lr >= 570) lrConverted = 8.0;
        else if (lr >= 450) lrConverted = 7.0;
        else if (lr >= 365) lrConverted = 6.0;
        else if (lr >= 340) lrConverted = 5.0;

        let swConverted = 0;
        if (sw >= 312) swConverted = 10.0;
        else if (sw >= 292) swConverted = 9.5;
        else if (sw >= 262) swConverted = 9.0;
        else if (sw >= 242) swConverted = 8.0;
        else if (sw >= 232) swConverted = 7.0;
        else if (sw >= 202) swConverted = 6.0;
        else if (sw >= 180) swConverted = 5.0;

        convertedScore = Math.min(lrConverted, swConverted);
      } else if (type === 'TOEFL iBT') {
        if (score >= 5.5) convertedScore = 10.0;
        else if (score >= 5.0) convertedScore = 9.5;
        else if (score >= 4.5) convertedScore = 9.0;
        else if (score >= 4.0) convertedScore = 8.0;
        else if (score >= 3.5) convertedScore = 7.0;
        else if (score >= 3.0) convertedScore = 6.0;
        else if (score >= 2.5) convertedScore = 5.0;
      } else if (type === 'PTE') {
        if (score >= 63) convertedScore = 10.0;
        else if (score >= 55) convertedScore = 9.5;
        else if (score >= 47) convertedScore = 9.0;
        else if (score >= 39) convertedScore = 8.0;
        else if (score >= 31) convertedScore = 7.0;
        else if (score >= 24) convertedScore = 6.0;
        else if (score >= 20) convertedScore = 5.0;
      }
      return { convertedScore, bonusPoints: 0, valid: true };
    });

    const certIncentiveResult = computed(() => {
      const getBonus = (excludeEnglish = false) => {
        let maxBonus = 0;
        const limitBonus = 1.5;
        const limitDate = new Date('2026-10-30');

        const isValidDate = (dateStr) => {
          if (!dateStr) return true;
          return new Date(dateStr) >= limitDate;
        };

        // 1. English Certificate (skip if excluded)
        if (!excludeEnglish && formData.value.hasEnglishCert) {
          const type = formData.value.englishCertType;
          const score = +formData.value.englishCertScore;
          const date = formData.value.englishCertDate;
          
          if (isValidDate(date)) {
            let englishBonus = 0;
            if (type === 'IELTS') {
              if (score >= 7.0) englishBonus = 1.5;
              else if (score >= 6.0) englishBonus = 1.0;
              else if (score >= 5.0) englishBonus = 0.5;
            } else if (type === 'TOEIC') {
              const lrScore = +formData.value.toeicLRScore;
              const swScore = +formData.value.toeicSWScore;
              let lrLevel = lrScore >= 835 ? 1.5 : (lrScore >= 700 ? 1.0 : (lrScore >= 480 ? 0.5 : 0));
              let swLevel = swScore >= 312 ? 1.5 : (swScore >= 262 ? 1.0 : (swScore >= 232 ? 0.5 : 0));
              englishBonus = Math.min(lrLevel, swLevel);
            } else if (type === 'TOEFL iBT') {
              if (score >= 5.0) englishBonus = 1.5;
              else if (score >= 4.0) englishBonus = 1.0;
              else if (score >= 3.0) englishBonus = 0.5;
            } else if (type === 'PTE') {
              if (score >= 63) englishBonus = 1.5;
              else if (score >= 47) englishBonus = 1.0;
              else if (score >= 31) englishBonus = 0.5;
            }
            maxBonus = Math.max(maxBonus, englishBonus);
          }
        }

        // 1b. VSTEP, Aptis (English - also skip if excluded)
        if (!excludeEnglish && formData.value.hasIncentiveOther) {
          if (formData.value.vstepLevel) {
            let b = formData.value.vstepLevel === 'Bậc 5(C1)' ? 1.5 : (formData.value.vstepLevel === 'Bậc 4' ? 1.0 : 0.5);
            maxBonus = Math.max(maxBonus, b);
          }
          if (formData.value.aptisLevel) {
            let b = formData.value.aptisLevel === 'C1' ? 1.5 : (formData.value.aptisLevel === 'B2' ? 1.0 : 0.5);
            maxBonus = Math.max(maxBonus, b);
          }
        }

        // 2. Other Incentive Certs (MOS, Languages, Other International)
        if (formData.value.hasIncentiveOther) {
          // MOS - cần cả 3 đều >= 700
          const word = +formData.value.mosWordScore;
          const excel = +formData.value.mosExcelScore;
          const ppt = +formData.value.mosPPTScore;
          if (word >= 700 && excel >= 700 && ppt >= 700) {
            const minScore = Math.min(word, excel, ppt);
            let mosBonus = minScore >= 900 ? 1.5 : (minScore >= 800 ? 1.0 : 0.5);
            maxBonus = Math.max(maxBonus, mosBonus);
          }

          // Other Languages
          if (formData.value.jlptLevel) {
            let b = formData.value.jlptLevel === 'N2' ? 1.5 : (formData.value.jlptLevel === 'N3' ? 1.0 : 0.5);
            maxBonus = Math.max(maxBonus, b);
          }
          if (formData.value.hskLevel) {
            let b = (formData.value.hskLevel === 'HSK 5' || formData.value.hskLevel === 'HSK 6' || formData.value.hskLevel === '6' || formData.value.hskLevel === '5') ? 1.5 : (formData.value.hskLevel === 'HSK 4' || formData.value.hskLevel === '4' ? 1.0 : 0.5);
            maxBonus = Math.max(maxBonus, b);
          }
          if (formData.value.topikLevel) {
            let b = (formData.value.topikLevel === '6' || formData.value.topikLevel === '5' || formData.value.topikLevel === 'C1' || formData.value.topikLevel === 'TOPIK 5' || formData.value.topikLevel === 'TOPIK 6') ? 1.5 : (formData.value.topikLevel === 'B2' || formData.value.topikLevel === 'TOPIK 4' ? 1.0 : 0.5);
            maxBonus = Math.max(maxBonus, b);
          }
          if (formData.value.delfTcfLevel) {
            let b = formData.value.delfTcfLevel === 'C1' ? 1.5 : (formData.value.delfTcfLevel === 'B2' ? 1.0 : 0.5);
            maxBonus = Math.max(maxBonus, b);
          }

          // Other International Certs
          if (formData.value.hasOtherCert && formData.value.otherIntCertType) {
            maxBonus = Math.max(maxBonus, 1.5);
          }
        }

        return Math.min(maxBonus, limitBonus);
      };

      return {
        total: getBonus(false),
        excludeEnglish: getBonus(true)
      };
    });

    const PScore = computed(() => {
      // console.log('props.priorityScore',props.priorityScore)
      return props.priorityScore||0
    });

    function cacuPointPriority(value) {
      if (!value || value <= 0) return 0;
      let p = +(PScore.value || 0);
      if (p <= 0) return 0;

      if (value < 22.5) {
        return Number(p.toFixed(2));
      } else {
        let res = ((30 - value) / 7.5) * p;
        return res > 0 ? Number(res.toFixed(2)) : 0;
      }
    }

    function cacuTotalBonus(baseScore, isConverted) {
      if (baseScore <= 0) return 0;
      const incentive = isConverted ? (certIncentiveResult.value as any).excludeEnglish : (certIncentiveResult.value as any).total;
      const priority = cacuPointPriority(baseScore + incentive);
      return Number((priority + incentive).toFixed(2));
    }

    function calculateBestTotal(baseValue: number, actualEnglish: number, isEnglishInCombo: boolean, priorityIndex: number = 1) {
      const convRes = englishCertResult.value;
      const incentivePoints = certIncentiveResult.value;

      // Kiểm tra checkbox thủ công isUseEnglishX dựa trên priorityIndex
      const isManualUseEnglish = priorityIndex === 3 ? formData.value.isUseEnglish3 : (priorityIndex === 2 ? formData.value.isUseEnglish2 : formData.value.isUseEnglish1);

      // Nếu tổ hợp KHÔNG có Tiếng Anh -> Không áp dụng quy đổi, lấy điểm khuyến khích bình thường
      if (!isEnglishInCombo) {
        const incentive = incentivePoints.total;
        const pScoreNew = cacuPointPriority(baseValue + incentive);
        return { 
          total: +(baseValue + incentive + pScoreNew).toFixed(2), 
          usedConversion: false, 
          incentiveScore: incentive, 
          priorityScoreNew: pScoreNew,
          englishConvertedScore: 0,
          sum: baseValue 
        };
      }

      // Nếu tổ hợp CÓ Tiếng Anh
      // Nếu không có chứng chỉ hoặc chứng chỉ không hợp lệ hoặc người dùng tắt thủ công
      // -> lấy điểm thi thật và giữ điểm khuyến khích
      if (!convRes.valid || !isManualUseEnglish) {
        const incentive = incentivePoints.total;
        const pScoreNew = cacuPointPriority(baseValue + incentive);
        return { 
          total: +(baseValue + incentive + pScoreNew).toFixed(2), 
          usedConversion: false, 
          incentiveScore: incentive, 
          priorityScoreNew: pScoreNew,
          englishConvertedScore: 0, 
          sum: baseValue 
        };
      }

      // Có chứng chỉ Tiếng Anh hợp lệ
      if (convRes.convertedScore > actualEnglish) {
        // Điểm quy đổi cao hơn -> dùng điểm quy đổi, điểm khuyến khích = 0
        const sum1 = baseValue - actualEnglish + convRes.convertedScore;
        const incentive = 0;
        const pScoreNew1 = cacuPointPriority(sum1 + incentive);
        return { 
          total: +(sum1 + incentive + pScoreNew1).toFixed(2), 
          usedConversion: true, 
          incentiveScore: incentive, 
          priorityScoreNew: pScoreNew1,
          englishConvertedScore: convRes.convertedScore, 
          sum: sum1 
        };
      } else {
        // Điểm thi thật >= điểm quy đổi -> lấy điểm thi thật, VẪN được cộng điểm khuyến khích
        const sum2 = baseValue;
        const incentive = incentivePoints.total;
        const pScoreNew2 = cacuPointPriority(sum2 + incentive);
        return { 
          total: +(sum2 + incentive + pScoreNew2).toFixed(2), 
          usedConversion: false, 
          incentiveScore: incentive, 
          priorityScoreNew: pScoreNew2,
          englishConvertedScore: 0, 
          sum: sum2 
        };
      }
    }
    function getComboExtraBonus(baseSum, comboCode) {
      if (!baseSum || !comboCode) return 0;
      let item = arrIndustry.value.find((i: any) => i.code === comboCode);
      if (!item) return 0;
      
      let method = formData.value.method;
      let prefix = (method == 5 || (method == 4 && formData.value.formOfMethod == 'TC01')) ? 'pt05' : '';
      let suffix = (method == 1) ? 'HKII' : ''; // Đặc thù cho học bạ lớp 12
      let subjects = (method == 4 || method == 1 || method == 5) ? item['subjectthpt'] : item['subjecthk2'];
      
      let actualEnglish = 0;
      let hasEnglish = false;
      let originalSum = 0;
      let check = false;

      if (Array.isArray(subjects)) {
        subjects.forEach((i: any) => {
          if (check) return;
          // Chuyển đổi tên môn sang field tương ứng trong formData
          // VD: mathTHPT -> mathHKII nếu là học bạ
          let baseSubject = i.replace('THPT', '').replace('HKII', '');
          let fieldName = prefix ? prefix + i : (suffix ? baseSubject + suffix : i);
          
          if (i.toLowerCase().includes('english')) {
            hasEnglish = true;
            actualEnglish = +formData.value[fieldName] || 0;
          }
          if (formData.value[fieldName] || formData.value[fieldName] === 0) originalSum += +formData.value[fieldName]
          else { check = true; }
        });
      }

      if (check || originalSum === 0) return 0;

      const best = calculateBestTotal(originalSum, actualEnglish, hasEnglish);
      return best.incentiveScore;
    }

    function finalScoreWithCertBonus(baseVal, comboCode) {
      if (!baseVal || !comboCode) return baseVal || 0;
      let item = arrIndustry.value.find((i: any) => i.code === comboCode);
      if (!item) return baseVal;

      let method = formData.value.method;
      let prefix = (method == 5 || (method == 4 && formData.value.formOfMethod == 'TC01')) ? 'pt05' : '';
      let suffix = (method == 1) ? 'HKII' : '';
      let subjects = (method == 4 || method == 1 || method == 5) ? item['subjectthpt'] : item['subjecthk2'];
      
      let actualEnglish = 0;
      let hasEnglish = false;
      let originalSum = 0;
      let check = false;

      if (Array.isArray(subjects)) {
        subjects.forEach((i: any) => {
          if (check) return;
          let baseSubject = i.replace('THPT', '').replace('HKII', '');
          let fieldName = prefix ? prefix + i : (suffix ? baseSubject + suffix : i);

          if (i.toLowerCase().includes('english')) {
            hasEnglish = true;
            actualEnglish = +formData.value[fieldName] || 0;
          }
          if (formData.value[fieldName] || formData.value[fieldName] === 0) originalSum += +formData.value[fieldName]
          else { check = true; }
        });
      }

      if (check || originalSum === 0) return baseVal;

      const best = calculateBestTotal(originalSum, actualEnglish, hasEnglish);
      return best.total.toFixed(2);
    }

    const arrGPAIndustry = computed(() => {
      let tempArr = arrIndustry.value.map((i: any) => {
        let temp = {
          code: i.code,
          value: caculateIndustry(i,'subjecthk2'),
        } as any
        return temp
      })
      return tempArr
    });
    const arrGPAIndustryTHPT = computed(() => {
      let tempArr = arrIndustry.value.map((i: any) => {
        let prefix = formData.value.method == 5 ? 'pt05' : '';
        let temp = {
          code: i.code,
          value: caculateIndustry(i,'subjectthpt', prefix),
        }
        return temp
      })
      return tempArr
    });

    const arrMethosIndustryTHPT = computed(() => {
      let admissionsIndustry = formData.value.admissionsIndustryTHPT
      let tempMajors = JSON.parse(JSON.stringify(arrMajors.value))
      let arrCode = tempMajors.filter(i =>i.value == admissionsIndustry)[0]?.code
      let temp:{ value: string, label: string }[] = arrCode ? arrIndustry.value.filter(i=>arrCode?.includes(i.value)) : arrIndustry.value
      let arr: Array<string> = []
      arrGPAIndustryTHPT.value.forEach(item => {
        if(item.value != 0)
          arr.push(item.code)
      })
      let obj = temp.filter(item => arr.includes(item.value))
      if(admissionsIndustry && userSelectTHPT.value) {
        methosIndustryAutoChangeTHPT()
      }
      return obj
    });

    const arrMethosIndustryTHPT2 = computed(() => {
      let admissionsIndustry = formData.value.admissionsIndustryTHPT2
      let tempMajors = JSON.parse(JSON.stringify(arrMajors.value))
      let arrCode = tempMajors.filter(i =>i.value == admissionsIndustry)[0]?.code
      let temp:{ value: string, label: string }[] = arrCode ? arrIndustry.value.filter(i=>arrCode?.includes(i.value)) : arrIndustry.value
      let arr: Array<string> = []
      arrGPAIndustryTHPT.value.forEach(item => {
        if(item.value != 0)
          arr.push(item.code)
      })
      let obj = temp.filter(item => arr.includes(item.value))
      if(admissionsIndustry && userSelectTHPT.value) {
        methosIndustryAutoChangeTHPT()
      }
      return obj
    });

    const arrMethosIndustryTHPT3 = computed(() => {
      let admissionsIndustry = formData.value.admissionsIndustryTHPT3
      let tempMajors = JSON.parse(JSON.stringify(arrMajors.value))
      let arrCode = tempMajors.filter(i =>i.value == admissionsIndustry)[0]?.code
      let temp:{ value: string, label: string }[] = arrCode ? arrIndustry.value.filter(i=>arrCode?.includes(i.value)) : arrIndustry.value
      let arr: Array<string> = []
      arrGPAIndustryTHPT.value.forEach(item => {
        if(item.value != 0)
          arr.push(item.code)
      })
      let obj = temp.filter(item => arr.includes(item.value))
      if(admissionsIndustry && userSelectTHPT.value) {
        methosIndustryAutoChangeTHPT()
      }
      return obj
    });
    
    const arrIndustry = ref<any>([])
    const statusTag =  ref(statusTagDefault)
    const admissionsIndustryChangeTHPT = (event: string) => {
      if (formData.value.admissionsIndustryTHPT2 == event) {
        formData.value.admissionsIndustryTHPT2 = ""
        formData.value.methosIndustryTHPT2 = ""
      }
      if (formData.value.admissionsIndustryTHPT3 == event) {
        formData.value.admissionsIndustryTHPT3 = ""
        formData.value.methosIndustryTHPT3 = ""
      }
      if (arrMajors.value.length != 0 && event) {
        let maxGPA = maxGPAIndustryTHPT(event)
        let value = maxGPA ? maxGPA.code : undefined
        formData.value.methosIndustryTHPT = value ? value : ""
      }
      if (!event) {
        formData.value.methosIndustryTHPT = ""
      }
      userSelectTHPT.value = false
    }

    const admissionsIndustryChangeTHPT2 = (event: string) => {
      if (formData.value.admissionsIndustryTHPT3 == event) {
        formData.value.admissionsIndustryTHPT3 = ""
        formData.value.methosIndustryTHPT3 = ""
      }
      if (arrMajorsTHPT2.value.length != 0 && event) {
        let maxGPA = maxGPAIndustryTHPT(event)
        let value = maxGPA ? maxGPA.code : undefined
        formData.value.methosIndustryTHPT2 = value ? value : ""
      }
      if (!event) {
        formData.value.methosIndustryTHPT2 = ""
      }
      userSelectTHPT.value = false
    }

    const admissionsIndustryChangeTHPT3 = (event: string) => {
      if (arrMajorsTHPT3.value.length != 0 && event) {
        let maxGPA = maxGPAIndustryTHPT(event)
        let value = maxGPA ? maxGPA.code : undefined
        formData.value.methosIndustryTHPT3 = value ? value : ""
      }
      userSelectTHPT.value = false
    }

    const methosIndustryManualChangeTHPT = () => {
      userSelectTHPT.value = false
    }
    const methosIndustryAutoChangeTHPT = () => {
      userSelectTHPT.value = true
    }

    const methosIndustryManualChange = () => {
      userSelect.value = false
    }
    const methosIndustryAutoChange = (event, number?: any) => {
      if(formData.value.formOfMethod == '9CR') {
        const resetDataPoint = {
          point0: '',
          point1: '',
          point2: '',
        }
        const emptySlot = () => ({
          adForm: '',
          type: '',
          label: '',
          data: JSON.parse(JSON.stringify(resetDataPoint))
        })

        // Xác định key của subjectpoint tương ứng với ngành 1, 2, 3
        const targetKey = !number ? 'subjectpoint' : (number == '2' ? 'subjectpoint2' : 'subjectpoint3')
        const otherKeys = ['subjectpoint', 'subjectpoint2', 'subjectpoint3'].filter(k => k !== targetKey)

        // Nếu không có event (xóa chọn tổ hợp), reset subjectpoint của ngành đó
        if (!event) {
          formData.value[targetKey] = [emptySlot(), emptySlot(), emptySlot()]
          clearScoreDirty(targetKey) // slot đổi -> các ô đã gõ của NV này không còn giá trị theo dõi
          userSelect.value = false
          return
        }

        const temp = renderSubject(event)

        // Guard: temp phải là mảng hợp lệ mới tiến hành gán dữ liệu
        if (!Array.isArray(temp) || temp.length === 0) return

        // Reset slots trước khi gán mới (tránh dữ liệu cũ còn sót lại)
        formData.value[targetKey] = [emptySlot(), emptySlot(), emptySlot()]
        clearScoreDirty(targetKey)

        temp.forEach((subjectType, index) => {
          if (index >= formData.value[targetKey].length) return

          // Điền đầy đủ adForm, type, label cho mỗi môn trong tổ hợp
          formData.value[targetKey][index].adForm = '9CR'
          formData.value[targetKey][index].type = subjectType
          formData.value[targetKey][index].label = renderTitleSubject(subjectType)

          // Tái sử dụng data điểm từ các ngành khác nếu cùng môn
          let record: any = null
          for (const k of otherKeys) {
            const found = formData.value[k]?.find((f: any) => f.type == subjectType)
            if (found) { record = found; break }
          }
          formData.value[targetKey][index].data = record
            ? JSON.parse(JSON.stringify(record.data))
            : JSON.parse(JSON.stringify(resetDataPoint))
        })
        // Đổ điểm từ Bảng điểm học bạ cho các ô còn TRỐNG (đổi tổ hợp tay vẫn tự có điểm; không phá ô đã nhập)
        fillSubjectpointFromTranscript(targetKey)
        userSelect.value = false
      } else {
        // Không phải 9CR: xử lý xóa cascading khi không có event
        if(number && !event) {
          formData.value[`admissionsIndustry${number}`] = ""
          if(number == '2') {
            formData.value.methosIndustry3 = ""
            formData.value.admissionsIndustry3 = ""
          }
        }
        userSelect.value = true
      }
    }

    // ===== PT2/9CR: Bảng điểm học bạ (students.transcript) — auto-chọn tổ hợp tốt nhất + đổ điểm =====
    // PTTK: umt-project-docs/.../PTTK_PT2_hoc_ba_auto_to_hop.md. Key môn của transcript = key trong admission_forms.subjectthpt.
    const studentTranscript = ref<any>(null)
    // Theo dõi TỪNG Ô điểm 9CR user thật sự gõ trong phiên — gate + phạm vi cho write-back.
    // (review 2026-07: boolean toàn cục không đủ — dính chéo giữa các hồ sơ mở nối tiếp trong cùng modal,
    //  và write-back phải chỉ ghi Ô USER SỬA, không phải mọi chênh lệch hồ sơ↔bảng điểm)
    const dirtyScoreCells = ref<Set<string>>(new Set())
    // Kết quả lần ghi bảng điểm gần nhất khi Lưu — nối vào thông báo "Lưu thành công" cho user thấy rõ
    const transcriptSyncInfo = ref('')
    const markScoreDirty = (k: string, index: number, pointKey: string) => {
      dirtyScoreCells.value.add(`${k}|${index}|${pointKey}`)
    }
    const clearScoreDirty = (targetKey?: string) => {
      if (!targetKey) { dirtyScoreCells.value.clear(); return }
      Array.from(dirtyScoreCells.value).forEach((c) => {
        if (c.startsWith(targetKey + '|')) dirtyScoreCells.value.delete(c)
      })
    }
    const _transcriptStudentId = () =>
      props.idStudent || props.dataAdm?.adRegister?.idStudent || (route.params.id as any) || null
    const loadStudentTranscript = async () => {
      const sid = _transcriptStudentId()
      if (!sid) { studentTranscript.value = null; studentGradScore.value = null; return }
      await axios.get(`/admission/student/${sid}`)
        .then(({ data }) => {
          studentTranscript.value = (data && data.transcript && typeof data.transcript === 'object') ? data.transcript : null
          //Bảng điểm thi TN THPT mức student (mục 6 tab Thông tin học tập) — nguồn prefill PT1
          studentGradScore.value = (data && data.graduationscore && typeof data.graduationscore === 'object') ? data.graduationscore : null
        })
        .catch(() => { studentTranscript.value = null; studentGradScore.value = null })
    }
    onMounted(loadStudentTranscript)
    watch(() => [props.idStudent, props.dataAdm], loadStudentTranscript)

    // ===== PT1: Bảng điểm thi TN THPT (students.graduationscore) — prefill + write-back =====
    // Cùng nguyên tắc với transcript PT2/9CR: prefill CHỈ đổ Ô TRỐNG (không phá điểm hồ sơ cũ);
    // write-back CHỈ chạy khi user thật sự sửa điểm trong phiên (gradScoreDirty — set ở
    // methosIndustryAutoChangeTHPT, handler @change chung của các ô điểm THPT).
    const studentGradScore = ref<any>(null)
    const gradScoreDirty = ref(false)
    //Đúng 10 ô điểm ĐANG HIỂN THỊ ở form PT1 (Pháp/Vẽ đang v-if=false) — khớp bộ môn mục 6 tab Thông tin học tập
    const GRAD_SCORE_FIELDS = ['mathTHPT', 'literatureTHPT', 'englishTHPT', 'physicsTHPT', 'chemistryTHPT', 'biologicalTHPT', 'historyTHPT', 'geographyTHPT', 'informationTechnologyTHPT', 'economicsAndLawEducationTHPT']
    const GRAD_SCORE_LABELS: Record<string, string> = { mathTHPT: 'Toán', literatureTHPT: 'Văn', englishTHPT: 'Anh', physicsTHPT: 'Lý', chemistryTHPT: 'Hóa', biologicalTHPT: 'Sinh', historyTHPT: 'Sử', geographyTHPT: 'Địa', informationTechnologyTHPT: 'Tin', economicsAndLawEducationTHPT: 'KT&PL' }
    const fillTHPTFromGradScore = () => {
      const g = studentGradScore.value
      if (!g || Number(formData.value.method) !== 4) return
      GRAD_SCORE_FIELDS.forEach((f) => {
        const v = g[f]
        if (v === undefined || v === null || v === '') return
        const cur = formData.value[f]
        if (cur === '' || cur === null || cur === undefined) formData.value[f] = String(v)
      })
    }
    //đổ điểm khi: chọn PT1 lúc tạo hồ sơ / điểm student load xong mà form đang ở PT1
    watch(() => [formData.value.method, studentGradScore.value], () => { fillTHPTFromGradScore() })

    // Ghi NGƯỢC điểm thi hồ sơ PT1 về students.graduationscore + timeline, gọi khi lưu hồ sơ.
    // Baseline là bản MỚI NHẤT từ server; fetch fail -> HỦY (không PUT đè). Lỗi không chặn lưu hồ sơ.
    const syncGradScoreWriteBack = async () => {
      try {
        if (Number(formData.value.method) !== 4) return
        if (!gradScoreDirty.value) return //mở hồ sơ cũ chỉ bấm Lưu thì KHÔNG đụng bảng điểm
        const sid = _transcriptStudentId()
        if (!sid) return
        let base: any = null
        try {
          const { data } = await axios.get(`/admission/student/${sid}`)
          base = (data && data.graduationscore && typeof data.graduationscore === 'object') ? data.graduationscore : {}
        } catch (e) {
          console.log('syncGradScoreWriteBack: bỏ qua (không fetch được điểm thi mới nhất)')
          return
        }
        const g = JSON.parse(JSON.stringify(base))
        const diffs: string[] = []
        GRAD_SCORE_FIELDS.forEach((f) => {
          const pv = formData.value[f]
          if (pv === '' || pv === null || pv === undefined || isNaN(+pv)) return
          const n = Math.round(Math.min(10, Math.max(0, +pv)) * 100) / 100
          const old = g[f]
          if (old === undefined || old === null || old === '' || Math.round(+old * 100) !== Math.round(n * 100)) {
            g[f] = n
            diffs.push(`${GRAD_SCORE_LABELS[f] || f}: ${(old === undefined || old === null || old === '') ? '—' : old}→${n}`)
          }
        })
        if (diffs.length === 0) { studentGradScore.value = g; gradScoreDirty.value = false; return }
        await axios.put(`/admission/student/${sid}`, { graduationscore: g })
        studentGradScore.value = g
        gradScoreDirty.value = false
        const dataComment = {
          idUser: user()?.id,
          idStudent: sid,
          comment: `[TIMELINE] Cập nhật Bảng điểm thi TN THPT từ hồ sơ ${props.dataAdm?.adRegister?.profileCode || formData.value.profileCode || ''}: ${diffs.join('; ')}`,
        }
        await axios.post(`/admission/comment`, dataComment).catch(() => { /* timeline lỗi không chặn */ })
      } catch (e) {
        console.log('syncGradScoreWriteBack err', e)
      }
    }
    // Banner lệch điểm PT1: hồ sơ có điểm mà bảng điểm KHÁC hoặc CHƯA CÓ môn đó (làm tròn 2 lẻ).
    // Phải tính cả ô "bảng điểm chưa có" — user nhập thêm điểm vào môn trống mà không báo gì
    // thì họ không biết điểm sẽ được ghi về bảng điểm khi Lưu (feedback 2026-07).
    const gradScoreMismatch = computed(() => {
      if (Number(formData.value.method) !== 4) return false
      const g = studentGradScore.value
      if (!g) return false
      return GRAD_SCORE_FIELDS.some((f) => {
        const pv = formData.value[f]
        if (pv === '' || pv == null || isNaN(+pv)) return false
        const gv = g[f]
        if (gv === undefined || gv === null || gv === '') return true //hồ sơ có, bảng điểm chưa có
        return Math.round(+pv * 100) !== Math.round(+gv * 100)
      })
    })
    // Kéo điểm Bảng điểm thi VÀO hồ sơ (đè các ô bảng điểm có giá trị — user chủ động bấm)
    const syncFromGradScore = () => {
      const g = studentGradScore.value
      if (!g) return
      GRAD_SCORE_FIELDS.forEach((f) => {
        const v = g[f]
        if (v === undefined || v === null || v === '') return
        formData.value[f] = String(v)
      })
    }
    // Đẩy điểm hồ sơ RA bảng điểm thi (action trên banner khi user KHÔNG sửa trong phiên)
    const writeFormScoresToGradScore = async () => {
      const hasScore = GRAD_SCORE_FIELDS.some((f) => {
        const pv = formData.value[f]
        return pv !== '' && pv != null && !isNaN(+pv)
      })
      if (!hasScore) {
        Swal.fire({ text: 'Hồ sơ chưa có ô điểm thi nào để ghi vào bảng điểm.', icon: 'info', buttonsStyling: false, confirmButtonText: 'Đóng', customClass: { confirmButton: 'btn btn-primary' } })
        return
      }
      gradScoreDirty.value = true //mượn write-back chuẩn: baseline server mới nhất + timeline + clear dirty
      await syncGradScoreWriteBack()
      Swal.fire({ text: 'Đã ghi điểm thi vào Bảng điểm thi TN THPT.', icon: 'success', buttonsStyling: false, timer: 2000, timerProgressBar: true, showConfirmButton: false })
    }

    // Cảnh báo SỚM khi tạo hồ sơ: SV đã có 1 hồ sơ nguồn "online" trạng thái "new" -> backend chặn tạo trùng
    // online (createAdmission). Nạp danh sách hồ sơ SV để disable option "Trực tuyến" + hiện banner NGAY,
    // thay vì để user nhập hết rồi mới báo lỗi lúc Lưu. Chỉ chạy ở chế độ tạo (không fromProfile/sửa).
    // Đợt mặc định khi TẠO hồ sơ = đợt HIỆN TẠI (/phase/item/current). mounted() (Options) ghi vào ref này;
    // resetDataForm (setup) đọc lại — bắc cầu giữa Options data (arrPhase) và setup do file hybrid.
    const defaultPhaseId = ref<any>(null)
    const existingOnlineDraft = ref<any>(null)
    const loadExistingOnlineDraft = async () => {
      existingOnlineDraft.value = null
      if (props.fromProfile || props.isEdit) return
      const sid = _transcriptStudentId()
      if (!sid) return
      await axios.get(`/admission/register/student/${sid}`)
        .then(({ data }) => {
          existingOnlineDraft.value = (data || []).find((r: any) => r.source === 'online' && r.status === 'new' && !r.isDelete) || null
          // Nếu form đang chọn 'online' mà đã bị chặn -> bỏ chọn để user chọn nguồn khác
          if (existingOnlineDraft.value && formData.value.source === 'online') formData.value.source = ''
        })
        .catch(() => { existingOnlineDraft.value = null })
    }
    onMounted(loadExistingOnlineDraft)
    watch(() => [props.idStudent, props.isEdit], loadExistingOnlineDraft)

    // Điểm 9CR của 1 tổ hợp từ bảng điểm: (Σ 9 ô)/3. Thiếu BẤT KỲ ô nào -> null (loại khỏi so sánh — đã chốt).
    const combo9CRScoreFromTranscript = (comboCode: string): number | null => {
      const t = studentTranscript.value
      if (!t || !comboCode) return null
      const item = (arrIndustry.value as any[]).find((i: any) => i.code === comboCode)
      const subjects = item?.subjectthpt
      if (!Array.isArray(subjects) || subjects.length === 0) return null
      let sum = 0
      for (const key of subjects) {
        const rec = t[key]
        if (!rec) return null
        for (const y of ['c10', 'c11', 'c12']) {
          const v = +rec[y]
          if (rec[y] === undefined || rec[y] === null || rec[y] === '' || isNaN(v)) return null
          sum += Math.min(10, Math.max(0, v))
        }
      }
      return +(sum / 3).toFixed(1)
    }

    // Tổ hợp tốt nhất của ngành theo bảng điểm (chỉ xét tổ hợp ngành nhận + đủ điểm)
    const best9CRComboForMajor = (majorId: any): { code: string, score: number } | null => {
      if (!majorId) return null
      const major = (arrMajors.value as any[]).find((i: any) => i.value == majorId)
      const codes = major?.code
      let list = Array.isArray(codes) && codes.length
        ? (arrIndustry.value as any[]).filter((i: any) => codes.includes(i.value))
        : (arrIndustry.value as any[])
      // Loại pseudo-form (không phải tổ hợp 3 môn) — giống filter của dropdown allArrMethosIndustry
      list = list.filter((i: any) => !['5HK', '3YS', '9CR'].includes(i.code))
      let best: { code: string, score: number } | null = null
      list.forEach((i: any) => {
        const s = combo9CRScoreFromTranscript(i.code)
        if (s !== null && (!best || s > best.score)) best = { code: i.code, score: s }
      })
      return best
    }

    // Đổ điểm từ bảng điểm vào subjectpoint của 1 NV. force=false: chỉ đổ ô TRỐNG (không phá điểm đã có/hồ sơ cũ).
    const fillSubjectpointFromTranscript = (targetKey: string, opts: { force?: boolean } = {}) => {
      const t = studentTranscript.value
      if (!t) return
      const arr = formData.value[targetKey]
      if (!Array.isArray(arr)) return
      arr.forEach((slot: any) => {
        if (!slot || !slot.type || !slot.data) return
        const rec = t[slot.type]
        if (!rec) return
        ;[['point0', 'c10'], ['point1', 'c11'], ['point2', 'c12']].forEach(([p, y]) => {
          const tv = rec[y]
          if (tv === undefined || tv === null || tv === '') return
          const has = slot.data[p] !== '' && slot.data[p] !== null && slot.data[p] !== undefined
          if (opts.force || !has) slot.data[p] = tv
        })
      })
    }

    // Hồ sơ cũ: điểm trong hồ sơ khác bảng điểm gốc -> banner warning + nút Đồng bộ (đã chốt: không tự ghi đè)
    // Cảnh báo mềm (KHÔNG chặn lưu): tổ hợp đã chọn nhưng còn thiếu điểm môn.
    // getBestComboResult trả null khi 1 môn của tổ hợp chưa nhập -> dùng làm tín hiệu thiếu.
    // Áp cho PT4 (Điểm thi THPT) & PT5 (Tương đương) — dùng chung methosIndustryTHPT*; bỏ 9CR (đã có banner riêng).
    const missingComboScores = computed(() => {
      const m = formData.value.method
      const out: string[] = []
      if (formData.value.formOfMethod === '9CR') return out
      if (m != 4 && m != 5) return out
      const combos = [
        { field: 'methosIndustryTHPT', label: 'Ưu tiên 1' },
        { field: 'methosIndustryTHPT2', label: 'Ưu tiên 2' },
        { field: 'methosIndustryTHPT3', label: 'Ưu tiên 3' },
      ]
      combos.forEach((c, idx) => {
        const code = (formData.value as any)[c.field]
        if (!code) return                                  // chưa chọn tổ hợp -> không cảnh báo
        if (!getBestComboResult(code, m, idx + 1)) out.push(c.label)  // null = thiếu điểm môn
      })
      return out
    })
    const transcriptMismatch = computed(() => {
      if (formData.value.formOfMethod !== '9CR' || formData.value.method != 1) return false
      const t = studentTranscript.value
      if (!t) return false
      let mismatch = false
      activeScoreKeys().forEach((k) => {
        (formData.value[k] || []).forEach((slot: any) => {
          if (!slot?.type || !slot.data) return
          const rec = t[slot.type]
          if (!rec) return
          ;[['point0', 'c10'], ['point1', 'c11'], ['point2', 'c12']].forEach(([p, y]) => {
            const pv = slot.data[p]
            const tv = rec[y]
            // So sánh sau khi làm tròn 1 lẻ (transcript lưu 1 lẻ) — tránh banner giả do 8.25 vs 8.3
            if (pv !== '' && pv != null && tv !== undefined && tv !== null && tv !== '' && Math.round(+pv * 10) !== Math.round(+tv * 10)) mismatch = true
          })
        })
      })
      return mismatch
    })
    const syncFromTranscript = () => {
      ;['subjectpoint', 'subjectpoint2', 'subjectpoint3'].forEach((k) => fillSubjectpointFromTranscript(k, { force: true }))
    }
    //Hồ sơ cũ lỗi để TRỐNG điểm: NV đã chọn tổ hợp nhưng ô trống trong khi học bạ có điểm môn đó
    //(banner transcriptMismatch chỉ bắt LỆCH 2 bên đều có điểm — không bắt được ca trống)
    const transcriptCanFill = computed(() => {
      if (formData.value.formOfMethod !== '9CR' || formData.value.method != 1) return false
      const t = studentTranscript.value
      if (!t) return false
      let canFill = false
      activeScoreKeys().forEach((k) => {
        (formData.value[k] || []).forEach((slot: any) => {
          if (!slot?.type || !slot.data) return
          const rec = t[slot.type]
          if (!rec) return
          ;[['point0', 'c10'], ['point1', 'c11'], ['point2', 'c12']].forEach(([p, y]) => {
            const pv = slot.data[p]
            const tv = rec[y]
            if ((pv === '' || pv === null || pv === undefined) && tv !== undefined && tv !== null && tv !== '') canFill = true
          })
        })
      })
      return canFill
    })
    //Gợi ý tổ hợp TỐT HƠN theo học bạ: tổ hợp đang chọn không phải tổ hợp điểm cao nhất của ngành
    const comboBetterSuggestion = (n: number) => {
      if (formData.value.formOfMethod !== '9CR' || !studentTranscript.value) return null
      const major = n === 2 ? formData.value.admissionsIndustry2 : n === 3 ? formData.value.admissionsIndustry3 : formData.value.admissionsIndustry
      const combo = n === 2 ? formData.value.methosIndustry2 : n === 3 ? formData.value.methosIndustry3 : formData.value.methosIndustry
      if (!major || !combo) return null
      const best = best9CRComboForMajor(major)
      if (!best || best.code === combo) return null
      const cur = combo9CRScoreFromTranscript(combo)
      if (cur !== null && best.score <= cur + 0.004) return null //bằng/kém thì thôi
      return { code: best.code, score: best.score, cur }
    }
    const applyBestCombo = (n: number) => {
      const sug = comboBetterSuggestion(n)
      if (!sug) return
      if (n === 2) formData.value.methosIndustry2 = sug.code
      else if (n === 3) formData.value.methosIndustry3 = sug.code
      else formData.value.methosIndustry = sug.code
      methosIndustryAutoChange(sug.code, n === 1 ? undefined : String(n))
      fillSubjectpointFromTranscript(n === 2 ? 'subjectpoint2' : n === 3 ? 'subjectpoint3' : 'subjectpoint', { force: true })
    }
    // Slot 9CR chỉ được TÍNH khi nguyện vọng đó ĐANG chọn tổ hợp. subjectpoint2/3 có thể còn
    // dữ liệu điểm CŨ VÔ HÌNH (NV bỏ chọn / hồ sơ cũ load từ DB) — nếu gộp cả vào thì lúc ghi
    // bảng điểm chúng ĐÈ điểm thật của NV1 và banner "lệch điểm" không bao giờ tắt (bug 2026-07,
    // bắt được qua PUT body: gửi điểm cũ 8/8/8 thay vì 8.5 đang hiển thị).
    const activeScoreKeys = () => {
      // Điều kiện active = NGÀNH đang chọn (admissionsIndustry*) — methosIndustry* có thể còn code CŨ
      // trong formData dù UI đã bỏ chọn Ưu tiên 2/3 (hồ sơ cũ load từ DB)
      const map: Array<[string, any]> = [
        ['subjectpoint', formData.value.admissionsIndustry && formData.value.methosIndustry],
        ['subjectpoint2', formData.value.admissionsIndustry2 && formData.value.methosIndustry2],
        ['subjectpoint3', formData.value.admissionsIndustry3 && formData.value.methosIndustry3],
      ]
      return map.filter(([, active]) => !!active).map(([k]) => k)
    }
    // Có ô điểm nào user thật sự gõ trong phiên chưa? (banner mismatch nói rõ "sẽ tự ghi khi Lưu")
    const hasDirtyScores = computed(() => dirtyScoreCells.value.size > 0)

    // Action trên banner "Chưa có Bảng điểm học bạ": ghi TOÀN BỘ ô điểm hợp lệ đang có trong hồ sơ
    // vào students.transcript. Cùng nguyên tắc an toàn với syncTranscriptWriteBack:
    // baseline là bản MỚI NHẤT từ server + ghi timeline vào Ghi chú.
    const writeFormScoresToTranscript = async () => {
      try {
        if (formData.value.method != 1 || formData.value.formOfMethod !== '9CR') return
        const sid = _transcriptStudentId()
        if (!sid) return
        // Gom ô điểm hợp lệ của các NV ĐANG CHỌN tổ hợp — NV3 trước, NV1 sau cùng (NV1 thắng nếu trùng môn)
        const cells: Array<{ type: string, label: string, p: string, n: number }> = []
        activeScoreKeys().reverse().forEach((k) => {
          (formData.value[k] || []).forEach((slot: any) => {
            if (!slot?.type || !slot.data) return
            ;['point0', 'point1', 'point2'].forEach((p) => {
              const pv = slot.data[p]
              if (pv === '' || pv === null || pv === undefined || isNaN(+pv)) return
              cells.push({ type: slot.type, label: slot.label || slot.type, p, n: Math.round(Math.min(10, Math.max(0, +pv)) * 10) / 10 })
            })
          })
        })
        if (cells.length === 0) {
          Swal.fire({ text: 'Hồ sơ chưa có ô điểm nào để ghi vào bảng điểm.', icon: 'info', buttonsStyling: false, confirmButtonText: 'Đóng', customClass: { confirmButton: 'btn btn-primary' } })
          return
        }
        let base: any = null
        try {
          const { data } = await axios.get(`/admission/student/${sid}`)
          base = (data && data.transcript && typeof data.transcript === 'object') ? data.transcript : {}
        } catch (e) {
          Swal.fire({ text: 'Không tải được bảng điểm mới nhất, vui lòng thử lại.', icon: 'error', buttonsStyling: false, confirmButtonText: 'Đóng', customClass: { confirmButton: 'btn btn-primary' } })
          return
        }
        const t = JSON.parse(JSON.stringify(base))
        const yearLabel = { point0: 'L10', point1: 'L11', point2: 'L12' } as any
        const pointToYear = { point0: 'c10', point1: 'c11', point2: 'c12' } as any
        const diffs: string[] = []
        cells.forEach(({ type, label, p, n }) => {
          const y = pointToYear[p]
          const old = t[type] ? t[type][y] : undefined
          if (old === undefined || old === null || old === '' || Math.round(+old * 10) !== Math.round(n * 10)) {
            if (!t[type]) t[type] = {}
            t[type][y] = n
            const oldText = (old === undefined || old === null || old === '') ? '—' : old
            diffs.push(`${label} ${yearLabel[p]}: ${oldText}→${n}`)
          }
        })
        if (diffs.length === 0) {
          studentTranscript.value = t
          Swal.fire({ text: 'Bảng điểm học bạ đã khớp với điểm trong hồ sơ.', icon: 'info', buttonsStyling: false, timer: 2000, timerProgressBar: true, showConfirmButton: false })
          return
        }
        await axios.put(`/admission/student/${sid}`, { transcript: t })
        studentTranscript.value = t
        dirtyScoreCells.value.clear() // các ô vừa ghi coi như đã đồng bộ — khỏi write-back lần nữa khi Lưu
        syncFromTranscript() // chuẩn hoá điểm về MỌI NV (1 môn 1 điểm) -> banner lệch tắt ngay
        const dataComment = {
          idUser: user()?.id,
          idStudent: sid,
          comment: `[TIMELINE] Ghi Bảng điểm học bạ từ hồ sơ ${props.dataAdm?.adRegister?.profileCode || formData.value.profileCode || ''}: ${diffs.join('; ')}`,
        }
        await axios.post(`/admission/comment`, dataComment).catch(() => { /* timeline lỗi không chặn */ })
        Swal.fire({ text: 'Đã ghi điểm vào Bảng điểm học bạ.', icon: 'success', buttonsStyling: false, timer: 2000, timerProgressBar: true, showConfirmButton: false })
      } catch (e) {
        console.log('writeFormScoresToTranscript err', e)
      }
    }

    // Ghi NGƯỢC điểm hồ sơ về bảng điểm gốc + timeline trace, gọi khi lưu hồ sơ PT2/9CR.
    // Gate: chỉ chạy khi user THẬT SỰ sửa điểm trong phiên (dirtyScoreCells) — mở hồ sơ cũ chỉ bấm Lưu
    // thì KHÔNG đụng transcript. Khi ĐÃ sửa -> coi HỒ SƠ là nguồn đúng: ghi TOÀN BỘ ô điểm hợp lệ
    // (không chỉ ô dirty) để sau Lưu điểm hồ sơ khớp hẳn bảng điểm — banner "lệch điểm" tự tắt.
    // Lỗi ở bước này KHÔNG chặn lưu hồ sơ (try/catch).
    const syncTranscriptWriteBack = async () => {
      try {
        transcriptSyncInfo.value = ''
        if (formData.value.method != 1 || formData.value.formOfMethod !== '9CR') return
        if (dirtyScoreCells.value.size === 0) return // chỉ ghi ngược khi user thật sự gõ điểm trong phiên
        const sid = _transcriptStudentId()
        if (!sid) return
        // Baseline PHẢI là bản MỚI NHẤT trên server (snapshot lúc mở form có thể cũ — vd vừa sửa ở tab
        // Thông tin học tập). Fetch fail -> HỦY write-back, tuyệt đối không PUT đè bằng baseline rỗng/cũ.
        let base: any = null
        try {
          const { data } = await axios.get(`/admission/student/${sid}`)
          base = (data && data.transcript && typeof data.transcript === 'object') ? data.transcript : {}
        } catch (e) {
          console.log('syncTranscriptWriteBack: bỏ qua (không fetch được transcript mới nhất)')
          return
        }
        const t = JSON.parse(JSON.stringify(base))
        const yearLabel = { point0: 'L10', point1: 'L11', point2: 'L12' } as any
        const pointToYear = { point0: 'c10', point1: 'c11', point2: 'c12' } as any
        const diffs: string[] = []
        // Chỉ NV đang chọn tổ hợp; NV3 trước, NV1 sau cùng (NV1 thắng nếu trùng môn)
        activeScoreKeys().reverse().forEach((k) => {
          (formData.value[k] || []).forEach((slot: any) => {
            if (!slot?.type || !slot.data) return
            ;['point0', 'point1', 'point2'].forEach((p) => {
              const pv = slot.data[p]
              if (pv === '' || pv === null || pv === undefined || isNaN(+pv)) return
              const n = Math.round(Math.min(10, Math.max(0, +pv)) * 10) / 10
              const y = pointToYear[p]
              const old = t[slot.type] ? t[slot.type][y] : undefined
              if (old === undefined || old === null || old === '' || Math.round(+old * 10) !== Math.round(n * 10)) {
                if (!t[slot.type]) t[slot.type] = {}
                t[slot.type][y] = n
                const oldText = (old === undefined || old === null || old === '') ? '—' : old
                diffs.push(`${slot.label || slot.type} ${yearLabel[p]}: ${oldText}→${n}`)
              }
            })
          })
        })
        if (diffs.length === 0) { studentTranscript.value = t; dirtyScoreCells.value.clear(); return }
        await axios.put(`/admission/student/${sid}`, { transcript: t })
        studentTranscript.value = t
        dirtyScoreCells.value.clear()
        transcriptSyncInfo.value = `đã cập nhật ${diffs.length} ô điểm vào Bảng điểm học bạ`
        // Đồng bộ điểm CHUẨN HOÁ ngược vào MỌI nguyện vọng: cùng 1 môn có thể bị gõ lệch giữa các NV
        // (học bạ chỉ có 1 điểm/môn) — không sync thì hồ sơ lưu xuống mâu thuẫn + banner lệch không tắt.
        // Chạy TRƯỚC khi admissionSubmit build payload -> hồ sơ lưu xuống cũng nhất quán.
        syncFromTranscript()
        // Timeline trace vào Ghi chú (widget đọc theo idStudent)
        const dataComment = {
          idUser: user()?.id,
          idStudent: sid,
          comment: `[TIMELINE] Cập nhật Bảng điểm học bạ từ hồ sơ ${props.dataAdm?.adRegister?.profileCode || formData.value.profileCode || ''}: ${diffs.join('; ')}`,
        }
        await axios.post(`/admission/comment`, dataComment).catch(() => { /* timeline lỗi không chặn */ })
      } catch (e) {
        console.log('syncTranscriptWriteBack err', e)
      }
    }
    // ===== hết khối transcript =====

    const admissionsIndustryChange = (event: string) => {
      if (formData.value.admissionsIndustry2 == event) {
        formData.value.admissionsIndustry2 = ""
        formData.value.methosIndustry2 = ""
      }
      if (formData.value.admissionsIndustry3 == event) {
        formData.value.admissionsIndustry3 = ""
        formData.value.methosIndustry3 = ""
      }
      if (arrMajors.value.length != 0 && event) {
        if (formData.value.formOfMethod == '9CR' && studentTranscript.value) {
          // 9CR + CÓ bảng điểm: chọn tổ hợp tốt nhất theo transcript; không tổ hợp nào đủ điểm -> chọn tay
          const best = best9CRComboForMajor(event)
          formData.value.methosIndustry = best ? best.code : ""
        } else {
          let maxGPA = maxGPAIndustry(event)
          let value = maxGPA ? maxGPA.code : undefined
          formData.value.methosIndustry = value ? value : ""
        }
      }
      if (!event) {
        formData.value.methosIndustry = ""
      }
      if(formData.value.formOfMethod == '9CR' && formData.value.methosIndustry) {
        methosIndustryAutoChange(formData.value.methosIndustry)
        fillSubjectpointFromTranscript('subjectpoint', { force: true })
      }
      userSelect.value = false
    }

    const admissionsIndustryChange2 = (event: string) => {
      if (formData.value.admissionsIndustry3 == event) {
        formData.value.admissionsIndustry3 = ""
        formData.value.methosIndustry3 = ""
      }
      if (arrMajors2.value.length != 0 && event) {
        if (formData.value.formOfMethod == '9CR' && studentTranscript.value) {
          const best = best9CRComboForMajor(event)
          formData.value.methosIndustry2 = best ? best.code : ""
        } else {
          let maxGPA = maxGPAIndustry(event)
          let value = maxGPA ? maxGPA.code : undefined
          formData.value.methosIndustry2 = value ? value : ""
        }
      }
      if (!event) {
        formData.value.methosIndustry2 = ""
      }
      if(formData.value.formOfMethod == '9CR' && formData.value.methosIndustry2) {
        methosIndustryAutoChange(formData.value.methosIndustry2, '2')
        fillSubjectpointFromTranscript('subjectpoint2', { force: true })
      }
      userSelect.value = false
    }

    const admissionsIndustryChange3 = (event: string) => {
      if (arrMajors3.value.length != 0 && event) {
        if (formData.value.formOfMethod == '9CR' && studentTranscript.value) {
          const best = best9CRComboForMajor(event)
          formData.value.methosIndustry3 = best ? best.code : ""
        } else {
          let maxGPA = maxGPAIndustry(event)
          let value = maxGPA ? maxGPA.code : undefined
          formData.value.methosIndustry3 = value ? value : ""
        }
      }
      if(formData.value.formOfMethod == '9CR' && formData.value.methosIndustry3) {
        methosIndustryAutoChange(formData.value.methosIndustry3, '3')
        fillSubjectpointFromTranscript('subjectpoint3', { force: true })
      }
      userSelect.value = false
    }
    
    function methosIndustryResetTHPT() {
      let arr: Array<string> = []
      arrGPAIndustryTHPT.value.forEach(item => {
        if(item.value != 0)
          arr.push(item.code)
      })
      if(userSelectTHPT.value) {
        //auto chọn cao điểm nhất ngành 1
        if(formData.value.admissionsIndustryTHPT != "" && formData.value.methosIndustryTHPT) {
          let maxGPA = maxGPAIndustryTHPT(formData.value.admissionsIndustryTHPT)
          let value = maxGPA ? maxGPA.code : undefined
          formData.value.methosIndustryTHPT = value ? value : ""
        }
        if(formData.value.admissionsIndustryTHPT2 != "" && formData.value.methosIndustryTHPT2) {
          let maxGPA = maxGPAIndustryTHPT(formData.value.admissionsIndustryTHPT2)
          let value = maxGPA ? maxGPA.code : undefined
          formData.value.methosIndustryTHPT2 = value ? value : ""
        }
        if(formData.value.admissionsIndustryTHPT3 != "" && formData.value.methosIndustryTHPT3) {
          let maxGPA = maxGPAIndustryTHPT(formData.value.admissionsIndustryTHPT3)
          let value = maxGPA ? maxGPA.code : undefined
          formData.value.methosIndustryTHPT3 = value ? value : ""
        }
      }
      userSelectTHPT.value = false
    };
    function maxGPAIndustryTHPT(val) {
      let tempMajors = JSON.parse(JSON.stringify(arrMajors.value))
      let tempCode = tempMajors.filter(i =>i.value == val)
      let arrCode = undefined as any
      if(tempCode.length != 0) {
        arrCode = tempCode[0].code // get array tổ hợp xét tuyển
      }
      //filter value và label những tổ hợp của từng môn
      let temp:{ value: string, label: string }[] = arrCode ? arrIndustry.value.filter(i=>arrCode?.includes(i.value)) : arrIndustry.value
      let arr: Array<string> = []
      temp.forEach(item => {
        arr.push(item.value)
      })
      //console.log('arr',arr)
      let obj = arrGPAIndustryTHPT.value.filter(item => item.value != 0 && arr.includes(item.code))
      //console.log('obj',obj)
      let objWithPriorityScore = obj.map((item) => {
        let {value} = item
        let priority = cacuPointPriority(value)
        return {
          ...item,
          valueW: value + priority
        }
      })
      let maxValue = Math.max.apply(Math, objWithPriorityScore.map(function(o) { return o.valueW; }))
      let result = objWithPriorityScore.find(item => {  return item.valueW === maxValue })
      return result
    };
    const isMaxGPATHPT = computed(() => {
      methosIndustryResetTHPT()
      let tempMax = maxGPAIndustryTHPT(formData.value.admissionsIndustryTHPT)
      let value = tempMax ? tempMax.value : undefined
      
      if(GPAIndustryTHPT.value === value) {
        return true
      }
      return false
    });
    const GPAIndustryTHPT = computed(() => {
      let temp = arrGPAIndustryTHPT.value.filter(item => item.code == formData.value.methosIndustryTHPT)
      return temp.length != 0 ? temp[0].value : 0
    });
    const isMaxGPATHPT2 = computed(() => {
      let tempMax = maxGPAIndustryTHPT(formData.value.admissionsIndustryTHPT2)
      let value = tempMax ? tempMax.value : undefined
      if(GPAIndustryTHPT2.value === value) {
        return true
      }
      return false
    });
    const GPAIndustryTHPT2 = computed(() => {
      let temp = arrGPAIndustryTHPT.value.filter(item => item.code == formData.value.methosIndustryTHPT2)
      return temp.length != 0 ? temp[0].value : 0
    });
    const isMaxGPATHPT3 = computed(() => {
      let tempMax = maxGPAIndustryTHPT(formData.value.admissionsIndustryTHPT3)
      let value = tempMax ? tempMax.value : undefined
      if(GPAIndustryTHPT3.value === value) {
        return true
      }
      return false
    });
    const GPAIndustryTHPT3 = computed(() => {
      let temp = arrGPAIndustryTHPT.value.filter(item => item.code == formData.value.methosIndustryTHPT3)
      return temp.length != 0 ? temp[0].value : 0
    });
    function methosIndustryReset() {
      let arr: Array<string> = []
      arrGPAIndustry.value.forEach(item => {
        if(item.value != 0)
          arr.push(item.code)
      })
      if(userSelect.value) {
        //auto chọn cao điểm nhất ngành 1
        if(formData.value.admissionsIndustry != "" && formData.value.methosIndustry) {
          let maxGPA = maxGPAIndustry(formData.value.admissionsIndustry)
          let value = maxGPA ? maxGPA.code : undefined
          formData.value.methosIndustry = value ? value : ""
        }
        if(formData.value.admissionsIndustry2 != "" && formData.value.methosIndustry2) {
          let maxGPA = maxGPAIndustry(formData.value.admissionsIndustry2)
          let value = maxGPA ? maxGPA.code : undefined
          formData.value.methosIndustry2 = value ? value : ""
        }
        if(formData.value.admissionsIndustry3 != "" && formData.value.methosIndustry3) {
          let maxGPA = maxGPAIndustry(formData.value.admissionsIndustry3)
          let value = maxGPA ? maxGPA.code : undefined
          formData.value.methosIndustry3 = value ? value : ""
        }
      }
      userSelect.value = false
    };
    function maxGPAIndustry(val) {
      let tempMajors = JSON.parse(JSON.stringify(arrMajors.value))
      let tempCode = tempMajors.filter(i =>i.value == val)
      let arrCode = undefined as any
      if(tempCode.length != 0) {
        arrCode = tempCode[0].code // get array tổ hợp xét tuyển
      }
      //filter value và label những tổ hợp của từng môn
      let temp:{ value: string, label: string }[] = arrCode ? arrIndustry.value.filter(i=>arrCode?.includes(i.value)) : arrIndustry.value
      if(formData.value.formOfMethod == 'THM') {
        temp = temp.filter(item => !['5HK','3YS','9CR'].includes(item.value))
      }
      else if(formData.value.formOfMethod == '3YS') {
        temp = temp.filter(item => ['3YS'].includes(item.value))
      }
      // console.log('temptemp',temp)

      let arr: Array<string> = []
      temp.forEach(item => {
        arr.push(item.value)
      })
      //console.log('arr',arr)
      let obj = arrGPAIndustry.value.filter(item => item.value != 0 && arr.includes(item.code))
      //console.log('obj',obj)
      let maxValue = Math.max.apply(Math, obj.map(function(o) { return o.value; }))
      // console.log('maxValue',maxValue)
      let result = obj.find(item => {  return item.value === maxValue })
      // console.log('result',result)
      return result
    };
    const isMaxGPA = computed(() => {
      if (formData.value.formOfMethod == '9CR') {
        // 9CR: "tốt nhất" = tổ hợp có điểm cao nhất theo BẢNG ĐIỂM HỌC BẠ của ứng viên
        const best = best9CRComboForMajor(formData.value.admissionsIndustry)
        return !!best && formData.value.methosIndustry === best.code
      }
      methosIndustryReset()
      let tempMax = maxGPAIndustry(formData.value.admissionsIndustry)
      let value = tempMax ? tempMax.value : undefined
      if(GPAIndustry.value === value) {
        return true
      }
      return false
    });
    const GPAIndustry = computed(() => {
      if(formData.value.formOfMethod == '9CR') {
        let a = [] as any
        formData.value.subjectpoint.forEach(item=> {
          let i = item.data
          if(i.point0 > 10 || i.point0 < 0) {
            item.data.point0 = 0
          }
          if(i.point1 > 10 || i.point1 < 0) {
            item.data.point1 = 0
          }
          if(i.point2 > 10 || i.point2 < 0) {
            item.data.point2 = 0
          }
          a = a.concat([i.point0,i.point1,i.point2])
        })
        let sum = (+a.reduce((acc, curr) => acc + +curr, 0)/3).toFixed(1)
        return +sum
      }
      let temp = arrGPAIndustry.value.filter(item => item.code == formData.value.methosIndustry)
      return temp.length != 0 ? temp[0].value : 0
    });
    const isMaxGPA2 = computed(() => {
      if (formData.value.formOfMethod == '9CR') {
        const best = best9CRComboForMajor(formData.value.admissionsIndustry2)
        return !!best && formData.value.methosIndustry2 === best.code
      }
      let tempMax = maxGPAIndustry(formData.value.admissionsIndustry2)
      let value = tempMax ? tempMax.value : undefined
      if(GPAIndustry2.value === value) {
        return true
      }
      return false
    });
    const GPAIndustry2 = computed(() => {
      if(formData.value.formOfMethod == '9CR') {
        let a = [] as any
        formData.value.subjectpoint2.forEach(item=> {
          let i = item.data
          if(i.point0 > 10 || i.point0 < 0) {
            item.data.point0 = 0
          }
          if(i.point1 > 10 || i.point1 < 0) {
            item.data.point1 = 0
          }
          if(i.point2 > 10 || i.point2 < 0) {
            item.data.point2 = 0
          }
          a = a.concat([i.point0,i.point1,i.point2])
        })
        let sum = (+a.reduce((acc, curr) => acc + +curr, 0)/3).toFixed(1)
        return +sum
      }
      let temp = arrGPAIndustry.value.filter(item => item.code == formData.value.methosIndustry2)
      return temp.length != 0 ? temp[0].value : 0
    });
    const isMaxGPA3 = computed(() => {
      if (formData.value.formOfMethod == '9CR') {
        const best = best9CRComboForMajor(formData.value.admissionsIndustry3)
        return !!best && formData.value.methosIndustry3 === best.code
      }
      let tempMax = maxGPAIndustry(formData.value.admissionsIndustry3)
      let value = tempMax ? tempMax.value : undefined
      if(GPAIndustry3.value === value) {
        return true
      }
      return false
    });
    const GPAIndustry3 = computed(() => {
      if(formData.value.formOfMethod == '9CR') {
        let a = [] as any
        formData.value.subjectpoint3.forEach(item=> {
          let i = item.data
          if(i.point0 > 10 || i.point0 < 0) {
            item.data.point0 = 0
          }
          if(i.point1 > 10 || i.point1 < 0) {
            item.data.point1 = 0
          }
          if(i.point2 > 10 || i.point2 < 0) {
            item.data.point2 = 0
          }
          a = a.concat([i.point0,i.point1,i.point2])
        })
        let sum = (+a.reduce((acc, curr) => acc + +curr, 0)/3).toFixed(1)
        return +sum
      }
      let temp = arrGPAIndustry.value.filter(item => item.code == formData.value.methosIndustry3)
      return temp.length != 0 ? temp[0].value : 0
    });

    const calculatedAvgGrade12 = computed(() => {
        const subjects = [
            "pt05mathTHPT", "pt05physicsTHPT", "pt05chemistryTHPT", "pt05englishTHPT",
            "pt05frenchTHPT", "pt05literatureTHPT", "pt05historyTHPT", "pt05geographyTHPT",
            "pt05biologicalTHPT", "pt05informationTechnologyTHPT", "pt05artTHPT", 
            "pt05economicsAndLawEducationTHPT"
        ];
        let total = 0;
        let count = 0;
        subjects.forEach(s => {
            if (formData.value[s] && formData.value[s] !== "") {
                total += parseFloat(formData.value[s]);
                count++;
            }
        });
        return count > 0 ? parseFloat((total / count).toFixed(2)) : 0;
    });

    const GPAIndustryDGNL_HN = computed(() => {
      const scores = [
        +formData.value.dgnlHN_math || 0,
        +formData.value.dgnlHN_physics || 0,
        +formData.value.dgnlHN_chemistry || 0,
        +formData.value.dgnlHN_biology || 0,
        +formData.value.dgnlHN_history || 0,
        +formData.value.dgnlHN_geography || 0,
        +formData.value.dgnlHN_english || 0,
        +formData.value.dgnlHN_literature || 0,
      ].sort((a, b) => b - a);
      const top3Sum = scores[0] + scores[1] + scores[2];
      const normalizedScore = (top3Sum * 30) / 450;
      return +normalizedScore.toFixed(2);
    });

    const totalScoreDGNL_HN = computed(() => {
      const score = GPAIndustryDGNL_HN.value;
      const incentive = certIncentiveResult.value.total;
      const priority = cacuPointPriority(score + incentive);
      return +(score + priority + incentive).toFixed(2);
    });

    const GPAIndustryDGNL = computed(() => {
      const score = +formData.value.aptitudeTest || 0;
      return +(score * 30 / 1200).toFixed(2);
    });

    const totalScoreDGNL = computed(() => {
      const score = GPAIndustryDGNL.value;
      const incentive = certIncentiveResult.value.total;
      const priority = cacuPointPriority(score + incentive);
      return +(score + priority + incentive).toFixed(2);
    });

    
    function generatePdf(profileCode:string,adCode:string) {
      // Không có mã hồ sơ thì bỏ qua (tránh gọi API tạo PDF với dữ liệu rỗng)
      if(!profileCode) return
      let data = {
        "profileCode": profileCode,
        "adCode": adCode
      }
      // Tạo PDF phiếu đăng ký là phụ trợ — lỗi ở đây KHÔNG được chặn luồng lưu hồ sơ
      axios.post('/admission/generate/',data).catch((e) => {
        console.warn('generatePdf failed:', e?.response?.status || e)
      })
    }
    function checkHighschoolGraduation() {
      if(!props.dataHighschool && formData.value.status == 'verified') {
        Swal.fire({
            text: "Vui lòng kiểm tra lại điều kiện tốt nghiệp THPT của ứng viên này!",
            icon: "warning",
            buttonsStyling: false,
            confirmButtonText: "Trở lại",
            customClass: {
                confirmButton: "btn btn-primary",
            },
        }).then(() => {
            //hideModal(addCustomerModalRef.value);
        });   
        emit('callbackFunction',true)
        return true
      }
      emit('callbackFunction',false)
      return false
    } 
    function user() {
      let temp  = window.localStorage.getItem("user")
      return temp?JSON.parse(temp) : null
    }
    async function submitComment() {
      let dataComment = {
        "idUser": user()?.id,
        "idStudent":props.idStudent,
        "comment": `Đã chuyển hồ sơ ${props.dataAdm?.adRegister?.profileCode} thành Không hợp lệ. Lý do: `+comment_profile.value
      }
      await axios.post(`/admission/comment`,dataComment)
      .then(( {data} ) => {
        comment_profile.value = ''
        emitter.emit("addComment", data);
      })
      .catch((errors) => {
        console.log('err',errors)
      });
    }
    const comment_profile = ref('')
    async function admissionSubmit() {
      // Trạng thái (xác thực / không hợp lệ) đã chuyển sang card "Trạng thái hồ sơ" ở sidebar (fromProfile)
      // -> submit form CHỈ lưu dữ liệu hồ sơ, không còn xét/đổi status ở đây.
      // PT2/9CR: điểm sửa tay trong hồ sơ GHI NGƯỢC về Bảng điểm học bạ gốc + timeline (đã chốt thiết kế); lỗi không chặn lưu.
      await syncTranscriptWriteBack()
      // PT1: điểm thi sửa tay trong hồ sơ ghi ngược về Bảng điểm thi TN THPT (students.graduationscore) — cùng nguyên tắc.
      await syncGradScoreWriteBack()
      let highSchoolScore = {}
      let highSchoolGraduationScore = {}
      let nlqlScore = {}
      let qdUmt = {}
      let vsatScore = {}
      const adMajors = ref([{}])
      let tempMajors = JSON.parse(JSON.stringify(arrMajors.value))
      if (Number(formData.value.method) === 4) {
        highSchoolGraduationScore = {
          "idAdReg": idAdReg.value,
          "mathScore": +formData.value.mathTHPT == 0 ? null : +formData.value.mathTHPT,
          "physicsScore": +formData.value.physicsTHPT == 0 ? null : +formData.value.physicsTHPT,
          "chemistryScore": +formData.value.chemistryTHPT == 0 ? null : +formData.value.chemistryTHPT,
          "englishScore": +formData.value.englishTHPT == 0 ? null : +formData.value.englishTHPT,
          "frenchScore": +formData.value.frenchTHPT == 0 ? null : +formData.value.frenchTHPT,
          "literatureScore": +formData.value.literatureTHPT == 0 ? null : +formData.value.literatureTHPT,
          "historyScore": +formData.value.historyTHPT == 0 ? null : +formData.value.historyTHPT,
          "geographyScore": +formData.value.geographyTHPT == 0 ? null : +formData.value.geographyTHPT,
          "artScore": +formData.value.artTHPT == 0 ? null : +formData.value.artTHPT,
          "informationTechnologyScore": +formData.value.informationTechnologyTHPT == 0 ? null : +formData.value.informationTechnologyTHPT,
          "economicsAndLawEducationScore": +formData.value.economicsAndLawEducationTHPT == 0 ? null : +formData.value.economicsAndLawEducationTHPT,
          "biologyScore": +formData.value.biologicalTHPT == 0 ? null : +formData.value.biologicalTHPT,
        };
      }

      if (Number(formData.value.method) === 6) {
        vsatScore = {
          "idAdReg": idAdReg.value,
          "mathScore": +formData.value.dgnlHN_math || 0,
          "physicsScore": +formData.value.dgnlHN_physics || 0,
          "chemistryScore": +formData.value.dgnlHN_chemistry || 0,
          "biologyScore": +formData.value.dgnlHN_biology || 0,
          "historyScore": +formData.value.dgnlHN_history || 0,
          "geographyScore": +formData.value.dgnlHN_geography || 0,
          "englishScore": +formData.value.dgnlHN_english || 0,
          "literatureScore": +formData.value.dgnlHN_literature || 0,
          "normalizedScore": GPAIndustryDGNL_HN.value
        };
        
        const methods = [
          { industry: formData.value.majorDGNL_HN, priority: 1 },
          { industry: formData.value.majorDGNL_HN2, priority: 2 },
          { industry: formData.value.majorDGNL_HN3, priority: 3 }
        ];

        adMajors.value = [];
        methods.forEach(m => {
          if (m.industry) {
            adMajors.value.push({
              "idAdReg": idAdReg.value,
              "majorId": tempMajors.find(item => item.value == m.industry)?.id,
              "adForm": 'VSAT',
              "admissionScore": GPAIndustryDGNL_HN.value.toFixed(2),
              "priorityScore": cacuPointPriority(GPAIndustryDGNL_HN.value + certIncentiveResult.value.total),
              "objectInfo": {
                "priorityScoreNew": cacuPointPriority(GPAIndustryDGNL_HN.value + certIncentiveResult.value.total),
                "incentiveScore": certIncentiveResult.value.total,
                "englishConvertedScore": 0
              },
              "averageScore": (GPAIndustryDGNL_HN.value + cacuPointPriority(GPAIndustryDGNL_HN.value + certIncentiveResult.value.total) + certIncentiveResult.value.total).toFixed(2),
              "priority": m.priority,
            });
          }
        });
      }

      if(+formData.value.method == 4) {

        const methods = [
          { industry: formData.value.admissionsIndustryTHPT, combo: formData.value.methosIndustryTHPT, gpa: GPAIndustryTHPT.value, priority: 1 },
          { industry: formData.value.admissionsIndustryTHPT2, combo: formData.value.methosIndustryTHPT2, gpa: GPAIndustryTHPT2.value, priority: 2 },
          { industry: formData.value.admissionsIndustryTHPT3, combo: formData.value.methosIndustryTHPT3, gpa: GPAIndustryTHPT3.value, priority: 3 }
        ];

        adMajors.value = []; // Reset adMajors
        methods.forEach(m => {
          if (m.industry && m.combo) {
            const res = getBestComboResult(m.combo, 4);
            adMajors.value.push({
              "idAdReg": idAdReg.value,
              "majorId": tempMajors.filter(item => item.value == m.industry)[0]?.id,
              "adForm": m.combo,
              "averageScore": res ? res.total.toFixed(2) : (m.gpa + cacuPointPriority(m.gpa)).toFixed(2),
              "priorityScore": res ? res.priorityScoreNew : cacuPointPriority(m.gpa),
              "admissionScore": res ? res.sum.toFixed(2) : m.gpa.toFixed(2),
              "objectInfo": {
                "priorityScoreNew": res ? res.priorityScoreNew : cacuPointPriority(m.gpa),
                "incentiveScore": res ? res.incentiveScore : 0,
                "englishConvertedScore": res ? res.englishConvertedScore : 0
              },
              "priority": m.priority,
            });
          }
        });
      }

      if(+formData.value.method == 1) {
        const methods = [
          { industry: formData.value.admissionsIndustry, combo: formData.value.methosIndustry, gpa: GPAIndustry.value, priority: 1 },
          { industry: formData.value.admissionsIndustry2, combo: formData.value.methosIndustry2, gpa: GPAIndustry2.value, priority: 2 },
          { industry: formData.value.admissionsIndustry3, combo: formData.value.methosIndustry3, gpa: GPAIndustry3.value, priority: 3 }
        ];

        adMajors.value = []; // Reset adMajors
        methods.forEach(m => {
          if (m.industry && m.combo) {
            const res = getBestComboResult(m.combo, 1);
            adMajors.value.push({
              "idAdReg": idAdReg.value,
              "majorId": tempMajors.filter(item => item.value == m.industry)[0]?.id,
              "adForm": m.combo,
              "averageScore": res ? res.total.toFixed(2) : (m.gpa + cacuPointPriority(m.gpa)).toFixed(2),
              "priorityScore": res ? res.priorityScoreNew : cacuPointPriority(m.gpa),
              "admissionScore": res ? res.sum.toFixed(2) : m.gpa.toFixed(2),
              "objectInfo": {
                "priorityScoreNew": res ? res.priorityScoreNew : cacuPointPriority(m.gpa),
                "incentiveScore": res ? res.incentiveScore : 0,
                "englishConvertedScore": res ? res.englishConvertedScore : 0
              },
              "priority": m.priority,
            });
          }
        });
      }
      if(+formData.value.method == 1) {
        highSchoolScore = {
          "idAdReg": idAdReg.value,
          "class10TotalScore": +formData.value.all10 == 0 ? null : +formData.value.all10,
          "class11TotalScore": +formData.value.all11 == 0 ? null : +formData.value.all11,
          "class12Semester1Score": +formData.value.hki12 == 0 ? null : +formData.value.hki12,
          "class12TotalScore": +formData.value.all12 == 0 ? null : +formData.value.all12,
          "class12AverageMathScore": +formData.value.mathHKII == 0 ? null : +formData.value.mathHKII,
          "class12AveragePhysicsScore": +formData.value.physicsHKII == 0 ? null : +formData.value.physicsHKII,
          "class12AverageChemistryScore": +formData.value.chemistryHKII == 0 ? null : +formData.value.chemistryHKII,
          "class12AverageEnglishScore": +formData.value.englishHKII == 0 ? null : +formData.value.englishHKII,
          "class12AverageFrenchScore": +formData.value.frenchHKII == 0 ? null : +formData.value.frenchHKII,
          "class12AverageLiteratureScore": +formData.value.literatureHKII == 0 ? null : +formData.value.literatureHKII,
          "class12AverageHistoryScore": +formData.value.historyHKII == 0 ? null : +formData.value.historyHKII,
          "class12AverageGeographyScore": +formData.value.geographyHKII == 0 ? null : +formData.value.geographyHKII,
          "class12AverageBiologyScore": +formData.value.biologicalHKII == 0 ? null : +formData.value.biologicalHKII,
          "class12AverageCivicEducationScore": +formData.value.civicEducationHKII == 0 ? null : +formData.value.civicEducationHKII,
          "class12AverageInformationTechnologyScore": +formData.value.informationTechnologyHKII == 0 ? null : +formData.value.informationTechnologyHKII,
          "class12AverageEconomicsAndLawEducationScore": +formData.value.economicsAndLawEducationHKII == 0 ? null : +formData.value.economicsAndLawEducationHKII,
          "class12AverageArtScore": +formData.value.artHKII == 0 ? null : +formData.value.artHKII,
          "admissiontype": formData.value.formOfMethod,
        }
        if(formData.value.formOfMethod == '9CR') {
          let subjectpoint = {
            subjectpoint1: formData.value.subjectpoint,
            subjectpoint2: formData.value.subjectpoint2,
            subjectpoint3: formData.value.subjectpoint3,
          }
          highSchoolScore = { ...highSchoolScore, ...subjectpoint }
        }
      }
      let equivalentDegreeData = {}
      if(+formData.value.method == 5) {
        equivalentDegreeData = {
          "idAdReg": idAdReg.value,
          "formOfMethod": formData.value.formOfMethodMethod5,
          "sat": formData.value.sat,
          "satDate": formData.value.satDate,
          "actScore": formData.value.actScore,
          "actDate": formData.value.actDate,
          "tcCriteria": formData.value.tcCriteria,
          "tc01AverageGrade12": formData.value.tc01AverageGrade12,
          "mathTHPT": formData.value.pt05mathTHPT,
          "physicsTHPT": formData.value.pt05physicsTHPT,
          "chemistryTHPT": formData.value.pt05chemistryTHPT,
          "englishTHPT": formData.value.pt05englishTHPT,
          "frenchTHPT": formData.value.pt05frenchTHPT,
          "literatureTHPT": formData.value.pt05literatureTHPT,
          "historyTHPT": formData.value.pt05historyTHPT,
          "geographyTHPT": formData.value.pt05geographyTHPT,
          "biologicalTHPT": formData.value.pt05biologicalTHPT,
          "artTHPT": formData.value.pt05artTHPT,
          "informationTechnologyTHPT": formData.value.pt05informationTechnologyTHPT,
          "economicsAndLawEducationTHPT": formData.value.pt05economicsAndLawEducationTHPT,
        }
      }
      if(+formData.value.method == 2) {
        let pointnlqlScore = (formData.value.aptitudeTest*30/1200).toFixed(1)
        nlqlScore = {
          "idAdReg": idAdReg.value,
          "nlqgScore": pointnlqlScore,//điểm đã quy đổi thang 30 (dùng xét tuyển)
          "totalScore": formData.value.aptitudeTest,//điểm gốc thang 1200 để load/sửa không bị làm tròn
        }
        const incentive = certIncentiveResult.value.total;
        const pScoreNew = cacuPointPriority(+pointnlqlScore + incentive);
        adMajors.value = [
          {
            "idAdReg": idAdReg.value,
            "majorId": tempMajors.filter(item => item.value == formData.value.majorForAptitudeTest)[0]?.id,
            "adForm": 'DGNL',
            "averageScore": (+pointnlqlScore + incentive + pScoreNew).toFixed(2),
            "objectInfo": {
              "priorityScoreNew": pScoreNew,
              "incentiveScore": incentive,
              "englishConvertedScore": 0
            },
            "priority": 1,
          },
        ];
        if(formData.value.majorForAptitudeTest2 != "" && formData.value.majorForAptitudeTest2) {
          let temp = {
            "idAdReg": idAdReg.value,
            "majorId": tempMajors.filter(item => item.value == formData.value.majorForAptitudeTest2)[0]?.id,
            "adForm": 'DGNL',
            "averageScore": (+pointnlqlScore + incentive + pScoreNew).toFixed(2),
            "objectInfo": {
              "priorityScoreNew": pScoreNew,
              "incentiveScore": incentive,
              "englishConvertedScore": 0
            },
            "priority": 2,
          }
          adMajors.value.push(temp)
        }
        if(formData.value.majorForAptitudeTest3 != "" && formData.value.majorForAptitudeTest3) {
          let temp = {
            "idAdReg": idAdReg.value,
            "majorId": tempMajors.filter(item => item.value == formData.value.majorForAptitudeTest3)[0]?.id,
            "adForm": 'DGNL',
            "averageScore": (+pointnlqlScore + incentive + pScoreNew).toFixed(2),
            "objectInfo": {
              "priorityScoreNew": pScoreNew,
              "incentiveScore": incentive,
              "englishConvertedScore": 0
            },
            "priority": 3,
          }
          adMajors.value.push(temp)
        }
      }
      if(+formData.value.method == 3) {
        qdUmt = {
          "idAdReg": idAdReg.value,
          "ieltsScore": +formData.value.ielts == 0 ? null : +formData.value.ielts,
          "toeflScore": +formData.value.toefl == 0 ? null : +formData.value.toefl,
          "toeicScore": +formData.value.toeic == 0 ? null : +formData.value.toeic,
          "satScore": +formData.value.sat == 0 ? null : +formData.value.sat,
          "isEngCert": formData.value.typeIsCert == 'isEnglishCertificate',
          "isCollegeDiploma": formData.value.typeIsCert == 'isCollegeOrInterDegree',
          "isInternationalCert": formData.value.typeIsCert == 'isInternationalCertificate',
          "isAthleteCertOrPreMaster": formData.value.typeIsCert == 'isAthleteCertOrPreMaster',
          "isNationalAward": formData.value.typeIsCert == 'isPrize',
          "isGoodInHighschool": formData.value.typeIsCert == 'isGoodStanding'
        }
        const incentive = certIncentiveResult.value.total;
        const pScoreNew = cacuPointPriority(incentive); // Base is 0 for direct admission? 
        adMajors.value = [
          {
            "idAdReg": idAdReg.value,
            "majorId": tempMajors.filter(item => item.value == formData.value.majorForUmt)[0]?.id,
            "adForm": 'UMT',
            "averageScore": (incentive + pScoreNew).toFixed(2),
            "objectInfo": {
              "priorityScoreNew": pScoreNew,
              "incentiveScore": incentive,
              "englishConvertedScore": 0
            },
            "priority": 1,
          },
        ];
        if(formData.value.majorForUmt2 != "" && formData.value.majorForUmt2) {
          let temp = {
            "idAdReg": idAdReg.value,
            "majorId": tempMajors.filter(item => item.value == formData.value.majorForUmt2)[0]?.id,
            "adForm": 'UMT',
            "averageScore": (incentive + pScoreNew).toFixed(2),
            "objectInfo": {
              "priorityScoreNew": pScoreNew,
              "incentiveScore": incentive,
              "englishConvertedScore": 0
            },
            "priority": 2,
          }
          adMajors.value.push(temp)
        }
        if(formData.value.majorForUmt3 != "" && formData.value.majorForUmt3) {
          let temp = {
            "idAdReg": idAdReg.value,
            "majorId": tempMajors.filter(item => item.value == formData.value.majorForUmt3)[0]?.id,
            "adForm": 'UMT',
            "averageScore": (incentive + pScoreNew).toFixed(2),
            "objectInfo": {
              "priorityScoreNew": pScoreNew,
              "incentiveScore": incentive,
              "englishConvertedScore": 0
            },
            "priority": 3,
          }
          adMajors.value.push(temp)
        }
      }
      if(+formData.value.method == 5) {
        const priorities = [
          { industry: formData.value.admissionsIndustryTHPT, combo: formData.value.methosIndustryTHPT, p: 1 },
          { industry: formData.value.admissionsIndustryTHPT2, combo: formData.value.methosIndustryTHPT2, p: 2 },
          { industry: formData.value.admissionsIndustryTHPT3, combo: formData.value.methosIndustryTHPT3, p: 3 }
        ];
        adMajors.value = [];
        priorities.forEach(item => {
          if (item.industry) {
            let pt05Score = 0;
            let pScoreNew = 0;
            let incentive = certIncentiveResult.value.total;
            let engConverted = 0;

            if (formData.value.formOfMethodMethod5 === 'SAT') {
              pt05Score = +formData.value.sat ? ((+formData.value.sat * 30) / 1600) : 0;
              pScoreNew = cacuPointPriority(pt05Score + incentive);
            } else if (formData.value.formOfMethodMethod5 === 'ACT') {
              pt05Score = +formData.value.actScore ? ((+formData.value.actScore * 30) / 36) : 0;
              pScoreNew = cacuPointPriority(pt05Score + incentive);
            } else if (formData.value.formOfMethodMethod5 === 'TC01') {
              if (item.combo) {
                const res = getBestComboResult(item.combo, 5);
                pt05Score = res ? res.sum : (item.p == 1 ? GPAIndustryTHPT.value : (item.p == 2 ? GPAIndustryTHPT2.value : GPAIndustryTHPT3.value));
                pScoreNew = res ? res.priorityScoreNew : cacuPointPriority(pt05Score);
                incentive = res ? res.incentiveScore : 0;
                engConverted = res ? res.englishConvertedScore : 0;
              }
            }

            adMajors.value.push({
              "idAdReg": idAdReg.value,
              "majorId": tempMajors.find(m => m.value == item.industry)?.id,
              "adForm": item.combo || formData.value.formOfMethodMethod5,
              "averageScore": (pt05Score + incentive + pScoreNew).toFixed(2),
              "priorityScore": PScore.value,
              "admissionScore": pt05Score.toFixed(2),
              "objectInfo": {
                "priorityScoreNew": pScoreNew,
                "incentiveScore": incentive,
                "englishConvertedScore": engConverted
              },
              "priority": item.p,
            });
          }
        });
      }
      
      const certBonusData = {
        hasEnglishCert: formData.value.hasEnglishCert,
        englishCertType: formData.value.englishCertType,
        englishCertScore: formData.value.englishCertScore,
        toeicLRScore: formData.value.toeicLRScore,
        toeicSWScore: formData.value.toeicSWScore,
        englishCertDate: formData.value.englishCertDate,
        hasIncentiveOther: formData.value.hasIncentiveOther,
        mosWordScore: formData.value.mosWordScore,
        mosExcelScore: formData.value.mosExcelScore,
        mosPPTScore: formData.value.mosPPTScore,
        jlptLevel: formData.value.jlptLevel,
        hskLevel: formData.value.hskLevel,
        topikLevel: formData.value.topikLevel,
        delfTcfLevel: formData.value.delfTcfLevel,
        vstepLevel: formData.value.vstepLevel,
        aptisLevel: formData.value.aptisLevel,
        hasOtherCert: formData.value.hasOtherCert,
        otherIntCertType: (formData.value.hasIncentiveOther && formData.value.hasOtherCert) ? formData.value.otherIntCertType : null,
        otherIntCertScore: (formData.value.hasIncentiveOther && formData.value.hasOtherCert) ? formData.value.otherIntCertScore : null,
        englishCertConvertedScore: formData.value.hasEnglishCert ? +englishCertResult.value.convertedScore : 0,
        totalIncentiveBonus: certIncentiveResult.value.total,
        isUsedForConversion: false, // Calculated below
      };

      let isUsedForConversion = false;
      const firstCombo = formData.value.methosIndustryTHPT || formData.value.methosIndustry;
      if (firstCombo && formData.value.hasEnglishCert) {
        let item = arrIndustry.value.find((i: any) => i.code === firstCombo);
        if (item) {
          let subjects = (formData.value.method == 4 || formData.value.method == 1) ? item['subjectthpt'] : item['subjecthk2'];
          let prefix = formData.value.method == 5 ? 'pt05' : '';
          let actualEnglish = 0;
          let hasEnglish = false;
          let originalSum = 0;
          let check = false;
          if (Array.isArray(subjects)) {
            subjects.forEach((s: any) => {
              let fieldName = prefix ? prefix + s : s;
              if (s.toLowerCase().includes('english')) { hasEnglish = true; actualEnglish = +formData.value[fieldName] || 0; }
              if (formData.value[fieldName] || formData.value[fieldName] === 0) originalSum += +formData.value[fieldName]
              else check = true;
            });
          }
          if (!check && originalSum > 0 && hasEnglish) {
            const best = calculateBestTotal(originalSum, actualEnglish, true);
            isUsedForConversion = best.usedConversion;
          }
        }
      }
      certBonusData["isUsedForConversion"] = isUsedForConversion;
      let dataReg = {} as any
      if(props.fromProfile) {
        // status do card "Trạng thái hồ sơ" ở sidebar quản lý -> submit form KHÔNG gửi status (tránh ghi đè trạng thái đã đặt ở sidebar).
      }
      else {
        let dataTemp = {
          "source":formData.value.source,
          "createdAt":formData.value.createdAt,
          "phase":formData.value.phase,
          "isExtra":formData.value.source != 'online'?additionalPhase.value:undefined
        }
        dataReg = Object.assign(dataReg,dataTemp)
      }
      dataReg.certBonusData = certBonusData;
      
      if(props.isEdit) {
        let urlApi = '/admission'
        let dataApi: any = {
          "adMajors": adMajors.value,
          "idAdReg": props.dataAdm.adRegister.id,
          "certBonusData": certBonusData,
          "idStudent": props.dataAdm.adRegister.idStudent,
          "idAdMethod": formData.value.method
        }
        let isMethod5 = false;
        
        if(Object.keys(qdUmt).length !== 0) {
          dataApi.detail = qdUmt;
          urlApi = urlApi + '/qdumt2/' + props.dataAdm.adDetails[0]?.id;
        }
        else if(Object.keys(nlqlScore).length !== 0) {
          dataApi.detail = nlqlScore;
          urlApi = urlApi + '/nlqgscore2/' + props.dataAdm.adDetails[0]?.id;
        }
        else if(Object.keys(highSchoolScore).length !== 0) {
          dataApi.detail = highSchoolScore;
          urlApi = urlApi + '/highschoolscore2/' + props.dataAdm.adDetails[0]?.id;
        }
        else if(Object.keys(highSchoolGraduationScore).length !== 0) {
          dataApi.detail = highSchoolGraduationScore;
          urlApi = urlApi + '/highSchoolGraduationScore2/' + props.dataAdm.adDetails[0]?.id;
        }
        else if(Object.keys(equivalentDegreeData).length !== 0) {
          isMethod5 = true;
          dataApi.equivalentDegreeData = equivalentDegreeData;
          dataApi.isEdit = true;
          urlApi = '/admission/register/nexttouploadfile';
        }
        else if(+formData.value.method == 6) {
          isMethod5 = true; // Use the same flexible flow
          dataApi.vsat = vsatScore;
          dataApi.isEdit = true;
          urlApi = '/admission/register/nexttouploadfile';
        }
        
        const request = isMethod5 ? axios.post(urlApi, dataApi) : axios.put(urlApi, dataApi);
        
        await request.then( ( {data} ) => {
          generatePdf(props.dataAdm.adRegister.profileCode, props.dataAdm.adRegister.adCode)
          axios.put(`/admission/register/${props.dataAdm.adRegister.id}`, dataReg)
          if(props.fromProfile) {
            Swal.fire({
                text: "Lưu thành công" + (transcriptSyncInfo.value ? ` — ${transcriptSyncInfo.value}` : ""),
                icon: "success",
                timer: 2000,
                timerProgressBar: true,
                buttonsStyling: false,
                confirmButtonText: "Đóng",
                customClass: {
                    confirmButton: "btn btn-primary",
                },
            }).then(() => {
                //hideModal(addCustomerModalRef.value);
            });   
          }
          else if(!props.fromProfile) {
            const majors = isMethod5 ? data.majors : data.adMajors;
            let temp = {
              id: data.admissionRegister?.id || props.dataAdm.adRegister.id,
              date: moment(dataReg.createdAt.toString()).format('DD/MM/YYYY'),
              source: dataReg.source,
              phase: formData.value.phase,
              majors: majors?.map(i => {return {name:i.major?.name,priority:i.priority}}).sort((a, b) => {
                  if( a.priority !== undefined && b.priority !== undefined ) {
                      return a.priority > b.priority ? 1 : -1;
                  } else {
                      return a.priority !== undefined ? 1 : -1
                  }
              })
            }
            emit("updateData", temp);
            emit("closeModal");
          }
          
        })
        .catch((errors) => {
          console.log('err',errors)
          Swal.fire({
            text: errors?.response?.data?.errorMessage || errors?.response?.data?.message || errors?.data?.errorMessage || "Có lỗi trong quá trình thực hiện.",
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "Làm mới lại trang",
            customClass: {
                confirmButton: "btn btn-primary",
            },
          }).then(() => {
            location.reload()
          }); 
        });
      }
      else {
        let data = {
          "idAdMethod": formData.value.method,
          "idStudent": route.params.id ? route.params.id:props.idStudent,
          "highSchoolScore": highSchoolScore,
          "highSchoolGraduationScore": highSchoolGraduationScore,
          "nlqlScore": nlqlScore,
          "vsat": vsatScore,
          "qdUmt": qdUmt,
          "equivalentDegreeData": equivalentDegreeData,
          "adMajors": adMajors.value,
          "certBonusData": certBonusData,
          "source": formData.value.source,
          "createdAt":formData.value.createdAt,
          "phase": formData.value.phase,
          "isExtra": additionalPhase.value,
        }
        await axios.post('/admission',data)
        .then( ( {data} ) => {
          generatePdf(data.admissionRegister.profileCode,data.admissionRegister.adCode)
          let temp = {
            date: moment(data.admissionRegister.createdAt).format('DD/MM/YYYY'),
            code: data.admissionRegister.profileCode,
            adCode: data.admissionRegister.adCode,
            method: data.admissionRegister.adMethodName,
            id: data.admissionRegister.id,
            action: true,
            isActive: data.admissionRegister.isActive,
            source: data.admissionRegister.source,
            phase: data.admissionRegister.phase,
            status: {
                label: statusTag.value[data.admissionRegister.status]?.label,
                state: statusTag.value[data.admissionRegister.status]?.state,
                value: data.admissionRegister.status
            },
            majors: data.majors.map(i => {return {name:i.major.name,priority:i.priority}}).sort((a, b) => {
                if( a.priority !== undefined && b.priority !== undefined ) {
                    return a.priority > b.priority ? 1 : -1;
                } else {
                    return a.priority !== undefined ? 1 : -1
                }
            })
          }
         emit("updateData", temp);
         isAddFiles.value = true
         adCode.value = data.admissionRegister?.adCode
         idAdReg.value = data.admissionRegister?.id
         tableData.value = []
         // Sau khi tạo: mở popup "Cập nhật tệp đính kèm" để người dùng tải tệp lên ngay
         showUploadPopup.value = true
        })
        .catch(({ response }) => {
          console.log('err',response)
          Swal.fire({
            text: response?.data?.errorMessage || response?.data?.message || "Có lỗi trong quá trình thực hiện.",
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "Làm mới lại trang",
            customClass: {
                confirmButton: "btn btn-primary",
            },
          }).then(() => {
            location.reload()
          }); 
        });
      }
      
    }
    const additionalPhase = ref(false)
    // Danh sách field bắt buộc của mục "Xét tuyển liên thông" còn thiếu (cập nhật LIVE khi nhập + dùng lại lúc Lưu)
    const missingArpFields = computed(() => {
      const _arp: any = formData_arp.value || {}
      const _col: any = _arp.college || {}
      const miss: string[] = []
      if(!_arp.registeredmajor) miss.push('Ngành đăng ký')
      // Thông tin công việc (workplace/job/jobtitle) là optional -> không tính vào "Còn thiếu"
      if(!_col.graduationschool) miss.push('Trường tốt nghiệp')
      if(!_col.trainingform) miss.push('Hình thức đào tạo')
      if(!_col.graduationsys) miss.push('Hệ')
      if(!_col.gpafor) miss.push('Điểm trung bình (hệ điểm)')
      if(!_col.gpa) miss.push('Điểm')
      if(!_col.graduationnumber) miss.push('Số hiệu bằng tốt nghiệp')
      if(!_col.graduationentrynumber) miss.push('Số vào sổ TN')
      if(!_col.graduationyear) miss.push('Năm tốt nghiệp')
      if(!_col.graduationday) miss.push('Ngày cấp bằng')
      if(_arp.isintermediate) {
        const _int: any = _arp.intermediate || {}
        if(!_int.graduationschool) miss.push('Trung cấp: Trường tốt nghiệp')
        if(!_int.trainingform) miss.push('Trung cấp: Hình thức đào tạo')
        if(!_int.graduationsys) miss.push('Trung cấp: Hệ')
        if(!_int.graduationnumber) miss.push('Trung cấp: Số hiệu bằng tốt nghiệp')
        if(!_int.graduationentrynumber) miss.push('Trung cấp: Số vào sổ TN')
        if(!_int.graduationyear) miss.push('Trung cấp: Năm tốt nghiệp')
        if(!_int.graduationday) miss.push('Trung cấp: Ngày cấp bằng')
      }
      return miss
    })

    const submit = () => {
      // Chống double-click: bấm "Lưu hồ sơ" nhiều lần trước khi request xong -> tạo/lưu TRÙNG + nhiều popup.
      // loading khoá từ TRƯỚC validate (đồng bộ) nên cú bấm thứ 2 bị chặn ngay; reset khi xong/lỗi/validate-fail.
      if (loading.value) { return false }
      if(!isPermission.value) {
        emit("closeModal");
        return true
      }
      // Chặn lưu/hoàn tất khi còn tệp đính kèm đang tải lên (tệp tự upload ngay khi thêm)
      if (tableData.value && tableData.value.some(f => f && f.processing)) {
        Swal.fire({
          text: "Vui lòng đợi các tệp đính kèm tải lên xong rồi mới lưu.",
          icon: "warning",
          buttonsStyling: false,
          confirmButtonText: "Đã hiểu",
          customClass: { confirmButton: "btn btn-primary" },
        });
        return false;
      }
      if(isAddFiles.value) {
        // "Hoàn tất" = chỉ đóng modal (hồ sơ đã lưu ở bước trước, tệp tự lưu ngay).
        // PHẢI return — nếu không sẽ chạy tiếp validate+admissionSubmit → tạo TRÙNG hồ sơ.
        emit("closeModal")
        return false
      }
      if (!formRef.value) {
        return;
      }
      loading.value = true // khoá TỪ ĐÂY (trước validate async) -> cú bấm thứ 2 thấy loading=true và bị chặn
      formRef.value.validate(async (valid) => {
        if (valid) {
          // console.log('_arpros',_arpros.value)
          try {
            if(arpros.value) {
              // Cho-lưu-thiếu: KHÔNG chặn lưu khi thiếu trường bắt buộc liên thông —
              // banner umt-warn-banner trong form đã cảnh báo live danh sách trường thiếu.
              await articulationProgram()
            }
            else {
              await admissionSubmit()
            }
          } finally {
            loading.value = false // mở khoá khi lưu xong (thành công/lỗi)
          }
        } else {
          loading.value = false // validate thất bại -> mở khoá để user sửa rồi lưu lại
          return false;
        }
      });
    };
    const formatField = (value) => {
      let b = value
      if(b == "") {
        b = null
      }
      return b
    }
    const articulationProgram = async() => {
      let recordMajor = arrMajorsArticulation.value.find((i:any) => i.value == formData_arp.value.registeredmajor)
      let data: any = {
        student: {
          // Form LTĐHCQ KHÔNG còn sửa thông tin cá nhân -> chỉ gửi id để liên kết hồ sơ.
          // BE chỉ UPDATE theo các field có trong payload => KHÔNG ghi đè thông tin cá nhân (quản lý ở tab Thông tin cá nhân).
          // Tạo mới (articulationCreate) không có dataAdm -> lấy id từ prop idStudent.
          "id": props.dataAdm?.adRegister?.idStudent || props.idStudent,
        },

        // utmobj: utmobj,
        articulationprogram: {
          attachments: tableData.value,
          adregid: idAdReg.value?idAdReg.value: undefined,
          // Tạo mới -> KHÔNG có _arpros.id (optional chaining tránh crash null) -> BE tự tạo hồ sơ PT9.
          id: _arpros?.value?.id ? _arpros.value.id : undefined,
          ...formData_arp.value.college,
          gpa: formatField(formData_arp.value.college.gpa),
          graduationday: formatField(formData_arp.value.college.graduationday),
          registeredmajor: formData_arp.value.registeredmajor,
          registeredmajorName: recordMajor?.name,
          registeredmajorid: recordMajor?.id,
          admissionscores: {
            averageScore: formData_arp.value.college.gpafor == 'gpa10'?formData_arp.value.college.gpa : (formData_arp.value.college.gpa*10/4).toFixed(1),
          },
          intermediate: formData_arp.value.intermediate,
          isintermediate: formData_arp.value.isintermediate,
          job: formData_arp.value.job,
          jobtitle: formData_arp.value.jobtitle,
          workplace: formData_arp.value.workplace,
        },
        
        // skipcrmsync: true,
      }
     
      // console.log('data',data,)
      // console.log('formData.value',formData.value,)
      // popupLoading()
      await axios.post('/admission/student/articulationProgram',data)
      .then(( {data} ) => {
        //console.log('student',data)
        // Dựng dữ liệu cập nhật cho danh sách hồ sơ (trước đây chỉ closeModal -> danh sách KHÔNG refresh ngành vừa lưu)
        const _selMajor = arrMajorsArticulation.value.find((i:any) => i.value == formData_arp.value.registeredmajor)
        // TẠO MỚI liên thông: BE trả _adreg (đã có adCode) -> chuyển sang bước ĐÍNH KÈM
        // (giống admissionSubmit) để tệp upload đúng adReg vừa tạo, thay vì đóng luôn.
        const _adreg: any = data?._adreg
        if (props.articulationCreate && _adreg) {
          emit("updateData", {
            id: _adreg.id,
            code: _adreg.profileCode,
            adCode: _adreg.adCode,
            date: _adreg.createdAt ? moment(_adreg.createdAt.toString()).format('DD/MM/YYYY') : moment().format('DD/MM/YYYY'),
            source: _adreg.source,
            phase: _adreg.phase,
            majors: [{ name: _selMajor ? _selMajor.label : 'Chưa chọn', priority: 1 }],
          })
          isAddFiles.value = true
          adCode.value = _adreg.adCode
          idAdReg.value = _adreg.id
          tableData.value = []
          showUploadPopup.value = true
          Swal.fire({
            text: "Đã tạo hồ sơ liên thông. Tải tệp minh chứng rồi bấm Hoàn tất.",
            icon: "success", timer: 2500, timerProgressBar: true, buttonsStyling: false,
            confirmButtonText: "Đóng", customClass: { confirmButton: "btn btn-primary" },
          })
          return
        }
        const _reg: any = (props.dataAdm && props.dataAdm.adRegister) || {}
        const _updateTemp = {
          id: _reg.id || idAdReg.value,
          date: _reg.createdAt ? moment(_reg.createdAt.toString()).format('DD/MM/YYYY') : _reg.date,
          updatedAt: moment().format('DD/MM/YYYY'),
          source: _reg.source,
          phase: _reg.phase,
          majors: [{ name: _selMajor ? _selMajor.label : 'Chưa chọn', priority: 1 }],
        }
       Swal.fire({
          text: "Lưu thành công",
          icon: "success",
          timer: 2000,
          timerProgressBar: true,
          buttonsStyling: false,
          confirmButtonText: "Đóng",
          customClass: {
              confirmButton: "btn btn-primary",
          },
      }).then(() => {
        emit("updateData", _updateTemp);
        emit("closeModal");

          //hideModal(addCustomerModalRef.value);
      });

        // checkRegisterStudent()
        // if(formData.value.regScholarshipId && !checkRegScholarship.value && arr_registedScholarShip.value.length == 0) {
        //   regScholarshipFunc()
        // }
      })
      .catch(({ response }) => {
        console.log('err',response)
      });
    }
    const activatedRegisterChange = async (isActive,record) => {
      //let index = -1
      let data = {
        isActive: isActive
      }
      await axios.put(`/admission/register/${route.params.id}`, data)
      .then(( {data} ) => {
        // console.log('data',data)
      })
      .catch(({ response }) => {
        console.log('err',response)
      });
    }

    const findMath = (combo: string) => {
      let industry = arr_subject_THPT.value.find(i => i.value == combo); // Wait, this is for THPT subjects
      // Actually findMath in dangkytuyensinh.vue checks if 'english' is in the combination.
      let ind = arrIndustry.value.find(i => i.code == combo);
      return ind?.subjectthpt?.includes('englishTHPT') || ind?.subjecthk2?.includes('englishHKII') || false;
    }

    return {
      calculateBestTotal,
      cacuPointPriority,
      cacuTotalBonus,
      getComboExtraBonus,
      finalScoreWithCertBonus,
      certIncentiveResult,
      englishCertResult,
      findMath,
      formData,
      rules,
      additionalPhase,
      submit,
      formRef,
      studentTranscript,
      markScoreDirty,
      missingComboScores,
      transcriptMismatch,
      syncFromTranscript,
      hasDirtyScores,
      gradScoreDirty,
      studentGradScore,
      gradScoreMismatch,
      syncFromGradScore,
      writeFormScoresToGradScore,
      existingOnlineDraft,
      defaultPhaseId,
      writeFormScoresToTranscript,
      loading,
      userSelect,
      userSelectTHPT,
      arrMajors,
      arrMajorsArticulation,
      arrMajors2,
      arrMajors3,
      arrMajorsTHPT2,
      arrMajorsTHPT3,
      arrMajorsForAptitudeTest2,
      arrMajorsForAptitudeTest3,
      arrMajorsForUmt,
      arrMajorsForUmt2,
      arrMajorsForUmt3,
      isMaxGPA,
      isMaxGPA2,
      isMaxGPA3,
      GPAIndustry,
      GPAIndustry2,
      GPAIndustry3,
      maxGPAIndustry,
      isMaxGPATHPT,
      isMaxGPATHPT2,
      isMaxGPATHPT3,
      GPAIndustryTHPT,
      GPAIndustryTHPT2,
      GPAIndustryTHPT3,
      maxGPAIndustryTHPT,
      arrGPAIndustryTHPT,
      PScore,
      arrGPAIndustry,
      arrIndustry,
      textFile,
      resetDataForm,
      idAdReg,
      adCode,
      fizeSize,
      tableData,
      kt_customer_view_files_profile,
      kt_customer_view_method,
      isAddFiles,
      showUploadPopup,
      fileTypes,
      arrResource,
      Permission,
      checkPermission,
      isPermission,
      profileBackTo,
      activatedRegisterChange,
      checkHighschoolGraduation,
      comment_profile,
      tabFile,
      subjectpoint,
      formOptions,
      renderTitleSubject,
      slotTypeMismatch,
      transcriptCanFill,
      comboBetterSuggestion,
      applyBestCombo,
      renderSubject,
      formData_arp,
      arpros,
      missingArpFields,
      dataCustomer,
      dataResidenceProvince,
      dataResidenceDistrict,
      dataResidenceWard,
      dataProvince,
      dataDistrict,
      dataWard,
      getDistrict,
      getWard,
      calculatedAvgGrade12,
      arrMethosIndustryTHPT,
      arrMethosIndustryTHPT2,
      arrMethosIndustryTHPT3,
      handleHasEnglishCertChange,
      handleHasIncentiveOtherChange,
      methosIndustryManualChangeTHPT,
      methosIndustryAutoChangeTHPT,
      admissionsIndustryChangeTHPT,
      admissionsIndustryChangeTHPT2,
      admissionsIndustryChangeTHPT3,
      methosIndustryManualChange,
      methosIndustryAutoChange,
      admissionsIndustryChange,
      admissionsIndustryChange2,
      admissionsIndustryChange3,
      getIncentiveForDisplay,
      getPriorityForDisplay,
      getGPAForDisplay,
      getTotalForDisplay,
      getConversionUsedForDisplay,
      getEnglishConvertedScoreForDisplay,
      isPriorityReducedForDisplay,
      comboHasEnglish,
      GPAIndustryDGNL_HN,
      totalScoreDGNL_HN,
      GPAIndustryDGNL,
      totalScoreDGNL,
    };
  },
});
